import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    agregarFC_01Solicitud,
    setCambiosFC_01SolicitudBorrador,
    setCambiosFC_01SolicitudNueva,
    agregarFC_01SolicitudBorrador,
    resetDataFC_01, actualizarFC_01Estatus,
    guardarCambiosFC_01Borrador,
    eliminarFC_01AnexoPersonasAutBD,
    eliminarFC_01AnexoMarcasBD,
    eliminarFC_01Anexos,
    setModoBorrador,
    setModoCorreccion,
    editarFC_01AnexoPersonasAutBeneficiario,
    editarFC_01AnexoMarcasBeneficiario,
    agregarFC_01AnexoPersonasAutBeneficiario,
    agregarFC_01AnexoPersonaAutBeneficiario,
    agregarFC_01AnexoMarcasBeneficiario,
    agregarFC_01AnexoMarcaBeneficiario,
    enviarCorreccionesFC_01,
    agregarFC_01AnexoMediosDeContactoBeneficiario,
    editarFC_01AnexoMediosDeContactoBeneficiario,
    agregarFC_01AnexoRepresentanteLegalBeneficiario,
    editarFC_01AnexoRepresentantesLegales,
    eliminarFC_01AnexoRepresentanteLegal,
    agregarFC_01AnexoRepresentanteLegalBenefi,
    agregarFC_01ActividadesEmpresa,
    obtenerContador,
    agregarFC_01DomicilioFiscal,
    agregarFC_01AnexosFiles,
    agregarFC_01AnexoMarcaProductosConMezcalBeneficiario,
    agregarFC_01AnexoMarcasProductoConMezcalBeneficiario,
    editarFC_01AnexoMarcasProductoConMezcalBeneficiario,
    actualizarFC_01PaginaActiva,
    obtenerContadorDeFechaFolio,
    agregarFC_01AnexosFilesApoderadosLeg,
    agregarFC_01AnexosFilesPersonasAut,
    agregarFC_01AnexosFilesPredios,
    agregarFC_01AnexosFilesViveros,
    agregarFC_01AnexosFilesMarcas,
    agregarFC_01AnexosFilesMarcaProduct,
    agregarFC_01AnexosFilesInstalaciones,
    agregarFC_01OpcionesFilesPredios,
    agregarFC_01OpcionesFilesViveros,
    agregarFC_01OpcionesFilesInstalacion,
    generarSolicitudEnPDF,
    actualizarCalleFc_01,
    obtenerNumeroDeSolicitudesFC_01
} from '../../../redux/DucksBeneficiario/FC_01Ducks'

import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks'
import { Typography } from '@mui/material';
import ToolBarPaginas from '../../App/ToolBarPaginas';
import IconButton from '@mui/material/IconButton';
import { useStateIfMounted } from 'use-state-if-mounted'
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import TablaAnexos from './TablaAnexos';
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faCannabis, faClover, faHandSpock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faBoxOpen, faDumpsterFire,
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faCannabis, faClover, faHandSpock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faBoxOpen, faDumpsterFire)

import estilos from './FormularioFC01BeneficiarioComponent.module.css';
import TelefonoYCorreo from '../../App/TelefonoYCorreo';
import PredioComponent from '../../App/PredioComponent';
import ProductorComponent from '../../App/ProductorComponent';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import ArchivosMarcaComponent from '../../ArchivosComponents/ArchivosMarcaComponent';
import ArchivosInstalaciones from '../../ArchivosComponents/ArchivosInstalaciones';
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';

import Collapsible from 'react-collapsible';
import { useForm } from 'react-hook-form'
import Tooltip, { tooltipClasses, TooltipClasses } from '@mui/material/Tooltip';

import ModalComponent from '../../App/ModalComponent'

const { useState, useEffect, useRef } = React;
import { Formik } from 'formik'
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import ArchivosPrediosViveros from '../../ArchivosComponents/ArchivosPrediosViveros';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import BotonDescargarSolicitudComponent from '../../App/BotonDescargarSolicitudComponent';
import { obtenerColoniasPorCpApi, obtenerCPsPorMunicipioApi, obtenerEstadosApi, obtenerLocalidadesPorEstadoYMunicipioApi, obtenerCallesPorClavesEstadoMunicipioLocalidad, obtenerEstadosConClaveApi, obtenerMunicipiosConClavePorEstadoApi } from '../../../redux/DucksApis/CopomexDucks';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import { styled } from '@mui/system';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import DocumentacionFC_01Component from './DocumentacionFC_01Component';

//PARA PERSONA MORAL
const _rfc_pattern_pm = "^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
    "(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
    "(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
    "(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";

//PARA PERSONA FISICA
const _rfc_pattern_pf = "^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
    "(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
    "(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
    "(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black',
};

const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 500,
        textAlign: 'justify',
    },
});


function FormularioFC01BeneficiarioComponent(props) {
    // let valoresIniciales = {
    //     rfc: '',
    // }
    const [functionSetValues, setFunctionSetValues] = useStateIfMounted()
    const [valuesFormik, setValuesFormik] = useStateIfMounted({})

    const [valoresIniciales, setValoresIniciales] = useStateIfMounted(
        {
            actualizacioninformacion: false,
            asociado: false,
            calle: "",
            certificadonomcomercializador: false,
            certificadonomenvasador: false,
            certificadonomproductor: false,
            codigopostal: "",
            colonia: "",
            comercializadorbebidasconmezcal: false,
            comercializadormezcal: false,
            constanciacomercializador: false,
            correoelectronicorepresentante: "",
            dictameninstalaciones: false,
            dictameninstalacionesbodega: false,
            dictameninstalacionesenvasadora: false,
            dictameninstalacionesfabrica: false,
            discapacidadno: false,
            discapacidadsi: false,
            envasador: false,
            escolaridad: "",
            estado: "",
            estadocivil: "",
            fechadenacimiento: fechaParaMayorEdad,
            fechasolicitud: fechaHoy,
            inscrito: false,
            lenguaindijenano: false,
            lenguaindijenasi: false,
            localidad: "",
            municipioalcaldia: "",
            noasociado: false,
            nombrerazonsocial: "",
            numeroexterior: "",
            numerohijos: "",
            numerointerior: "",
            ocupacion: "",
            personafisica: false,
            personamoral: false,
            productormaguey: false,
            productormezcal: false,
            representantelegal: "",
            rfc: "",
            sexo: "",
            telefonorepresentante: "",
            tipodiscapacidad: "",
            tipolengua: "",
            viverista: false,
            personaautorizadasi: false,
            personaautorizadano: false,
            representantelegalsi: false,
            representantelegalno: false,
            numerosocio: "",
            telefono: "",
            correoelectronico: "",
            terminosYCondiciones: false,
            certificacionsi: false,
            certificacionno: false,
            empresacertificadora: "",
            numerohombres: '',
            numeromujeres: '',
            numerodiscapacitados: '',
            numerobase: '',
            numeroeventuales: '',
            opcionTipoInscripcion: '',
            opcionTipoInscrito: '',
            opcionTipoEmpresa: '',
            otracalle: '',
            passwordnomno: false,
            passwordnomsi: false,
            comprobantepago: false,
            comprobantepagotext: '',
        }
    )

    // let botonEnviarRegistro = false
    const [botonEnviarRegistro, setBotonEnviarRegistro] = React.useState(false)
    const [botonEnviarBorrador, setBotonEnviarBorrador] = React.useState(false)
    // let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)

    const [valores, setValores] = useStateIfMounted({})
    const valoresInicialesRef = useRef(valores)



    const [files, setFile] = React.useState([])
    const filesRef = React.useRef(files)
    const [filesPredios, setFilePredios] = React.useState([])
    const filesPrediosRef = React.useRef(filesPredios)
    const [filesViveros, setFileViveros] = React.useState([])
    const filesViverosRef = React.useRef(filesViveros)
    const [filesApoderadosLeg, setFileApoderadosLeg] = React.useState([])
    const filesApoderadosLegRef = React.useRef(filesApoderadosLeg)
    const [filesPersonasAut, setFilePersonasAut] = React.useState([])
    const filesPersonasAutRef = React.useRef(filesPersonasAut)
    const [filesMarcas, setFileMarcas] = React.useState([])
    const filesMarcasRef = React.useRef(filesMarcas)
    const [filesMarcasProduct, setFileMarcasProduct] = React.useState([])
    const filesMarcasProductRef = React.useRef(filesMarcasProduct)
    const [filesInstalaciones, setFileInstalaciones] = React.useState([])
    const filesInstalacionesRef = React.useRef(filesInstalaciones)
    const [opcionFilePredio, setOpcionFilePredio] = React.useState([])
    const opcionFilePredioRef = React.useRef(opcionFilePredio)
    const [opcionFileVivero, setOpcionFileVivero] = React.useState([])
    const opcionFileViveroRef = React.useRef(opcionFileVivero)
    const [opcionFileInstalacion, setOpcionFileInstalacion] = React.useState([])
    const opcionFileInstalacionRef = React.useRef(opcionFileInstalacion)
    /*STATES PARA VALIDACIÓN DE RFC */

    const [isRFCValid, setIsRFCValid] = useState(false);
    const [validadorRFC, setValidadorRFC] = useState('');

    const validarRFC = (event, inputField) => {

        const rfc = event.target.value;
        comprobarRFC(rfc, inputField);

    };

    function comprobarRFC(rfc, inputField, aceptarGenerico = true) {
        let rfcAux = rfc.toUpperCase();
        if (rfcValido(rfcAux)) {
            if (rfcValido2(rfcAux)) {
                setIsRFCValid(true)
                setValidadorRFC('RFC válido');
            }
            else {
                setIsRFCValid(false)
                setValidadorRFC('El RFC está mal construido. Revisa su estructura')
            }
        }
        else {
            setIsRFCValid(false)
            setValidadorRFC('El RFC está mal construido. Revisa su estructura')
        }

    }


    function rfcValido2(rfc, aceptarGenerico = true) {
        const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
        var validado = rfc.match(re);

        if (!validado)  //Coincide con el formato general del regex?
            return false;

        //Separar el dígito verificador del resto del RFC
        const digitoVerificador = validado.pop(),
            rfcSinDigito = validado.slice(1).join(''),
            len = rfcSinDigito.length,

            //Obtener el digito esperado
            diccionario = "0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ",
            indice = len + 1;
        var suma,
            digitoEsperado;

        if (len == 12) suma = 0
        else suma = 481; //Ajuste para persona moral

        for (var i = 0; i < len; i++)
            suma += diccionario.indexOf(rfcSinDigito.charAt(i)) * (indice - i);
        digitoEsperado = 11 - suma % 11;
        if (digitoEsperado == 11) digitoEsperado = 0;
        else if (digitoEsperado == 10) digitoEsperado = "A";

        //El dígito verificador coincide con el esperado?
        // o es un RFC Genérico (ventas a público general)?
        if ((digitoVerificador != digitoEsperado)
            && (!aceptarGenerico || rfcSinDigito + digitoVerificador != "XAXX010101000"))
            return false;
        else if (!aceptarGenerico && rfcSinDigito + digitoVerificador == "XEXX010101000")
            return false;
        return rfcSinDigito + digitoVerificador;
    }

    function rfcValido(rfc, aceptarGenerico = true) {
        return rfc.match(_rfc_pattern_pm) || rfc.match(_rfc_pattern_pf);
    }

    const { register, handleSubmit, formState: { errors } } = useForm();

    /******REDUX */
    const dispatch = useDispatch()

    const currentUser = useSelector(store => store.Usuario.data)
    let fc_01Map = useSelector(store => store.FC_01Solicitud.fc_01Map)
    const personasAutorizadasMap = useSelector(store => store.FC_01Solicitud.personasAutorizadasMap)
    const representantesLegalesMap = useSelector(store => store.FC_01Solicitud.representantesLegalesMap)
    const prediosMap = useSelector(store => store.FC_01Solicitud.predioMap)
    const productorMap = useSelector(store => store.FC_01Solicitud.productorMap)
    const marcasDeMezcalMap = useSelector(store => store.FC_01Solicitud.anexoMarcaDeMezcalMap)
    const marcasConProductosMap = useSelector(store => store.FC_01Solicitud.anexoMarcaConProductoMap)

    const anexoInstalaciones = useSelector(store => store.FC_01Solicitud.instalaciones)
    const anexoUnidadEnvasado = useSelector(store => store.FC_01Solicitud.anexoUnidadEnvasado)
    const anexoUnidadProduccion = useSelector(store => store.FC_01Solicitud.anexoUnidadProduccion)
    const anexoUnidadAlmacen = useSelector(store => store.FC_01Solicitud.anexoUnidadAlmacen)
    const representantesLegalesFC_01 = useSelector(store => store.FC_01Solicitud.representantesLegales)
    const mediosDeContactoFC_01 = useSelector(store => store.FC_01Solicitud.mediosDeContacto)
    const marcasFC_01 = useSelector(store => store.FC_01Solicitud.marcas)
    const marcasProductosConMezcalFC_01 = useSelector(store => store.FC_01Solicitud.marcasProductosConMezcal)
    const personasAutorizadasFC_01 = useSelector(store => store.FC_01Solicitud.personasAutorizadas)

    const prediosFC_01 = useSelector(store => store.FC_01Solicitud.predios)
    const documentacionFC_01Map = useSelector(store => store.FC_01Solicitud.documentacionFC_01Map)
    const documentacionRepresentanteLegalMap = useSelector(store => store.FC_01Solicitud.documentacionRepresentanteLegalMap)
    const documentacionPersonaAutorizadaMap = useSelector(store => store.FC_01Solicitud.documentacionPersonaAutorizadaMap)
    const documentacionPredioMap = useSelector(store => store.FC_01Solicitud.documentacionPredioMap)
    const documentacionViveroMap = useSelector(store => store.FC_01Solicitud.documentacionViveroMap)
    const documentacionMarcaMap = useSelector(store => store.FC_01Solicitud.documentacionMarcaMap)
    const documentacionMarcaProductoMap = useSelector(store => store.FC_01Solicitud.documentacionMarcaProductoMap)
    const documentacionInstalacionMap = useSelector(store => store.FC_01Solicitud.documentacionInstalacionMap)
    const documentacionResponsableMap = useSelector(store => store.FC_01Solicitud.documentacionResponsableMap)

    const observacionesApartados = useSelector(store => store.FC_01Solicitud.observacionesApartados)

    const productorFC_01 = useSelector(store => store.FC_01Solicitud.productor)

    const filesFC_01 = useSelector(store => store.FC_01Solicitud.files)
    const filesApoderadosLegFC_01 = useSelector(store => store.FC_01Solicitud.filesApoderadosLeg)
    const filesPersonasAutFC_01 = useSelector(store => store.FC_01Solicitud.filesPersonasAut)
    const filesMarcasFC_01 = useSelector(store => store.FC_01Solicitud.filesMarcas)
    const filesMarcasProductFC_01 = useSelector(store => store.FC_01Solicitud.filesMarcasProduct)
    const filesInstalacionesFC_01 = useSelector(store => store.FC_01Solicitud.filesInstalaciones)
    const filesPrediosFC_01 = useSelector(store => store.FC_01Solicitud.filesPredios)
    const filesViverosFC_01 = useSelector(store => store.FC_01Solicitud.filesViveros)

    //
    const opcionesFilesPrediosFC_01 = useSelector(store => store.FC_01Solicitud.opcionesFilesPredios)
    const opcionesFilesViverosFC_01 = useSelector(store => store.FC_01Solicitud.opcionesFilesViveros)
    const opcionesFilesInstalacionesFC_01 = useSelector(store => store.FC_01Solicitud.opcionesFilesInstalaciones)

    let data = useSelector(store => store.FC_01Solicitud.data)
    let fc_01 = useSelector(store => store.FC_01Solicitud.fc_01)
    // if (fc_01.inscrito & fc_01.asociado){fc_01.opcionTipoInscrito='asociado'} 
    // if (fc_01.inscrito & fc_01.noasociado){fc_01.opcionTipoInscrito='noasociado'}

    const paginaActiva = useSelector(store => store.FC_01Solicitud.paginaActiva)
    const modoEdicionBorrador = useSelector(store => store.FC_01Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_01Solicitud.modoCorreccion)


    const borrador = useSelector(store => store.FC_01Solicitud.borrador)

    /*COPOMEX API*/
    const estadosApi = useSelector(store => store.CopomexApi.estados)
    const municipiosApi = useSelector(store => store.CopomexApi.municipios)
    const codigosPostalesApi = useSelector(store => store.CopomexApi.codigosPostales)
    const coloniasApi = useSelector(store => store.CopomexApi.colonias)
    const localidadesApi = useSelector(store => store.CopomexApi.localidades)
    const callesApi = useSelector(store => store.CopomexApi.calles)


    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    const terminosYCondicionesRef = useRef(terminosYCondiciones)

    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])


    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [mostrarMensajeInscripcion, setMostrarMensajeInscripcion] = React.useState(false)
    const resetValores = (objectProducto) => {
        //setProductos(prev => [...prev, objectProducto])
        setvalidacion(objectProducto.validacion)
    }
    const paginaSiguiente = async (valores) => {
        const avanzar = evaluarPagina(valores)
        let validacionMarcas = botonValidarMarcas(marcas, marcasProductoConMezcal)
        let validacionMedios = botonValidarDatosGenerales(mediosDeContacto, representantesLegales, personasAutorizadas)
        let validacionPredios = botonValidarPredios(predios, productor)

        let numProduccion = 0
        let numEnvasado = 0
        for (const anexo of anexoInstalaciones) {
            if (anexo.data.tipoInstalacion === 'Unidad Producción') numProduccion++
            if (anexo.data.tipoInstalacion === 'Unidad Envasado') numEnvasado++
        }

        if (validacionMarcas == true && nombresParaPaginas[paginaActiva - 1] === 'Marcas') {
            setvalidacion(true)
            settexto('de sus marcas')
        } else {
            if (validacionPredios == true && (nombresParaPaginas[paginaActiva - 1] === 'Viverista' ||
                nombresParaPaginas[paginaActiva - 1] === 'Productor de maguey' ||
                nombresParaPaginas[paginaActiva - 1] === 'Viverista/Productor de maguey')) {
                setvalidacion(true)
                settexto(' de sus predios')
            } else {
                if (validacionMedios == true && nombresParaPaginas[paginaActiva - 1] === 'Datos generales') {
                    setvalidacion(true)
                    settexto('de sus datos generales')
                } else {
                    if (nombresParaPaginas[paginaActiva - 1] === 'Instalaciones' && valores.productormezcal && numProduccion === 0) {
                        setvalidacion(true)
                        settexto('o al menos una unidad de producción')
                    } else {
                        if (nombresParaPaginas[paginaActiva - 1] === 'Instalaciones' && valores.envasador && numEnvasado === 0) {
                            setvalidacion(true)
                            settexto('o al menos una unidad de envasado')
                        } else if (!avanzar) {
                            setvalidacion(true)
                            settexto('')
                        } else {
                            if (avanzar) {
                                dispatch(actualizarFC_01PaginaActiva(paginaActiva + 1))
                            }
                        }
                    }
                }
            }
        }
    }
    const paginaAnterior = async () => {

        dispatch(actualizarFC_01PaginaActiva(paginaActiva - 1))

    }

    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }




    /*******STATE */
    //let paginas = [1, 2, 3]
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3])
    //const nombresParaPaginas = ['Datos generales', 'Domicilio fiscal', 'Viverista/Productor de maguey', 'Instalaciones', 'Marcas', 'Documentación']
    //    let nombresParaPaginas = ['Datos generales', 'Domicilio fiscal', 'Documentación']
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Domicilio fiscal', 'Documentación'])
    var fechaHoy = moment().format('YYYY-MM-DD')
    var fechaResta = moment().subtract(18, "y");
    var fechaParaMayorEdad = fechaResta.format('YYYY-MM-DD')
    let contadorFolio = useSelector(store => store.FC_01Solicitud.contadorDeFechaFolio)
    const [folio, setFolio] = useStateIfMounted('')

    React.useEffect(() => {
        var año = moment().format('YY');
        let year = String(año)
        dispatch(obtenerContadorDeFechaFolio(year))
    }, [])
    React.useEffect(async () => {
        if (modoCorreccion === false && modoEdicionBorrador === false) {
            let idUsuario = currentUser.user[0].id
            const contadorFC_01 = await dispatch(obtenerNumeroDeSolicitudesFC_01(idUsuario))

            if (contadorFC_01.payload > 0) {
                props.history.push('/solicitudes')
            }
        }

    }, [])

    const [filePreRegMaguey, setPM] = useStateIfMounted('')
    const [fileIOVLegal, setIOVLegal] = useStateIfMounted('')
    const [fileACN, setACN] = useStateIfMounted('')
    const [filePNRL, setPNRL] = useStateIfMounted('')
    const [filePropiedadM, setPropiedadM] = useStateIfMounted('')
    const [fileIOVAutorizada, setIOVAutorizada] = useStateIfMounted('')
    const [fileRFC, setRFC] = useStateIfMounted('')
    const [fileCDF, setCDF] = useStateIfMounted('')
    const [fileIOVResponsable, setIOVResponsable] = useStateIfMounted('')
    const [fileCTPInstalaciones, setCTPInstalaciones] = useStateIfMounted('')
    const [fileCCArrendamiento, setCCArrendamiento] = useStateIfMounted('')
    const [fileCCComodato, setCCComodato] = useStateIfMounted('')
    const [fileCTMarca, setCTMarca] = useStateIfMounted('')
    const [fileCRPTramite, setCRPTramite] = useStateIfMounted('')
    const [fileLUCesion, setLUCesion] = useStateIfMounted('')
    const [fileTituloMarca, setTituloMarca] = useStateIfMounted('')
    const [fileJE, setJE] = useStateIfMounted('')
    const [fileCC, setCC] = useStateIfMounted('')
    const [fileCM, setCM] = useStateIfMounted('')
    const [fileCPago, setCPago] = useStateIfMounted('')
    const [fileCCExp, setCCExp] = useStateIfMounted('')

    let ifFileCCExp = true
    let ifFilePreRegMaguey = true
    let ifFileIOVLegal = true
    let ifFileACN = true
    let ifFilePNRL = true
    let ifFilePropiedadM = true
    let ifFileIOVAutorizada = true
    let ifFileRFC = true
    let ifFileCDF = true
    let ifFileIOVResponsable = true
    let ifFileCTPInstalaciones = true
    let ifFileCCArrendamiento = true
    let ifFileCCComodato = true
    let ifFileCTMarca = true
    let ifFileCRPTramite = true
    let ifFileLUCesion = true
    let ifFileTituloMarca = true
    let ifFileJE = true
    let ifFileCC = true
    let ifFileCM = true
    let ifFileCPago = true

    const [personafisica, setFisica] = useStateIfMounted(false)
    const personafisicaRef = useRef(personafisica)
    const [personamoral, setMoral] = useStateIfMounted(false)
    const personamoralRef = useRef(personamoral)
    const [noasociado, setNoAsociado] = useStateIfMounted(false)
    const noasociadoRef = useRef(noasociado)
    const [asociado, setAsociado] = useStateIfMounted(false)
    const asociadoRef = useRef(asociado)
    const [inscrito, setInscrito] = useStateIfMounted(false)
    const inscritoRef = useRef(inscrito)
    const [dictameninstalaciones, setDictamenInstalaciones] = useStateIfMounted(false)
    const dictameninstalacionesRef = useRef(dictameninstalaciones)

    const [dictameninstalacionesfabrica, setInstalacionesFabrica] = useStateIfMounted(false)
    const dictameninstalacionesfabricaRef = useRef(dictameninstalacionesfabrica)
    const [dictameninstalacionesenvasadora, setInstalacionesEnvasadora] = useStateIfMounted(false)
    const dictameninstalacionesenvasadoraRef = useRef(dictameninstalacionesenvasadora)
    const [dictameninstalacionesbodega, setInstalacionesBodega] = useStateIfMounted(false)
    const dictameninstalacionesbodegaRef = useRef(dictameninstalacionesbodega)

    const [constanciacomercializador, setConstanciaComercializador] = useStateIfMounted(false)
    const constanciacomercializadorRef = useRef(constanciacomercializador)
    const [actualizacioninformacion, setActualizacionInformacion] = useStateIfMounted(false)
    const actualizacioninformacionRef = useRef(actualizacioninformacion)
    const [certificadonomproductor, setNomProductor] = useStateIfMounted(false)
    const certificadonomproductorRef = useRef(certificadonomproductor)
    const [certificadonomenvasador, setNomEnvasador] = useStateIfMounted(false)
    const certificadonomenvasadorRef = useRef(certificadonomenvasador)
    const [certificadonomcomercializador, setNomComercializador] = useStateIfMounted(false)
    const certificadonomcomercializadorRef = useRef(certificadonomcomercializador)
    const [nombrerazonsocial, setNombreRazon] = useStateIfMounted('')
    const nombrerazonsocialRef = useRef(nombrerazonsocial)
    let [fechasolicitud, setFechaSolicitud] = useStateIfMounted(fechaHoy)
    const fechasolicitudRef = useRef(fechasolicitud)
    const [calle, setCallle] = useStateIfMounted('')
    const calleRef = useRef(calle)
    let [numeroexterior, setNumExterior] = useStateIfMounted('')
    const numeroexteriorRef = useRef(numeroexterior)
    let [numerointerior, setNumInterior] = useStateIfMounted('')
    const numerointeriorRef = useRef(numerointerior)
    const [colonia, setColonia] = useStateIfMounted('')
    const coloniaRef = useRef(colonia)
    const [localidad, setLocalidad] = useStateIfMounted('')
    const localidadRef = useRef(localidad)
    const [municipioalcaldia, setMunicipioAlcaldia] = useStateIfMounted('')
    const municipioalcaldiaRef = useRef(municipioalcaldia)
    const [estado, setEstado] = useStateIfMounted('')
    const estadoRef = useRef(estado)
    let [codigopostal, setCp] = useStateIfMounted()
    const codigopostalRef = useRef(codigopostal)
    const [rfc, setRfc] = useStateIfMounted('')
    const rfcRef = useRef(rfc)
    const [representantelegal, setNombreLegal] = useStateIfMounted('')
    const representantelegalRef = useRef(representantelegal)
    let [telefonorepresentante, setTelefonoLegal] = useStateIfMounted('')
    const telefonorepresentanterRef = useRef(telefonorepresentante)
    const [correoelectronicorepresentante, setCorreoLegal] = useStateIfMounted('')
    const correoelectronicorepresentanteRef = useRef(correoelectronicorepresentante)
    let [telefonopersona, setTelefonoAutorizado] = useStateIfMounted('')


    let [telefono, setTelefono] = useStateIfMounted('')
    const telefonoRef = useRef(telefono)
    const [correoelectronico, setCorreoElectronico] = useStateIfMounted('')
    const correoelectronicoRef = useRef(correoelectronico)


    const [viverista, setViverista] = useStateIfMounted(false)
    const viveristaRef = useRef(viverista)
    const [productormaguey, setPoroductorMaguey] = useStateIfMounted(false)
    const productormagueyRef = useRef(productormaguey)
    const [productormezcal, setProductorMezcal] = useStateIfMounted(false)
    const productormezcalRef = useRef(productormezcal)
    const [envasador, setEnvasador] = useStateIfMounted(false)
    const envasadorRef = useRef(envasador)
    const [comercializadormezcal, setComercializadorMezcal] = useStateIfMounted(false)
    const comercializadormezcalRef = useRef(comercializadormezcal)
    const [comercializadorbebidasconmezcal, setComercializadorBebidas] = useStateIfMounted(false)
    const comercializadorbebidasconmezcalRef = useRef(comercializadorbebidasconmezcal)

    React.useEffect(() => {
        if (comercializadormezcal || comercializadorbebidasconmezcal) {
            setpasswordnomsi(true)
            setpasswordnomno(false)
        }
    }, [comercializadormezcal, comercializadorbebidasconmezcal])

    let [fechadenacimiento, setFechaNacimientoPersona] = useStateIfMounted(fechaParaMayorEdad)
    let fechadenacimientoRef = useRef(fechadenacimiento)
    const [sexo, setSexoPersona] = useStateIfMounted('')
    const sexoRef = useRef(sexo)
    const [estadocivil, setEstadoCivilPersona] = useStateIfMounted('')
    const estadocivilRef = useRef(estadocivil)
    const [escolaridad, setEscolaridadPersona] = useStateIfMounted('')
    const escolaridadRef = useRef(escolaridad)
    const [discapacidadsi, setDiscapacidadSi] = useStateIfMounted(false)
    const discapacidadsiRef = useRef(discapacidadsi)
    const [discapacidadno, setDiscapacidadNo] = useStateIfMounted(false)
    const discapacidadnoRef = useRef(discapacidadno)
    const [tipodiscapacidad, setTipoDiscapacidad] = useStateIfMounted('')
    const tipodiscapacidadRef = useRef(tipodiscapacidad)
    const [lenguaindijenasi, setLenguaSi] = useStateIfMounted(false)
    const lenguaindijenasiRef = useRef(lenguaindijenasi)
    const [lenguaindijenano, setLenguaNo] = useStateIfMounted(false)
    const lenguaindijenanoRef = useRef(lenguaindijenano)
    const [tipolengua, setTipoLengua] = useStateIfMounted('')
    const tipolenguaRef = useRef(tipolengua)
    const [ocupacion, setOcupacionPersona] = useStateIfMounted(' ')
    const ocupacionRef = useRef(ocupacion)
    let [numerohijos, setNumeroHijos] = useStateIfMounted(0)
    const numerohijosRef = useRef(numerohijos)

    const [numerohombres, setNumeroHombres] = useStateIfMounted()
    const [numeromujeres, setNumeroMujeres] = useStateIfMounted()
    const [numerodiscapacitados, setNumeroDiscapacitados] = useStateIfMounted()
    const [numerobase, setNumeroBase] = useStateIfMounted()
    const [numeroeventuales, setNumeroEventuales] = useStateIfMounted()

    const [representantelegalsi, setAgregarRepresentanteLegalSi] = useStateIfMounted(false)
    const representantelegalsiRef = useRef(representantelegalsi)
    const [representantelegalno, setAgregarRepresentanteLegalNo] = useStateIfMounted(false)
    const representantelegalnoRef = useRef(representantelegalno)

    const [passwordnomsi, setpasswordnomsi] = useStateIfMounted(false)
    const passwordnomsiRef = useRef(passwordnomsi)
    const [passwordnomno, setpasswordnomno] = useStateIfMounted(false)
    const passwordnomnoRef = useRef(passwordnomno)

    const [comprobantepago, setcomprobantepago] = useStateIfMounted(false)
    const comprobantepagoRef = useRef(comprobantepago)
    const [comprobantepagotext, setcomprobantepagotext] = useStateIfMounted(false)
    const comprobantepagotextRef = useRef(comprobantepagotext)

    const [mediosdecontactosi, setAgregarMediosDeContactoSi] = useStateIfMounted(false)
    const mediosdecontactosiRef = useRef(mediosdecontactosi)
    const [mediosdecontactono, setAgregarMediosDeContactoNo] = useStateIfMounted(false)
    const mediosdecontactonoRef = useRef(mediosdecontactono)

    const [personaautorizadasi, setAgregarPersonaAutorizadaSi] = useStateIfMounted(false)
    const personaautorizadasiRef = useRef(personaautorizadasi)
    const [personaautorizadano, setAgregarPersonaAutorizadaNo] = useStateIfMounted(false)
    const personaautorizadanoRef = useRef(personaautorizadano)

    const [marcas, setmarcas] = useStateIfMounted([]);
    const marcasRef = useRef(marcas)
    const [marcasProductoConMezcal, setmarcasProductoConMezcal] = useStateIfMounted([]);
    const marcasProductoConMezcalRef = useRef(marcasProductoConMezcal)

    const [personasAutorizadas, setPersonasAutorizadas] = React.useState([])
    const personasAutorizadasRef = useRef(personasAutorizadas)
    const noActualizarBorrador = useRef(true)

    const [mediosDeContacto, setMediosDeContacto] = useStateIfMounted([]);
    const mediosDeContactoRef = useRef(mediosDeContacto)

    const [predios, setPredios] = useStateIfMounted([]);
    const prediosRef = useRef(predios)

    const [productor, setProductor] = useStateIfMounted([]);
    const productorRef = useRef(productor)

    const [representantesLegales, setRepresentantesLegales] = useStateIfMounted([]);
    const representantesLegalesRef = useRef(representantesLegales);

    const [opcionTipoInscripcion, setOpcionTipoInscripcion] = useStateIfMounted('')
    const [opcionTipoEmpresa, setOpcionTipoEmpresa] = useStateIfMounted('')
    const [opcionTipoInscrito, setOpcionTipoInscrito] = useStateIfMounted('')
    let [certificacionsi, setcertificacionsi] = useStateIfMounted(false)
    const certificacionsiRef = useRef(certificacionsi)
    let [certificacionno, setcertificacionno] = useStateIfMounted(false)
    const certificacionnoRef = useRef(certificacionno)
    let [empresacertificadora, setempresacertificadora] = useStateIfMounted('')
    const empresacertificadoraRef = useRef(empresacertificadora)


    const [opcionTipoArchivoProductor, setOpcionTipoArchivoProductor] = useStateIfMounted("")
    const [opcionTipoArchivoEnvasador, setOpcionTipoArchivoEnvasador] = useStateIfMounted("")
    const [opcionTipoArchivoComercializador, setOpcionTipoArchivoComercializador] = useStateIfMounted("")

    let [numerosocio, setNumeroSocio] = useStateIfMounted('')
    const numerosocioRef = useRef(numerosocio)

    const handleSaveFC_01State = () => {
        if (fechasolicitud !== 'Invalid date' && fechasolicitud !== undefined) {
            fechasolicitud = new Date(fechasolicitud).toISOString()
        }
        if (fechadenacimiento !== 'Invalid date' && fechadenacimiento !== undefined) {
            fechadenacimiento = new Date(fechadenacimiento).toISOString()
        }
        // numeroexterior = Number(numeroexterior)
        // numerointerior = Number(numerointerior)
        numerohijos = Number(numerohijos)
        let idUsuario = currentUser.user[0].id
        if (data?.idfc01_solicitudregistro) {
            dispatch(setCambiosFC_01SolicitudBorrador({
                noasociado: noasociadoRef.current, asociado: asociadoRef.current, inscrito: inscritoRef.current,
                personafisica: personafisicaRef.current,
                personamoral: personamoralRef.current, dictameninstalaciones: dictameninstalacionesRef.current,
                dictameninstalacionesfabrica: dictameninstalacionesfabricaRef.current,
                dictameninstalacionesenvasadora: dictameninstalacionesenvasadoraRef.current,
                dictameninstalacionesbodega: dictameninstalacionesbodegaRef.current,
                constanciacomercializador: constanciacomercializadorRef.current,
                actualizacioninformacion: actualizacioninformacionRef.current,
                certificadonomproductor: certificadonomproductorRef.current,
                certificadonomenvasador: certificadonomenvasadorRef.current,
                certificadonomcomercializador: certificadonomcomercializadorRef.current,
                nombrerazonsocial: nombrerazonsocialRef.current, fechasolicitud: fechasolicitudRef.current, calle: calleRef.current,
                numeroexterior: numeroexteriorRef.current, numerointerior: numerointeriorRef.current, colonia: coloniaRef.current,
                localidad: localidadRef.current, municipioalcaldia: municipioalcaldiaRef.current, estado: estadoRef.current,
                codigopostal: codigopostalRef.current, rfc: rfcRef.current, representantelegal: representantelegalRef.current,
                telefonorepresentante: telefonorepresentanterRef.current,
                correoelectronicorepresentante: correoelectronicorepresentanteRef.current, viverista: viveristaRef.current,
                productormaguey: productormagueyRef.current, productormezcal: productormezcalRef.current,
                envasador: envasadorRef.current, comercializadormezcal: comercializadormezcalRef.current,
                comercializadorbebidasconmezcal: comercializadorbebidasconmezcalRef.current,
                fechadenacimiento: fechadenacimientoRef.current, sexo: sexoRef.current, estadocivil: estadocivilRef.current,
                escolaridad: escolaridadRef.current, discapacidadno: discapacidadnoRef.current, discapacidadsi: discapacidadsiRef.current,
                tipodiscapacidad: tipodiscapacidadRef.current, lenguaindijenasi: lenguaindijenasiRef.current,
                lenguaindijenano: lenguaindijenanoRef.current, tipolengua: tipolenguaRef.current, ocupacion: ocupacionRef.current,
                numerohijos: numerohijosRef.current, idestatusdesolicitudes: 1, idlogin: idUsuario,
                personaautorizadasi: personaautorizadasiRef.current, personaautorizadano: personaautorizadanoRef.current,
                representantelegalsi: representantelegalsiRef.current, representantelegalno: representantelegalnoRef.current,
                numerosocio: numerosocioRef.current, telefono: telefonoRef.current, correoelectronico: correoelectronicoRef.current,
                idfc01_solicitudregistro: data.idfc01_solicitudregistro, terminosYCondiciones: terminosYCondicionesRef.current,
                certificacionsi: certificacionsiRef.current, certificacionno: certificacionnoRef.current, empresacertificadora: empresacertificadoraRef.current,
                valores: valoresInicialesRef.current, passwordnomsi: passwordnomsiRef.current, passwordnomno: passwordnomnoRef.current,
                comprobantepago: comprobantepagoRef.current, comprobantepagotext: comprobantepagotextRef.current
            }))
        } else {
            const { ...valoresAGuardar } = valoresInicialesRef.current
            valoresAGuardar.certificacionno = certificacionnoRef.current
            valoresAGuardar.certificacionsi = certificacionsiRef.current
            valoresAGuardar.representantelegalsi = representantelegalsiRef.current
            valoresAGuardar.representantelegalno = representantelegalnoRef.current
            valoresAGuardar.discapacidadsi = discapacidadsiRef.current
            valoresAGuardar.discapacidadno = discapacidadnoRef.current
            valoresAGuardar.lenguaindijenasi = lenguaindijenasiRef.current
            valoresAGuardar.lenguaindijenano = lenguaindijenanoRef.current
            valoresAGuardar.personaautorizadasi = personaautorizadasiRef.current
            valoresAGuardar.personaautorizadano = personaautorizadanoRef.current
            valoresAGuardar.passwordnomsi = passwordnomsiRef.current
            valoresAGuardar.passwordnomno = passwordnomnoRef.current
            dispatch(setCambiosFC_01SolicitudNueva({
                noasociado: noasociadoRef.current, asociado: asociadoRef.current, inscrito: inscritoRef.current,
                personafisica: personafisicaRef.current,
                personamoral: personamoralRef.current, dictameninstalaciones: dictameninstalacionesRef.current,
                dictameninstalacionesfabrica: dictameninstalacionesfabricaRef.current,
                dictameninstalacionesenvasadora: dictameninstalacionesenvasadoraRef.current,
                dictameninstalacionesbodega: dictameninstalacionesbodegaRef.current,
                constanciacomercializador: constanciacomercializadorRef.current,
                actualizacioninformacion: actualizacioninformacionRef.current,
                certificadonomproductor: certificadonomproductorRef.current,
                certificadonomenvasador: certificadonomenvasadorRef.current,
                certificadonomcomercializador: certificadonomcomercializadorRef.current,
                nombrerazonsocial: nombrerazonsocialRef.current, fechasolicitud: fechasolicitudRef.current, calle: calleRef.current,
                numeroexterior: numeroexteriorRef.current, numerointerior: numerointeriorRef.current, colonia: coloniaRef.current,
                localidad: localidadRef.current, municipioalcaldia: municipioalcaldiaRef.current, estado: estadoRef.current,
                codigopostal: codigopostalRef.current, rfc: rfcRef.current, representantelegal: representantelegalRef.current,
                telefonorepresentante: telefonorepresentanterRef.current,
                correoelectronicorepresentante: correoelectronicorepresentanteRef.current, viverista: viveristaRef.current,
                productormaguey: productormagueyRef.current, productormezcal: productormezcalRef.current,
                envasador: envasadorRef.current, comercializadormezcal: comercializadormezcalRef.current,
                comercializadorbebidasconmezcal: comercializadorbebidasconmezcalRef.current,
                fechadenacimiento: fechadenacimientoRef.current, sexo: sexoRef.current, estadocivil: estadocivilRef.current,
                escolaridad: escolaridadRef.current, discapacidadno: discapacidadnoRef.current, discapacidadsi: discapacidadsiRef.current,
                tipodiscapacidad: tipodiscapacidadRef.current, lenguaindijenasi: lenguaindijenasiRef.current,
                lenguaindijenano: lenguaindijenanoRef.current, tipolengua: tipolenguaRef.current, ocupacion: ocupacionRef.current,
                numerohijos: numerohijosRef.current, idestatusdesolicitudes: 1, idlogin: idUsuario,
                personaautorizadasi: personaautorizadasiRef.current, personaautorizadano: personaautorizadanoRef.current,
                representantelegalsi: representantelegalsiRef.current, representantelegalno: representantelegalnoRef.current,
                numerosocio: numerosocioRef.current, telefono: telefonoRef.current, correoelectronico: correoelectronicoRef.current,
                terminosYCondiciones: terminosYCondicionesRef.current,
                certificacionsi: certificacionsiRef.current, certificacionno: certificacionnoRef.current, empresacertificadora: empresacertificadoraRef.current,
                valores: valoresAGuardar, passwordnomsi: passwordnomsiRef.current, passwordnomno: passwordnomnoRef.current,
                comprobantepago: comprobantepagoRef.current, comprobantepagotext: comprobantepagotextRef.current
            }))

        }

        dispatch(agregarFC_01AnexosFiles({
            data: filesRef.current
        }))

        dispatch(agregarFC_01AnexosFilesApoderadosLeg({
            data: filesApoderadosLegRef.current
        }))

        dispatch(agregarFC_01AnexosFilesPersonasAut({
            data: filesPersonasAutRef.current
        }))
        dispatch(agregarFC_01AnexosFilesPredios({
            data: filesPrediosRef.current
        }))
        dispatch(agregarFC_01AnexosFilesViveros({
            data: filesViverosRef.current
        }))
        dispatch(agregarFC_01AnexosFilesMarcas({
            data: filesMarcasRef.current
        }))
        dispatch(agregarFC_01AnexosFilesMarcaProduct({
            data: filesMarcasProductRef.current
        }))
        dispatch(agregarFC_01AnexosFilesInstalaciones({
            data: filesInstalacionesRef.current
        }))

        dispatch(agregarFC_01OpcionesFilesPredios({
            data: opcionFilePredioRef.current
        }))

        dispatch(agregarFC_01OpcionesFilesViveros({
            data: opcionFileViveroRef.current
        }))

        dispatch(agregarFC_01OpcionesFilesInstalacion({
            data: opcionFileInstalacionRef.current
        }))

        dispatch(agregarFC_01AnexoMarcasBeneficiario({
            data: marcasRef.current
        }))

        dispatch(agregarFC_01AnexoPersonasAutBeneficiario({
            data: personasAutorizadasRef.current
        }))

        dispatch(agregarFC_01AnexoRepresentanteLegalBeneficiario({
            data: representantesLegalesRef.current
        }))

        dispatch(agregarFC_01AnexoMediosDeContactoBeneficiario({
            data: mediosDeContactoRef.current
        }))
    }

    const handleSetAllPropertysRef = () => {
        filesRef.current = files
        marcasRef.current = marcas
        personasAutorizadasRef.current = personasAutorizadas
        representantesLegalesRef.current = representantesLegales
        noasociadoRef.current = noasociado
        asociadoRef.current = asociado
        inscritoRef.current = inscrito
        personafisicaRef.current = personafisica
        personamoralRef.current = personamoral
        dictameninstalacionesRef.current = dictameninstalaciones
        dictameninstalacionesfabricaRef.current = dictameninstalacionesfabrica
        dictameninstalacionesenvasadoraRef.current = dictameninstalacionesenvasadora
        dictameninstalacionesbodegaRef.current = dictameninstalacionesbodega
        constanciacomercializadorRef.current = constanciacomercializador
        actualizacioninformacionRef.current = actualizacioninformacion
        certificadonomproductorRef.current = certificadonomproductor
        certificadonomenvasadorRef.current = certificadonomcomercializador
        certificadonomcomercializadorRef.current = certificadonomcomercializador
        nombrerazonsocialRef.current = nombrerazonsocial
        fechasolicitudRef.current = fechasolicitud
        calleRef.current = calle
        numeroexteriorRef.current = numeroexterior
        numerointeriorRef.current = numerointerior
        coloniaRef.current = colonia
        localidadRef.current = localidad
        municipioalcaldiaRef.current = municipioalcaldia
        estadoRef.current = estado
        codigopostalRef.current = codigopostal
        rfcRef.current = rfc
        representantelegalRef.current = representantelegal
        telefonorepresentanterRef.current = telefonorepresentante
        correoelectronicorepresentanteRef.current = correoelectronicorepresentante
        viveristaRef.current = viverista
        productormagueyRef.current = productormaguey
        productormezcalRef.current = productormezcal
        envasadorRef.current = envasador
        comercializadormezcalRef.current = comercializadormezcal
        comercializadorbebidasconmezcalRef.current = comercializadorbebidasconmezcal
        fechadenacimientoRef.current = fechadenacimiento
        sexoRef.current = sexo
        estadocivilRef.current = estadocivil
        escolaridadRef.current = escolaridad
        discapacidadnoRef.current = discapacidadno
        discapacidadsiRef.current = discapacidadsi
        tipodiscapacidadRef.current = tipodiscapacidad
        lenguaindijenasiRef.current = lenguaindijenasi
        lenguaindijenanoRef.current = lenguaindijenano
        tipolenguaRef.current = tipolengua
        ocupacionRef.current = ocupacion
        numerohijosRef.current = numerohijos
        personaautorizadasiRef.current = personaautorizadasi
        personaautorizadanoRef.current = personaautorizadano
        representantelegalsiRef.current = representantelegalsi
        representantelegalnoRef.current = representantelegalno
        numerosocioRef.current = numerosocio
        telefonoRef.current = telefono
        correoelectronicoRef.current = correoelectronico

        mediosDeContactoRef.current = mediosDeContacto
        //------------Observaciones------------
        noasociadoRef.current = noasociado

        terminosYCondicionesRef.current = terminosYCondiciones
        certificacionsiRef.current = certificacionsi
        certificacionnoRef.current = certificacionno
        empresacertificadoraRef.current = empresacertificadora
        passwordnomsiRef.current = passwordnomsi
        passwordnomnoRef.current = passwordnomno

        valoresInicialesRef.current = valores
        filesApoderadosLegRef.current = filesApoderadosLeg
        filesPersonasAutRef.current = filesPersonasAut
        filesPrediosRef.current = filesPredios
        filesViverosRef.current = filesViveros
        filesMarcasRef.current = filesMarcas
        filesMarcasProductRef.current = filesMarcasProduct
        filesInstalacionesRef.current = filesInstalaciones

        opcionFilePredioRef.current = opcionFilePredio
        opcionFileViveroRef.current = opcionFileVivero
        opcionFileInstalacionRef.current = opcionFileInstalacion
    }

    const handleResetAllPropertys = (flag = true) => {
        setFile([])
        setInstalacionesBodega(false)
        setInstalacionesEnvasadora(false)
        setInstalacionesFabrica(false)
        setFisica(false)
        setMoral(false)
        setActualizacionInformacion(false)
        setAsociado(false)
        setCallle('')
        setNomComercializador(false)
        setNomEnvasador(false)
        setNomProductor(false)
        setCp('')
        setColonia('')
        setComercializadorBebidas(false)
        setComercializadorMezcal(false)
        setConstanciaComercializador(false)
        setCorreoLegal('')
        setDictamenInstalaciones(false)
        setDiscapacidadNo(false)
        setDiscapacidadSi(false)
        setEnvasador(false)
        setEscolaridadPersona('')
        setEstado('')
        setEstadoCivilPersona('')
        setFechaNacimientoPersona(fechaParaMayorEdad)
        setFechaSolicitud(fechaHoy)
        setInscrito(false)
        setLenguaNo(false)
        setLenguaSi(false)
        setLocalidad('')
        setMunicipioAlcaldia('')
        setNoAsociado(false)
        setNombreRazon('')
        setNumExterior('')
        setNumeroHijos('')
        setNumInterior('')
        setOcupacionPersona('')
        setPoroductorMaguey(false)
        setProductorMezcal(false)
        setNombreLegal('')
        setRfc('')
        setSexoPersona('')
        setTelefonoLegal('')
        setTipoDiscapacidad('')
        setTipoLengua('')
        setViverista(false)
        setPersonasAutorizadas([])
        setmarcas([])
        setRepresentantesLegales([])
        setMediosDeContacto([])
        setPredios([])
        setProductor([])
        setmarcasProductoConMezcal([])
        if (flag) {
            if (data.idfc01_solicitudregistro) {

                //dispatch(eliminarFC_01Anexos(data?.idfc01_solicitudregistro))
            }
        }
        setAgregarPersonaAutorizadaSi(false)
        setAgregarPersonaAutorizadaNo(false)
        setAgregarRepresentanteLegalSi(false)
        setAgregarRepresentanteLegalSi(false)
        setOpcionTipoInscripcion('')
        setOpcionTipoEmpresa('')
        setNumeroSocio('')
        setTelefono('')
        setCorreoElectronico('')
        handleCloseModal()

        setTerminosYCondiciones(false)
        setcertificacionno(false)
        setcertificacionsi(false)
        setempresacertificadora('')
        setpasswordnomsi(false)
        setpasswordnomsi(false)
        setFileApoderadosLeg([])
        setFilePersonasAut([])
        setFilePredios([])
        setFileViveros([])
        setFileMarcas([])
        setFileMarcasProduct([])
        setFileInstalaciones([])
        setOpcionFilePredio([])
        setOpcionFileVivero([])
        setOpcionFileInstalacion([])

        dispatch(resetDataFC_01())
    }

    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_01 = data
        }
        if (!(JSON.stringify({}) === JSON.stringify(fc_01))) {
            //  fc_01 = fc_01
            setValoresIniciales(fc_01.valores)
            setValores(fc_01)


            let fechaNac = moment(fc_01.fechadenacimiento ? fc_01.fechadenacimiento : (fechaHoy)).format('YYYY-MM-DD')
            let fechaSol = moment(fc_01.fechasolicitud ? fc_01.fechasolicitud : (fechaHoy)).format('YYYY-MM-DD')
            if (marcasFC_01.data) {
                if (marcasFC_01.data.data) {
                    setmarcas(marcasFC_01.data.data)
                } else {
                    setmarcas(marcasFC_01.data)
                }
            }
            if (marcasProductosConMezcalFC_01.data) {
                if (marcasProductosConMezcalFC_01.data.data) {
                    setmarcasProductoConMezcal(marcasProductosConMezcalFC_01.data.data)
                } else {
                    setmarcasProductoConMezcal(marcasProductosConMezcalFC_01.data)
                }
            }
            if (personasAutorizadasFC_01.data) {
                if (personasAutorizadasFC_01.data.data) {
                    const aux = Object.assign([], personasAutorizadasFC_01.data.data)
                    setPersonasAutorizadas(aux)
                } else {
                    const aux = Object.assign([], personasAutorizadasFC_01.data)
                    setPersonasAutorizadas(aux)
                }
            }
            if (representantesLegalesFC_01.data) {
                if (representantesLegalesFC_01.data.data) {
                    const aux = Object.assign([], representantesLegalesFC_01.data.data)
                    setRepresentantesLegales(aux)
                } else {
                    const aux = Object.assign([], representantesLegalesFC_01.data)
                    setRepresentantesLegales(aux)
                }
            }
            if (mediosDeContactoFC_01.data) {
                if (mediosDeContactoFC_01.data.data) {
                    setMediosDeContacto(mediosDeContactoFC_01.data.data)
                } else {
                    setMediosDeContacto(mediosDeContactoFC_01.data)
                }
            }
            if (prediosFC_01.data) {
                if (prediosFC_01.data.data) {
                    setPredios(prediosFC_01.data.data)
                } else {
                    setPredios(prediosFC_01.data)
                }
            }
            if (productorFC_01.data) {
                if (productorFC_01.data.data) {
                    setProductor(productorFC_01.data.data)
                } else {
                    setProductor(productorFC_01.data)
                }
            }


            if (fc_01.asociado) setOpcionTipoInscripcion('asociado')
            if (fc_01.noasociado) setOpcionTipoInscripcion('noasociado')
            if (fc_01.inscrito) setOpcionTipoInscripcion('yaInscrito')
            if (fc_01.inscrito & fc_01.asociado) { setOpcionTipoInscrito('asociado') }
            if (fc_01.inscrito & fc_01.noasociado) { setOpcionTipoInscrito('noasociado') }

            if (fc_01.personafisica) setOpcionTipoEmpresa('fisica')
            if (fc_01.personamoral) setOpcionTipoEmpresa('moral')

            setInstalacionesBodega(fc_01.dictameninstalacionesbodega)
            setInstalacionesEnvasadora(fc_01.dictameninstalacionesenvasadora)
            setInstalacionesFabrica(fc_01.dictameninstalacionesfabrica)
            setFisica(fc_01.personafisica)
            setMoral(fc_01.personamoral)
            setActualizacionInformacion(fc_01.actualizacioninformacion)
            setAsociado(fc_01.asociado)
            setCallle(fc_01.calle)
            setNomComercializador(fc_01.certificadonomcomercializador)
            setNomEnvasador(fc_01.certificadonomenvasador)
            setNomProductor(fc_01.certificadonomproductor)
            setCp(fc_01.codigopostal)
            setColonia(fc_01.colonia)
            setComercializadorBebidas(fc_01.comercializadorbebidasconmezcal)
            setComercializadorMezcal(fc_01.comercializadormezcal)
            setConstanciaComercializador(fc_01.constanciacomercializador)
            setCorreoLegal(fc_01.correoelectronicorepresentante)
            correoLegal(fc_01.correoelectronicorepresentante)
            setDictamenInstalaciones(fc_01.dictameninstalaciones)
            setDiscapacidadNo(fc_01.discapacidadno)
            setDiscapacidadSi(fc_01.discapacidadsi)
            setEnvasador(fc_01.envasador)
            setEscolaridadPersona(fc_01.escolaridad)
            setEstado(fc_01.estado)
            setEstadoCivilPersona(fc_01.estadocivil)
            setFechaNacimientoPersona(fechaNac)
            setFechaSolicitud(fechaSol)
            setInscrito(fc_01.inscrito)
            setLenguaNo(fc_01.lenguaindijenano)
            setLenguaSi(fc_01.lenguaindijenasi)
            setLocalidad(fc_01.localidad)
            setMunicipioAlcaldia(fc_01.municipioalcaldia)
            setNoAsociado(fc_01.noasociado)
            setNombreRazon(fc_01.nombrerazonsocial)
            setNumExterior(fc_01.numeroexterior)
            setNumeroHijos(fc_01.numerohijos)
            setNumInterior(fc_01.numerointerior)
            setOcupacionPersona(fc_01.ocupacion)
            setPoroductorMaguey(fc_01.productormaguey)
            setProductorMezcal(fc_01.productormezcal)
            setNombreLegal(fc_01.representantelegal)
            setRfc(fc_01.rfc)
            setSexoPersona(fc_01.sexo)
            setTelefonoLegal(fc_01.telefonorepresentante)
            setTipoDiscapacidad(fc_01.tipodiscapacidad)
            setTipoLengua(fc_01.tipolengua)
            setViverista(fc_01.viverista)
            setAgregarPersonaAutorizadaSi(fc_01.personaautorizadasi)
            setAgregarPersonaAutorizadaNo(fc_01.personaautorizadano)
            setAgregarRepresentanteLegalSi(fc_01.representantelegalsi)
            setAgregarRepresentanteLegalNo(fc_01.representantelegalno)
            setNumeroSocio(fc_01.numerosocio)
            setTelefono(fc_01.telefono)
            setCorreoElectronico(fc_01.correoelectronico)
            comprobarEmail(fc_01.correoelectronico)
            setNumeroHombres(fc_01.numerohombres)
            setNumeroMujeres(fc_01.numeromujeres)
            setNumeroDiscapacitados(fc_01.numerodiscapacitados)
            setNumeroBase(fc_01.numerobase)
            setNumeroEventuales(fc_01.numeroeventuales)
            setFolio(fc_01.folio)
            setcertificacionsi(fc_01.certificacionsi)
            setcertificacionno(fc_01.certificacionno)
            setempresacertificadora(fc_01.empresacertificadora)
            setpasswordnomsi(fc_01.passwordnomsi)
            setpasswordnomno(fc_01.passwordnomno)
            setcomprobantepago(fc_01.comprobantepago)
            setcomprobantepagotext(fc_01.comprobantepagotext)

            if (fc_01.terminosYCondiciones) setTerminosYCondiciones(fc_01.terminosYCondiciones)


        }

    }, [fc_01, data])

    //GUARDAR CAMBIOS EN UNMOUNT DE COMPONENTE
    React.useEffect(() => {
        return () => {
            if (noActualizarBorrador.current === true) {
                handleSaveFC_01State()
            }
        }
    }, [])

    //SETEAR PROPIEDADES A REF PARA CONSERVAR EN EL TIEMPO
    React.useEffect(() => {
        handleSetAllPropertysRef()
        guardarActividadesEmpresa()
        //guardarDomicilioFiscal()
    }, [files,
        marcas,
        representantesLegales,
        personasAutorizadas,
        mediosDeContacto,
        noasociado,
        asociado,
        inscrito,
        personafisica,
        personamoral,
        dictameninstalaciones,
        dictameninstalacionesfabrica,
        dictameninstalacionesenvasadora,
        dictameninstalacionesbodega,
        constanciacomercializador,
        actualizacioninformacion,
        certificadonomproductor,
        certificadonomcomercializador,
        certificadonomcomercializador,
        nombrerazonsocial,
        fechasolicitud,
        calle,
        numeroexterior,
        numerointerior,
        colonia,
        localidad,
        municipioalcaldia,
        estado,
        codigopostal,
        rfc,
        representantelegal,
        telefonorepresentante,
        correoelectronicorepresentante,
        viverista,
        productormaguey,
        productormezcal,
        envasador,
        comercializadormezcal,
        comercializadorbebidasconmezcal,
        fechadenacimiento,
        sexo,
        estadocivil,
        escolaridad,
        discapacidadno,
        discapacidadsi,
        tipodiscapacidad,
        lenguaindijenasi,
        lenguaindijenano,
        tipolengua,
        ocupacion,
        numerohijos,
        personaautorizadasi,
        personaautorizadano,
        representantelegalsi,
        representantelegalno,
        numerosocio,
        telefono,
        correoelectronico,
        terminosYCondiciones,
        certificacionsi,
        certificacionno,
        empresacertificadora,
        valores,
        passwordnomsi,
        passwordnomno,
        filesApoderadosLeg,
        filesPersonasAut,
        filesPredios,
        filesViveros,
        filesMarcas,
        filesMarcasProduct,
        filesInstalaciones,
        opcionFilePredio,
        opcionFileVivero,
        opcionFileInstalacion
    ])



    //DETECTAR CAMBIOS EN PERSONA AUTORIZADA
    React.useEffect(() => {
        if (personasAutorizadasFC_01.data) {
            if (personasAutorizadasFC_01.data.data) {
                const aux = Object.assign([], personasAutorizadasFC_01.data.data)
                setPersonasAutorizadas(aux)
            } else {
                const aux = Object.assign([], personasAutorizadasFC_01.data)
                setPersonasAutorizadas(aux)
            }
        }
    }, [personasAutorizadasFC_01])

    //DETECTAR CAMBIOS EN MARCAS
    React.useEffect(() => {
        if (marcasFC_01.data) {
            if (marcasFC_01.data.data) {
                setmarcas(marcasFC_01.data.data)
            } else {
                setmarcas(marcasFC_01.data)
            }
        }
    }, [marcasFC_01])
    React.useEffect(() => {
        if (marcasProductosConMezcalFC_01.data) {
            if (marcasProductosConMezcalFC_01.data.data) {
                setmarcasProductoConMezcal(marcasProductosConMezcalFC_01.data.data)
            } else {
                setmarcasProductoConMezcal(marcasProductosConMezcalFC_01.data)
            }
        }
    }, [marcasProductosConMezcalFC_01])

    React.useEffect(() => {
        if (prediosFC_01.data) {
            if (prediosFC_01.data.data) {
                setPredios(prediosFC_01.data.data)
            } else {
                setPredios(prediosFC_01.data)
            }
        }
    }, [prediosFC_01])

    React.useEffect(() => {
        if (productorFC_01.data) {
            if (productorFC_01.data.data) {
                setProductor(productorFC_01.data.data)
            } else {
                setProductor(productorFC_01.data)
            }
        }
    }, [productorFC_01])
    //DETECTAR CAMBIOS EN MEDIOS DE CONTACTO
    React.useEffect(() => {
        if (representantesLegalesFC_01.data) {
            if (representantesLegalesFC_01.data.data) {
                const aux = Object.assign([], representantesLegalesFC_01.data.data)
                setRepresentantesLegales(aux)
            } else {
                const aux = Object.assign([], representantesLegalesFC_01.data)
                setRepresentantesLegales(aux)
            }
        }
    }, [representantesLegalesFC_01])

    React.useEffect(() => {
        if (mediosDeContactoFC_01.data) {
            if (mediosDeContactoFC_01.data.data) {
                setMediosDeContacto(mediosDeContactoFC_01.data.data)
            } else {
                setMediosDeContacto(mediosDeContactoFC_01.data)
            }
        }
    }, [mediosDeContactoFC_01])

    React.useEffect(() => {
        let totalDePaginas = 3
        const nuevosApartados = ['Datos generales', 'Domicilio fiscal']
        if (viverista || productormaguey) {
            totalDePaginas++
            let nombreApartado = ''
            if (viverista && productormaguey) nombreApartado = 'Viverista/Productor de maguey'
            else if (viverista) nombreApartado = 'Viverista'
            else nombreApartado = 'Productor de maguey'
            nuevosApartados.push(nombreApartado)
        }
        if (productormezcal || envasador || comercializadormezcal || comercializadorbebidasconmezcal) {
            totalDePaginas++
            nuevosApartados.push('Instalaciones')
        }
        if (comercializadormezcal || comercializadorbebidasconmezcal) {
            totalDePaginas++
            nuevosApartados.push('Marcas')
        }
        nuevosApartados.push('Documentación')
        let nuevasPaginas = []
        for (let index = 1; index <= totalDePaginas; index++) {
            nuevasPaginas.push(index)
        }
        setPaginas(nuevasPaginas)
        setNombresParaPaginas(nuevosApartados)
    }, [viverista, productormaguey, productormezcal, envasador, comercializadormezcal, comercializadorbebidasconmezcal])

    //Obtener estados de la API
    React.useEffect(async () => {
        await dispatch(actualizarLoadingApp_true())
        const result = await obtenerEstadosConClave()
        await cargarDomicilioApi(result)
        await dispatch(actualizarLoadingApp_false())
    }, [])

    const cargarDomicilioApi = async (estadosConClave) => {
        var municipiosConClave = []
        if (fc_01.estado !== '') {
            const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(fc_01.estado))
            municipiosConClave = result.payload
        }
        if (fc_01.municipioalcaldia !== '') {
            const result = await dispatch(obtenerCPsPorMunicipioApi(fc_01.municipioalcaldia))
        }
        if (fc_01.codigopostal !== '') {
            //fc_01.codigopostal
            const result = await dispatch(obtenerColoniasPorCpApi(fc_01.codigopostal))
        }
        var localidadesConClave = []
        if (fc_01.codigopostal !== '') {
            const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: fc_01.estado, municipio: fc_01.municipioalcaldia }))
            localidadesConClave = result.payload
        }
        if (fc_01.localidad !== '') {
            const clave_estado = await obtenerClaveDomicilioEstado(estadosConClave, fc_01.estado)
            const clave_municipio = await obtenerClaveDomicilio(municipiosConClave, fc_01.municipioalcaldia, "municipio")
            const clave_localidad = await obtenerClaveDomicilio(localidadesConClave, fc_01.localidad, "localidad")
            const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))

        }
    }

    const salirModoEdicionBorrador = () => {
        dispatch(setModoBorrador(false))
        dispatch(resetDataFC_01())
        handleResetAllPropertys(false)
    }

    const salirModoCorreccion = () => {
        dispatch(setModoCorreccion(false))
        dispatch(resetDataFC_01())
        handleResetAllPropertys(false)
    }

    const handleAddPersonaAut = () => {
        let anexo = { id: uuidv4(), personaautoriazadaparatramites: '', telefonopersona: '', correoelectronicopersona: '', estado: false }
        if (modoEdicionBorrador) {
            dispatch(agregarFC_01AnexoPersonaAutBeneficiario(anexo))
        } else {
            setPersonasAutorizadas([...personasAutorizadas, anexo])
            let anexos = [...personasAutorizadas, anexo]
            dispatch(agregarFC_01AnexoPersonasAutBeneficiario({ data: anexos }))
        }
    }
    const handleOnChanguePersonaAut = (data) => {
        data.estado = comprobarEmailAnexo(data.valor)
        dispatch(editarFC_01AnexoPersonasAutBeneficiario(data))
    }
    const comprobarEmailAnexo = (correo) => {
        const patron = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/;
        const emailsAceptados = ['@gmail', '@yahoo', '@outlook', '@hotmail'];
        const extensionesAceptadas = ['.mx', '.com', '.es'];
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;
        if (!correo) return false
        if (correo.match(emailRegex)) {
            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;

            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                return true
            } else {
                return false
            }
        }
        else {
            return false
        }

    }

    const deletePersonaAutorizada = (inputField) => {
        if (inputField.idfc01_anexopersonaatorizadatramites) {
            dispatch(eliminarFC_01AnexoPersonasAutBD(inputField.idfc01_anexopersonaatorizadatramites))
        }
        const personas = personasAutorizadas.filter(persona => persona.id !== inputField.id)
        setPersonasAutorizadas(personas)
        dispatch(agregarFC_01AnexoPersonasAutBeneficiario({ data: personas }))
    }

    const deleteMarca = (inputField) => {
        if (inputField.idfc01_anexomarcas) {
            dispatch(eliminarFC_01AnexoMarcasBD(inputField.idfc01_anexomarcas))
        }
        const fields = marcas.filter(fields => fields.id !== inputField.id)
        setmarcas(fields)
        dispatch(agregarFC_01AnexoMarcasBeneficiario({ data: fields }))
    }
    const deleteMarcaProductoConMezcal = (inputField) => {
        if (inputField.idfc01_anexomarcas) {
            dispatch(eliminarFC_01AnexoMarcasBD(inputField.idfc01_anexomarcas))
        }
        const fields = marcasProductoConMezcal.filter(fields => fields.id !== inputField.id)
        setmarcasProductoConMezcal(fields)
        dispatch(agregarFC_01AnexoMarcasProductoConMezcalBeneficiario({ data: fields }))
    }

    const handleAddMarcas = () => {
        let anexo = {
            id: uuidv4(), marca: '', registrosi: false, registrono: false, numeroderegistroimpi: '',
            idtipomarca: 0, idtitularidaddemarca: 0, productor: '', maquilador: ''
        }
        if (modoEdicionBorrador) {
            dispatch(agregarFC_01AnexoMarcaBeneficiario(anexo))
        } else {
            setmarcas([...marcas, anexo])
            let anexos = [...marcas, anexo]
            dispatch(agregarFC_01AnexoMarcasBeneficiario({ data: anexos }))
        }
    };
    const handleAddMarcasProductoConMezcal = () => {
        let anexo = {
            id: uuidv4(), marca: '', registrosi: false, registrono: false, numeroderegistroimpi: '',
            idtipomarca: 0, idtitularidaddemarca: 0, productor: '', maquilador: ''
        }
        if (modoEdicionBorrador) {
            dispatch(agregarFC_01AnexoMarcaProductosConMezcalBeneficiario(anexo))
        } else {
            setmarcasProductoConMezcal([...marcasProductoConMezcal, anexo])
            let anexos = [...marcasProductoConMezcal, anexo]
            dispatch(agregarFC_01AnexoMarcasProductoConMezcalBeneficiario({ data: anexos }))
        }
    };
    const handleOnChangueMarcasProductosConMezcal = (data) => {
        dispatch(editarFC_01AnexoMarcasProductoConMezcalBeneficiario(data))
    }
    const handleOnChangueMarcas = (data) => {
        dispatch(editarFC_01AnexoMarcasBeneficiario(data))
    }

    const deleteMedioDeContacto = (inputField) => {
        // if (inputField.idfc01_anexomediosdecontacto) {
        //     dispatch(eliminarFC_01AnexoMarcasBD(inputField.idfc01_anexomarcas))
        // }
        const fields = mediosDeContacto.filter(fields => fields.id !== inputField.id)
        setMediosDeContacto(fields)
        dispatch(agregarFC_01AnexoMediosDeContactoBeneficiario({ data: fields }))
    }

    const handleAddMedioDeContacto = () => {
        let anexo = { id: uuidv4(), telefono: '', correoelectronico: '' }
        if (modoEdicionBorrador) {
            //dispatch(agregarFC_01AnexoMarcaBeneficiario(anexo))
        } else {
            setMediosDeContacto([...mediosDeContacto, anexo])
            let anexos = [...mediosDeContacto, anexo]
            dispatch(agregarFC_01AnexoMediosDeContactoBeneficiario({ data: anexos }))
        }
    };

    const deleteRepresentanteLegal = (inputField) => {
        if (inputField.idfc01_anexorepresentantelegal) {
            dispatch(eliminarFC_01AnexoRepresentanteLegal(inputField.idfc01_anexorepresentantelegal))
        }
        const fields = representantesLegales.filter(fields => fields.id !== inputField.id)
        setRepresentantesLegales(fields)
        dispatch(agregarFC_01AnexoRepresentanteLegalBeneficiario({ data: fields }))
    }

    const handleAddRepresentanteLegal = () => {
        let anexo = { id: uuidv4(), representantelegal: "", telefonorepresentante: "", correoelectronicorepresentante: "", estado: false }
        if (modoEdicionBorrador) {
            dispatch(agregarFC_01AnexoRepresentanteLegalBenefi(anexo))
        } else {
            setRepresentantesLegales((prev) => [...prev, anexo])
            let anexos = [...representantesLegales, anexo]
            dispatch(agregarFC_01AnexoRepresentanteLegalBeneficiario({ data: anexos }))

        }
    }

    const handleOnChangueRepresentanteLegal = (data) => {
        data.estado = comprobarEmailAnexo(data.valor)
        dispatch(editarFC_01AnexoRepresentantesLegales(data))
    }

    const handleOnChangueMedioDeContacto = (data) => {
        dispatch(editarFC_01AnexoMediosDeContactoBeneficiario(data))
    }

    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }

    const botonEnviarBorradorFC_01 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de enviar su solicitud al personal de atencion al cliente, 
            ya no podrá seguir editando esta solicitud.`,
            accion: 'enviarBorrador'
        })
    }

    const botonEnviarCorreccionesFC_01 = () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Una vez enviada las correcciones ya no podrá realizar cambios en esta solicitud.`,
            accion: 'enviarCorrecciones'
        })
    }
    const botonActivarModalError = () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Rellene los campos obligatorios para poder enviar las solicitud de registro`,
            accion: 'modalCorrecciones'
        })
    }

    const enviarBorrador = async (valores) => {
        // let contadorArchivo = 0
        // if (valores.opcionTipoEmpresa == "moral") {
        //     contadorArchivo += contadorMoralGeneral()
        //     contadorArchivo += contadorMarcas()
        //     contadorArchivo += contadorPredios()
        //     contadorArchivo += contadorInstalaciones()
        // } else {
        //     if (valores.opcionTipoEmpresa == "fisica") {
        //         contadorArchivo += contadorFisicaGeneral()
        //         contadorArchivo += contadorMarcas()
        //         contadorArchivo += contadorPredios()
        //         contadorArchivo += contadorInstalaciones()
        //     }
        // }
        // const countFiles = files.length + filesApoderadosLeg.length + filesPersonasAut.length
        //     + filesPredios.length + filesViveros.length + filesMarcas.length
        //     + filesMarcasProduct.length + filesInstalaciones.length
        // if (countFiles >= contadorArchivo) {
        await updateBorrador(valores)
        const idSolicitud = valores.idfc01_solicitudregistro
        const estatusNuevo = 7

        await dispatch(actualizarFC_01Estatus(
            { data: { idSolicitud: idSolicitud, estatus: estatusNuevo } }
        ))
        // await dispatch(resetDataFC_01())
        await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
        props.history.push('/solicitudes')
        // } else {
        //     setvalidacion(true)
        //     settexto('')
        // }


    }

    const botonGuardarComoBorrador = async (valores) => {
        const idlog = Number(currentUser.user[0].id)
        const id = 1
        const contadorBorrador = await dispatch(obtenerContador({ idestatusdesolicitudes: 1, idlogin: idlog }))

        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            if (contadorBorrador.payload >= 1) {
                handleOpenModal({
                    title: `¡Advertencia!`,
                    body: `Ya no puede guardar otro borrador, ya que cuenta con un formato de inscripción guardado.`,
                    accion: 'cerrarModal'
                })
            } else {
                handleOpenModal({
                    title: `¡Advertencia!`,
                    body: `Está a punto de guardar esta solicitud en su apartado de borradores.
                    Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                    accion: 'guardarBorrador',
                    data: valores
                })
            }
        }
    }
    const zeroFill = (number) => {
        let width = 4
        width -= number.length
        if (width > 0) {
            return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number + "";
    }
    const enviarCorrecciones = async (valores) => {
        // let contadorArchivo = 0
        // if (valores.opcionTipoEmpresa == "moral") {
        //     contadorArchivo += contadorMoralGeneral()
        //     contadorArchivo += contadorMarcas()
        //     contadorArchivo += contadorPredios()
        //     contadorArchivo += contadorInstalaciones()
        // } else {
        //     if (valores.opcionTipoEmpresa == "fisica") {
        //         contadorArchivo += contadorFisicaGeneral()
        //         contadorArchivo += contadorMarcas()
        //         contadorArchivo += contadorPredios()
        //         contadorArchivo += contadorInstalaciones()
        //     }
        // }
        // const countFiles = files.length + filesApoderadosLeg.length + filesPersonasAut.length
        //     + filesPredios.length + filesViveros.length + filesMarcas.length
        //     + filesMarcasProduct.length + filesInstalaciones.length

        // if (valores.comprobantepago === true) contadorArchivo++

        // if (countFiles >= contadorArchivo) {
        await dispatch(actualizarLoadingApp_true())
        noActualizarBorrador.current = false
        if (fechasolicitud !== 'Invalid date' && fechasolicitud !== '') {
            fechasolicitud = new Date(fechasolicitud).toISOString()
        } else {
            fechasolicitud = null
        }
        let fechaNacim = valores.fechadenacimiento
        if (fechaNacim !== 'Invalid date' && fechaNacim !== '' && fechaNacim !== undefined) {
            fechaNacim = new Date(fechaNacim).toISOString()
        } else {
            fechaNacim = null
        }
        // numeroexterior = Number(numeroexterior)
        // numerointerior = Number(numerointerior)
        numerohijos = Number(numerohijos)
        // numerosocio = Number(numerosocio)
        let numeroDeSocio = valores.numerosocio + ''
        if (numeroDeSocio.length < 5) numeroDeSocio = zeroFill(numeroDeSocio)
        codigopostal = codigopostal !== undefined && codigopostal !== '' ? (codigopostal.toString()) : ('')
        telefonopersona = telefonopersona !== undefined && telefonopersona !== '' ?
            (telefonopersona.toString()) : ('')
        telefonorepresentante = telefonorepresentante !== undefined && telefonorepresentante !== '' ?
            (telefonorepresentante.toString()) : ('')
        let idUsuario = currentUser.user[0].id

        let opcion1 = false
        let opcion2 = false
        let opcion3 = false
        if (valores.opcionTipoInscripcion === 'asociado') opcion1 = true
        if (valores.opcionTipoInscripcion === 'noasociado') opcion2 = true
        if (valores.opcionTipoInscripcion === 'inscrito') {
            opcion3 = true
            if (valores.opcionTipoInscrito === 'asociado') opcion1 = true
            if (valores.opcionTipoInscrito === 'noasociado') opcion2 = true
        }
        let opcionFisica = false
        let opcionMoral = false
        if (valores.opcionTipoEmpresa === 'fisica') opcionFisica = true
        if (valores.opcionTipoEmpresa === 'moral') opcionMoral = true
        let numeroHijos = valores.numerohijos
        if (numeroHijos === '') numeroHijos = null
        let numeroHombres = valores.numerohombres
        if (numeroHombres === '') numeroHombres = null
        let numeroMujeres = valores.numeromujeres
        if (numeroMujeres === '') numeroMujeres = null
        let numeroDiscapacitados = valores.numerodiscapacitados
        if (numeroDiscapacitados === '') numeroDiscapacitados = null
        let numeroBase = valores.numerobase
        if (numeroBase === '') numeroBase = null
        let numeroEventuales = valores.numeroeventuales
        if (numeroEventuales === '') numeroEventuales = null

        const solicitud = {
            idfc01_solicitudregistro: valores.idfc01_solicitudregistro,
            noasociado: opcion2, asociado: opcion1, inscrito: opcion3, personafisica: opcionFisica, personamoral: opcionMoral, dictameninstalaciones,
            dictameninstalacionesfabrica, dictameninstalacionesenvasadora, dictameninstalacionesbodega, constanciacomercializador,
            actualizacioninformacion, certificadonomproductor, certificadonomenvasador,
            certificadonomcomercializador,
            nombrerazonsocial: valores.nombrerazonsocial, fechasolicitud, calle: valores.calle, otracalle: valores.otracalle,
            numeroexterior: valores.numeroexterior, numerointerior: valores.numerointerior, colonia: valores.colonia,
            localidad: valores.localidad, municipioalcaldia: valores.municipioalcaldia, estado: valores.estado,
            codigopostal: valores.codigopostal + '', rfc: valores.rfc, representantelegal: valores.representantelegal,
            telefonorepresentante: valores.telefonorepresentante + '', correoelectronicorepresentante: valores.correoelectronicorepresentante,
            viverista: valores.viverista, productormaguey: valores.productormaguey, productormezcal: valores.productormezcal,
            envasador: valores.envasador, comercializadormezcal: valores.comercializadormezcal, comercializadorbebidasconmezcal: valores.comercializadorbebidasconmezcal,
            fechadenacimiento: fechaNacim, sexo: valores.sexo, estadocivil: valores.estadocivil, escolaridad: valores.escolaridad,
            discapacidadno, discapacidadsi, tipodiscapacidad: valores.tipodiscapacidad,
            lenguaindijenasi, lenguaindijenano, tipolengua: valores.tipolengua, ocupacion: valores.ocupacion,
            numerohijos: numeroHijos, idestatusdesolicitudes: 5, idlogin: idUsuario,
            personaautorizadasi, personaautorizadano, representantelegalsi, representantelegalno, numerosocio: numeroDeSocio,
            telefono: valores.telefono + '', correoelectronico: valores.correoelectronico, numerohombres: numeroHombres, numeromujeres: numeroMujeres,
            numerodiscapacitados: numeroDiscapacitados, numerobase: numeroBase, numeroeventuales: numeroEventuales,
            certificacionsi, certificacionno, empresacertificadora: valores.empresacertificadora, folio: valores.folio,
            passwordnomsi, passwordnomno, opciontipoinscrito: valores.opcionTipoInscrito
        }

        if (passwordnomsi === '') solicitud.passwordnomsi = false
        if (passwordnomno === '') solicitud.passwordnomno = false

        const objetoCompletoFC_01 = {
            solicitud,
            anexoUnidadAlmacen,
            anexoUnidadEnvasado,
            anexoUnidadProduccion,
            marcas,
            personasAutorizadas,
            representantesLegales,
            files,
            filesApoderadosLeg,
            filesPersonasAut,
            filesViveros,
            filesPredios,
            filesMarcas,
            filesMarcasProduct,
            filesInstalaciones,
            mediosDeContacto,
            predios,
            productor,
            anexoInstalaciones,
            marcasProductoConMezcal
        }

        await dispatch(enviarCorreccionesFC_01(objetoCompletoFC_01))

        const idSolicitud = valores.idfc01_solicitudregistro
        const estatusNuevo = 6
        await dispatch(actualizarFC_01Estatus(
            { data: { idSolicitud: idSolicitud, estatus: estatusNuevo, folio: valores.folio } }
        ))
        await dispatch(setModoCorreccion(false))
        await dispatch(resetDataFC_01())
        handleResetAllPropertys()
        await dispatch(obtenerSolicitudesWithStatus({ status: 6, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')
        // } else {
        //     setvalidacion(true)
        //     settexto('')
        // }
    }


    const updateBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        noActualizarBorrador.current = false
        if (fechasolicitud !== 'Invalid date' && fechasolicitud !== '') {
            fechasolicitud = new Date(fechasolicitud).toISOString()
        } else {
            fechasolicitud = null
        }
        let fechaNacim = valores.fechadenacimiento
        if (fechaNacim !== 'Invalid date' && fechaNacim !== '' && fechaNacim !== undefined) {
            fechaNacim = new Date(fechaNacim).toISOString()
        } else {
            fechaNacim = null
        }
        // numeroexterior = Number(numeroexterior)
        // numerointerior = Number(numerointerior)
        numerohijos = Number(numerohijos)
        // numerosocio = Number(numerosocio)
        let numeroDeSocio = valores.numerosocio + ''
        if (numeroDeSocio.length < 5) numeroDeSocio = zeroFill(numeroDeSocio)
        codigopostal = codigopostal !== undefined && codigopostal !== '' ? (codigopostal.toString()) : ('')
        telefonopersona = telefonopersona !== undefined && telefonopersona !== '' ?
            (telefonopersona.toString()) : ('')
        telefonorepresentante = telefonorepresentante !== undefined && telefonorepresentante !== '' ?
            (telefonorepresentante.toString()) : ('')
        let idUsuario = currentUser.user[0].id
        let archivos = [
            filePreRegMaguey,
            fileIOVLegal,
            fileACN,
            filePNRL,
            filePropiedadM,
            fileIOVAutorizada,
            fileRFC,
            fileCDF,
            fileIOVResponsable,
            fileCTPInstalaciones,
            fileCCArrendamiento,
            fileCCComodato,
            fileTituloMarca,
            fileCTMarca,
            fileCRPTramite,
            fileLUCesion,
            fileJE,
            fileCC,
            fileCCExp,
            fileCM,
            fileCPago
        ]
        let opcion1 = false
        let opcion2 = false
        let opcion3 = false
        if (valores.opcionTipoInscripcion === 'asociado') opcion1 = true
        if (valores.opcionTipoInscripcion === 'noasociado') opcion2 = true
        if (valores.opcionTipoInscripcion === 'inscrito') {
            opcion3 = true
            if (valores.opcionTipoInscrito === 'asociado') opcion1 = true
            if (valores.opcionTipoInscrito === 'noasociado') opcion2 = true
        }
        let opcionFisica = false
        let opcionMoral = false
        if (valores.opcionTipoEmpresa === 'fisica') opcionFisica = true
        if (valores.opcionTipoEmpresa === 'moral') opcionMoral = true
        let numeroHijos = valores.numerohijos
        if (numeroHijos === '') numeroHijos = null
        let numeroHombres = valores.numerohombres
        if (numeroHombres === '') numeroHombres = null
        let numeroMujeres = valores.numeromujeres
        if (numeroMujeres === '') numeroMujeres = null
        let numeroDiscapacitados = valores.numerodiscapacitados
        if (numeroDiscapacitados === '') numeroDiscapacitados = null
        let numeroBase = valores.numerobase
        if (numeroBase === '') numeroBase = null
        let numeroEventuales = valores.numeroeventuales
        if (numeroEventuales === '') numeroEventuales = null
        const solicitud = {
            idfc01_solicitudregistro: valores.idfc01_solicitudregistro,
            noasociado: opcion2, asociado: opcion1, inscrito: opcion3, personafisica: opcionFisica, personamoral: opcionMoral, dictameninstalaciones,
            dictameninstalacionesfabrica, dictameninstalacionesenvasadora, dictameninstalacionesbodega, constanciacomercializador,
            actualizacioninformacion, certificadonomproductor, certificadonomenvasador,
            certificadonomcomercializador,
            nombrerazonsocial: valores.nombrerazonsocial, fechasolicitud, calle: valores.calle, otracalle: valores.otracalle,
            numeroexterior: valores.numeroexterior, numerointerior: valores.numerointerior, colonia: valores.colonia,
            localidad: valores.localidad, municipioalcaldia: valores.municipioalcaldia, estado: valores.estado,
            codigopostal: valores.codigopostal + '', rfc: valores.rfc, representantelegal: valores.representantelegal,
            telefonorepresentante: valores.telefonorepresentante + '', correoelectronicorepresentante: valores.correoelectronicorepresentante,
            viverista: viverista, productormaguey: productormaguey, productormezcal: productormezcal,
            envasador: envasador, comercializadormezcal: comercializadormezcal, comercializadorbebidasconmezcal: comercializadorbebidasconmezcal,
            fechadenacimiento: fechaNacim, sexo: valores.sexo, estadocivil: valores.estadocivil, escolaridad: valores.escolaridad,
            discapacidadno, discapacidadsi, tipodiscapacidad: valores.tipodiscapacidad,
            lenguaindijenasi, lenguaindijenano, tipolengua: valores.tipolengua, ocupacion: valores.ocupacion,
            numerohijos: numeroHijos, idestatusdesolicitudes: 1, idlogin: idUsuario,
            personaautorizadasi, personaautorizadano, representantelegalsi, representantelegalno, numerosocio: numeroDeSocio,
            telefono: valores.telefono + '', correoelectronico: valores.correoelectronico, numerohombres: numeroHombres, numeromujeres: numeroMujeres,
            numerodiscapacitados: numeroDiscapacitados, numerobase: numeroBase, numeroeventuales: numeroEventuales,
            certificacionsi, certificacionno, empresacertificadora: valores.empresacertificadora, folio: valores.folio,
            passwordnomsi, passwordnomno, opciontipoinscrito: valores.opcionTipoInscrito
        }

        if (passwordnomsi === '') solicitud.passwordnomsi = false
        if (passwordnomno === '') solicitud.passwordnomno = false
        const objetoCompletoFC_01 = {
            solicitud,
            anexoUnidadAlmacen,
            anexoUnidadEnvasado,
            anexoUnidadProduccion,
            marcas,
            personasAutorizadas,
            representantesLegales,
            archivos,
            mediosDeContacto,
            predios,
            productor,
            anexoInstalaciones,
            marcasProductoConMezcal,
            files,
            filesApoderadosLeg,
            filesPersonasAut,
            filesPredios,
            filesViveros,
            filesMarcas,
            filesMarcasProduct,
            filesInstalaciones
        }

        await dispatch(guardarCambiosFC_01Borrador(objetoCompletoFC_01))
        await dispatch(actualizarLoadingApp_false())

        return

    }
    const actualizarBorrador = async (valores) => {
        await updateBorrador(valores)
        await dispatch(setModoBorrador(false))
        await dispatch(resetDataFC_01())
        handleResetAllPropertys()
        await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
        // await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')

    }

    const guardarBorrador = async (valores) => {
        dispatch(actualizarLoadingApp_true())
        if (fechasolicitud !== 'Invalid date' && fechasolicitud !== '') {
            fechasolicitud = new Date(fechasolicitud).toISOString()
        }
        let fechaNacim = valores.fechadenacimiento
        if (fechaNacim !== 'Invalid date' && fechaNacim !== '' && fechaNacim !== undefined) {
            fechaNacim = new Date(fechaNacim).toISOString()
        } else {
            fechaNacim = null
        }
        // numeroexterior = Number(numeroexterior)
        // numerointerior = Number(numerointerior)
        numerohijos = Number(numerohijos)
        // numerosocio = Number(numerosocio)
        let numeroDeSocio = valores.numerosocio + ''
        if (numeroDeSocio.length < 5) numeroDeSocio = zeroFill(numeroDeSocio)
        codigopostal = codigopostal !== undefined && codigopostal !== '' ? (codigopostal.toString()) : ('')
        telefonopersona = telefonopersona !== undefined && telefonopersona !== '' ?
            (telefonopersona.toString()) : ('')
        telefonorepresentante = telefonorepresentante !== undefined && telefonorepresentante !== '' ?
            (telefonorepresentante.toString()) : ('')
        let idUsuario = currentUser.user[0].id

        var añoFolio = moment().format('YY');
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        let archivos = [
            filePreRegMaguey,
            fileIOVLegal,
            fileACN,
            filePNRL,
            filePropiedadM,
            fileIOVAutorizada,
            fileRFC,
            fileCDF,
            fileIOVResponsable,
            fileCTPInstalaciones,
            fileCCArrendamiento,
            fileCCComodato,
            fileTituloMarca,
            fileCTMarca,
            fileCRPTramite,
            fileLUCesion,
            fileJE,
            fileCC,
            fileCCExp,
            fileCM,
            fileCPago
        ]
        let opcion1 = false
        let opcion2 = false
        let opcion3 = false
        if (valores.opcionTipoInscripcion === 'asociado') opcion1 = true
        if (valores.opcionTipoInscripcion === 'noasociado') opcion2 = true
        if (valores.opcionTipoInscripcion === 'inscrito') {
            opcion3 = true
            if (valores.opcionTipoInscrito === 'asociado') opcion1 = true
            if (valores.opcionTipoInscrito === 'noasociado') opcion2 = true
        }
        let opcionFisica = false
        let opcionMoral = false
        if (valores.opcionTipoEmpresa === 'fisica') opcionFisica = true
        if (valores.opcionTipoEmpresa === 'moral') opcionMoral = true
        let numeroHijos = valores.numerohijos
        if (numeroHijos === '') numeroHijos = null
        let numeroHombres = valores.numerohombres
        if (numeroHombres === '') numeroHombres = null
        let numeroMujeres = valores.numeromujeres
        if (numeroMujeres === '') numeroMujeres = null
        let numeroDiscapacitados = valores.numerodiscapacitados
        if (numeroDiscapacitados === '') numeroDiscapacitados = null
        let numeroBase = valores.numerobase
        if (numeroBase === '') numeroBase = null
        let numeroEventuales = valores.numeroeventuales
        if (numeroEventuales === '') numeroEventuales = null
        const solicitud = {
            noasociado: opcion2, asociado: opcion1, inscrito: opcion3, personafisica: opcionFisica, personamoral: opcionMoral, dictameninstalaciones,
            dictameninstalacionesfabrica, dictameninstalacionesenvasadora, dictameninstalacionesbodega, constanciacomercializador,
            actualizacioninformacion, certificadonomproductor, certificadonomenvasador,
            certificadonomcomercializador,
            nombrerazonsocial: valores.nombrerazonsocial, fechasolicitud, calle: valores.calle, otracalle: valores.otracalle,
            numeroexterior: valores.numeroexterior, numerointerior: valores.numerointerior, colonia: valores.colonia,
            localidad: valores.localidad, municipioalcaldia: valores.municipioalcaldia, estado: valores.estado,
            codigopostal: valores.codigopostal + '', rfc: valores.rfc, representantelegal: valores.representantelegal,
            telefonorepresentante: valores.telefonorepresentante + '', correoelectronicorepresentante: valores.correoelectronicorepresentante,
            viverista: valores.viverista, productormaguey: valores.productormaguey, productormezcal: valores.productormezcal,
            envasador: valores.envasador, comercializadormezcal: valores.comercializadormezcal, comercializadorbebidasconmezcal: valores.comercializadorbebidasconmezcal,
            fechadenacimiento: fechaNacim, sexo: valores.sexo, estadocivil: valores.estadocivil, escolaridad: valores.escolaridad,
            discapacidadno, discapacidadsi, tipodiscapacidad: valores.tipodiscapacidad,
            lenguaindijenasi, lenguaindijenano, tipolengua: valores.tipolengua, ocupacion: valores.ocupacion,
            numerohijos: numeroHijos, idestatusdesolicitudes: 1, idlogin: idUsuario,
            personaautorizadasi, personaautorizadano, representantelegalsi, representantelegalno, numerosocio: numeroDeSocio,
            telefono: valores.telefono + '', correoelectronico: valores.correoelectronico, numerohombres: numeroHombres, numeromujeres: numeroMujeres,
            numerodiscapacitados: numeroDiscapacitados, numerobase: numeroBase, numeroeventuales: numeroEventuales,
            certificacionsi, certificacionno, empresacertificadora: valores.empresacertificadora, folio: consFolio,
            passwordnomsi, passwordnomno, opciontipoinscrito: valores.opcionTipoInscrito
        }
        // if(valores.calle == 'Otro') solicitud.calle = valores.otracalle
        //agregarP

        const objetoCompletoFC_01 = {
            solicitud,
            anexoUnidadAlmacen,
            anexoUnidadEnvasado,
            anexoUnidadProduccion,
            marcas,
            personasAutorizadas,
            representantesLegales,
            mediosDeContacto,
            predios,
            productor,
            anexoInstalaciones,
            marcasProductoConMezcal
            // archivos
        }
        dispatch(agregarFC_01SolicitudBorrador(objetoCompletoFC_01))
        dispatch(resetDataFC_01())
        handleResetAllPropertys()
        await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
        dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')

    }
    const activarBotonEnviarRegistro = () => {
        setBotonEnviarRegistro(true)
    }
    const activarBotonEnviarBorrador = () => {
        setBotonEnviarBorrador(true)
    }
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const [envioCorrecto, setEnvioCorrecto] = useStateIfMounted(false)
    const [folioSolicitud, setFolioSolicitud] = useStateIfMounted('')
    const botonRegistrarFC_01 = async (valores) => {
        // let contadorArchivo = 0
        // if (valores.opcionTipoEmpresa == "moral") {
        //     contadorArchivo += contadorMoralGeneral()
        //     contadorArchivo += contadorMarcas()
        //     contadorArchivo += contadorPredios()
        //     contadorArchivo += contadorInstalaciones()
        // } else {
        //     if (valores.opcionTipoEmpresa == "fisica") {
        //         contadorArchivo += contadorFisicaGeneral()
        //         contadorArchivo += contadorMarcas()
        //         contadorArchivo += contadorPredios()
        //         contadorArchivo += contadorInstalaciones()
        //     }
        // }
        // const countFiles = files.length + filesApoderadosLeg.length + filesPersonasAut.length
        //     + filesPredios.length + filesViveros.length + filesMarcas.length
        //     + filesMarcasProduct.length + filesInstalaciones.length

        // if (countFiles >= contadorArchivo) {
        await dispatch(actualizarLoadingApp_true())

        if (fechasolicitud !== 'Invalid date' && fechasolicitud !== '') {
            fechasolicitud = new Date(fechasolicitud).toISOString()
        }
        let fechaNacim = valores.fechadenacimiento
        if (valores.fechadenacimiento !== 'Invalid date' && valores.fechadenacimiento !== '' && valores.fechadenacimiento !== undefined) {
            fechaNacim = new Date(valores.fechadenacimiento).toISOString()
        } else {
            fechaNacim = null
        }
        // numeroexterior = Number(numeroexterior)
        // numerointerior = Number(numerointerior)
        numerohijos = Number(numerohijos)
        // numerosocio = Number(numerosocio)
        let numeroDeSocio = valores.numerosocio + ''
        if (numeroDeSocio.length < 5) numeroDeSocio = zeroFill(numeroDeSocio)
        codigopostal = codigopostal !== undefined && codigopostal !== '' ? (codigopostal.toString()) : ('')
        telefonopersona = telefonopersona !== undefined && telefonopersona !== '' ?
            (telefonopersona.toString()) : ('')
        telefonorepresentante = telefonorepresentante !== undefined && telefonorepresentante !== '' ?
            (telefonorepresentante.toString()) : ('')
        let idUsuario = currentUser.user[0].id

        const contadorBorrador = await dispatch(obtenerContador({ idestatusdesolicitudes: 1, idlogin: idUsuario }))

        let folioConstruido = ""
        if (Number(contadorBorrador.payload) === 0) {
            var año = moment().format('YY');
            let year = String(año)
            const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
            var añoFolio = moment().format('YY');
            if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) folioConstruido = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
            if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) folioConstruido = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
            if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) folioConstruido = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
            if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) folioConstruido = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio
        }

        let opcion1 = false
        let opcion2 = false
        let opcion3 = false
        if (valores.opcionTipoInscripcion === 'asociado') opcion1 = true
        if (valores.opcionTipoInscripcion === 'noasociado') opcion2 = true
        if (valores.opcionTipoInscripcion === 'inscrito') {
            opcion3 = true
            if (valores.opcionTipoInscrito === 'asociado') opcion1 = true
            if (valores.opcionTipoInscrito === 'noasociado') opcion2 = true
        }

        let opcionFisica = false
        let opcionMoral = false
        if (valores.opcionTipoEmpresa === 'fisica') opcionFisica = true
        if (valores.opcionTipoEmpresa === 'moral') opcionMoral = true

        // let telefonoDelRepresentante = valores.telefonorepresentante + ''
        const solicitud = {
            noasociado: opcion2, asociado: opcion1, inscrito: opcion3, personafisica: opcionFisica, personamoral: opcionMoral,
            dictameninstalaciones, dictameninstalacionesfabrica,
            dictameninstalacionesenvasadora, dictameninstalacionesbodega, constanciacomercializador,
            actualizacioninformacion, certificadonomproductor, certificadonomenvasador,
            certificadonomcomercializador, nombrerazonsocial: valores.nombrerazonsocial, fechasolicitud, calle: valores.calle, otracalle: valores.otracalle,
            numeroexterior: valores.numeroexterior, numerointerior: valores.numerointerior, colonia: valores.colonia,
            localidad: valores.localidad, municipioalcaldia: valores.municipioalcaldia, estado: valores.estado,
            codigopostal: valores.codigopostal + '', rfc: valores.rfc, representantelegal: valores.representantelegal,
            telefonorepresentante: valores.telefonorepresentante + '', correoelectronicorepresentante: valores.correoelectronicorepresentante,
            viverista: valores.viverista, productormaguey: valores.productormaguey, productormezcal: valores.productormezcal,
            envasador: valores.envasador, comercializadormezcal: valores.comercializadormezcal, comercializadorbebidasconmezcal: valores.comercializadorbebidasconmezcal,
            fechadenacimiento: fechaNacim, sexo: valores.sexo, estadocivil: valores.estadocivil, escolaridad: valores.escolaridad,
            discapacidadno, discapacidadsi, tipodiscapacidad: valores.tipodiscapacidad,
            lenguaindijenasi, lenguaindijenano, tipolengua: valores.tipolengua, ocupacion: valores.ocupacion,
            numerohijos: Number(valores.numerohijos), idestatusdesolicitudes: 7, idlogin: idUsuario,
            personaautorizadasi, personaautorizadano, representantelegalsi, representantelegalno, numerosocio: numeroDeSocio,
            telefono: valores.telefono + '', correoelectronico: valores.correoelectronico, numerohombres: valores.numerohombres, numeromujeres: valores.numeromujeres,
            numerodiscapacitados: valores.numerodiscapacitados, numerobase: valores.numerobase, numeroeventuales: valores.numeroeventuales,
            certificacionsi, certificacionno, empresacertificadora: valores.empresacertificadora, folio: folioConstruido,
            passwordnomsi, passwordnomno, opciontipoinscrito: valores.opcionTipoInscrito
        }
        const objetoCompletoFC_01 = {
            solicitud,
            anexoUnidadAlmacen,
            anexoUnidadEnvasado,
            anexoUnidadProduccion,
            marcas,
            personasAutorizadas,
            representantesLegales,
            files,
            filesApoderadosLeg,
            filesPersonasAut,
            filesViveros,
            filesPredios,
            filesMarcas,
            filesMarcasProduct,
            filesInstalaciones,
            mediosDeContacto,
            predios,
            productor,
            anexoInstalaciones,
            marcasProductoConMezcal
        }
        await dispatch(agregarFC_01Solicitud(objetoCompletoFC_01))
        await dispatch(resetDataFC_01())
        handleResetAllPropertys()
        await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        // setFolioSolicitud(folioConstruido)
        // setEnvioCorrecto(true)
        props.history.push('/solicitudes')
        // } else {
        //     setvalidacion(true)
        //     settexto('')
        // }
    }

    const setTipoInscripcion = (value) => {
        setOpcionTipoInscripcion(value)
        if (value === 'asociado') {
            // if (target.checked) {
            setAsociado(true)
            setNoAsociado(false)
            setInscrito(false)
            // }
        } else if (value === 'noasociado') {
            // if (target.checked) {
            setAsociado(false)
            setNoAsociado(true)
            setInscrito(false)
            // }
        } else if (value === 'yaInscrito') {
            // if (target.checked) {
            setAsociado(false)
            setNoAsociado(false)
            setInscrito(true)
            // }
        } else {
            setAsociado(false)
            setNoAsociado(false)
            setInscrito(false)
        }
    }

    // const setFisicaOMoral = (target) => {
    //     if (target.id === 'fisica') {
    //         if (target.checked) {
    //             setFisica(true)
    //             setMoral(false)
    //         }
    //     } else if (target.id === 'moral') {
    //         if (target.checked) {
    //             setMoral(true)
    //             setFisica(false)
    //         }
    //     }
    // }
    const setFisicaOMoral = (value) => {
        setOpcionTipoEmpresa(value)
        if (value === 'fisica') {
            // if (target.checked) {
            setFisica(true)
            setMoral(false)
            // }
        } else if (value === 'moral') {
            // if (target.checked) {
            setMoral(true)
            setFisica(false)
            // }
        } else {
            setMoral(false)
            setFisica(false)
        }
    }

    const setLenguaSiNo = (target) => {
        if (target.id === 'si') {
            if (target.checked) {
                setLenguaSi(true)
                setLenguaNo(false)
            }

        } else if (target.id === 'no') {
            if (target.checked) {
                setLenguaNo(true)
                setLenguaSi(false)
            }
        }
    }

    const setDiscapacidadSiNo = (target) => {
        if (target.id === 'si') {
            if (target.checked) {
                setDiscapacidadSi(true)
                setDiscapacidadNo(false)
            }
        } else if (target.id === 'no') {
            if (target.checked) {
                setDiscapacidadNo(true)
                setDiscapacidadSi(false)
            }
        }
    }
    const setAgregarPersonaAutorizadaSiNo = (target) => {
        if (target.id === 'si') {
            if (target.checked) {
                setAgregarPersonaAutorizadaSi(true)
                setAgregarPersonaAutorizadaNo(false)
            }
        } else if (target.id === 'no') {
            if (target.checked) {
                setAgregarPersonaAutorizadaNo(true)
                setAgregarPersonaAutorizadaSi(false)
            }
        }
    }

    const setCertificacionSiNo = (target) => {
        if (target.id === 'si') {
            if (target.checked) {
                setcertificacionsi(true)
                setcertificacionno(false)
            }
        } else if (target.id === 'no') {
            if (target.checked) {
                setcertificacionno(true)
                setcertificacionsi(false)
            }
        }
    }

    const setAgregarRepresentanteLegalSiNo = (target) => {
        if (target.id === 'si') {
            if (target.checked) {
                setAgregarRepresentanteLegalSi(true)
                setAgregarRepresentanteLegalNo(false)
            }
        } else if (target.id === 'no') {
            if (target.checked) {
                setAgregarRepresentanteLegalNo(true)
                setAgregarRepresentanteLegalSi(false)
            }
        }
    }
    const setAgregaMediosDeContactoSiNo = (target) => {
        if (target.id === 'si') {
            if (target.checked) {
                setAgregarMediosDeContactoSi(true)
                setAgregarMediosDeContactoNo(false)
            }
        } else if (target.id === 'no') {
            if (target.checked) {
                setAgregarMediosDeContactoNo(true)
                setAgregarMediosDeContactoSi(false)
            }
        }
    }
    const setGenerarpasswordnomsiNo = (target) => {
        if (target.id === 'si') {
            if (target.checked) {
                setpasswordnomsi(true)
                setpasswordnomno(false)
            }
        } else if (target.id === 'no') {
            if (target.checked) {
                setpasswordnomno(true)
                setpasswordnomsi(false)
            }
        }
    }

    const guardarActividadesEmpresa = async () => {
        const data = {
            productormezcal,
            envasador,
            comercializadormezcal,
            comercializadorbebidasconmezcal
        }
        await dispatch(agregarFC_01ActividadesEmpresa(data))
    }
    const botonAlmacen = async () => {
        const data = {
            productormezcal,
            envasador,
            comercializadormezcal,
            comercializadorbebidasconmezcal
        }
        await dispatch(agregarFC_01ActividadesEmpresa(data))
        //await guardarDomicilioFiscal()
        props.history.push('/fc_01AnexoAlmacen', { calle: calle })

    }
    const guardarDomicilioFiscal = async (data) => {
        await dispatch(agregarFC_01DomicilioFiscal(data))
        return
    }
    let stateDomicilioFiscal = useSelector(store => store.FC_01Solicitud.domicilioFiscal)
    const [isValidEmailLegal, setIsValidEmailLegal] = useState(false);
    const correoLegal = (value) => {
        setCorreoLegal(value)
        setIsValidEmailLegal(comprobarEmailAnexo(value))
    }




    /***********************FILES*********************** */
    //FILES GENERALES
    const handdleFile = (objectFile) => {
        setFile(prev => [...prev, objectFile])
    }

    const handdleRemovePrev = (objectFile) => {
        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFile(newFiles)
            }
        }
    }

    //FILES PREDIOS
    const handdleFilePredio = (objectFile) => {
        setFilePredios(prev => [...prev, objectFile])
    }

    const handdleRemovePrevPredio = (objectFile) => {
        if (objectFile) {
            const newFiles = filesPredios.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFilePredios(newFiles)
            }
        }
    }
    const deletePrevPredio = (files, id) => {
        if (files) {
            let newFiles = []
            files.map((file, index) => {

                if (!(file.id).includes(id)) {
                    // deleteFile(file)
                    newFiles.push(file)
                }
            })
            setFilePredios(newFiles)
        }
    }

    const handleChangeOptionFilePredio = (option) => {
        setOpcionFilePredio(prev => [...prev, option])
    }
    const handdleRemoveOptionFilePredio = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFilePredio.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFilePredio(newOptions)
            }
        }
    }

    const handdleDeleteOptionFilePredio = (idAnexo) => {
        if (idAnexo) {
            const newOptions = opcionFilePredio.filter(opcion => opcion.idAnexo !== idAnexo)
            if (newOptions !== undefined) {
                setOpcionFilePredio(newOptions)
            }
        }
    }

    //FILES VIVEROS
    const handdleFileVivero = (objectFile) => {
        setFileViveros(prev => [...prev, objectFile])
    }

    const handdleRemovePrevVivero = (objectFile) => {
        if (objectFile) {
            const newFiles = filesViveros.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFileViveros(newFiles)
            }
        }
    }

    const deletePrevVivero = (files, id) => {
        if (files) {
            let newFiles = []
            files.map((file, index) => {

                if (!(file.id).includes(id)) {
                    // deleteFile(file)
                    newFiles.push(file)
                }
            })
            setFileViveros(newFiles)
        }
    }

    const handleChangeOptionFileVivero = (option) => {
        setOpcionFileVivero(prev => [...prev, option])
    }
    const handdleRemoveOptionFileVivero = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFileVivero.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFileVivero(newOptions)
            }
        }
    }
    const handdleDeleteOptionFileVivero = (idAnexo) => {
        if (idAnexo) {
            const newOptions = opcionFileVivero.filter(opcion => opcion.idAnexo !== idAnexo)
            if (newOptions !== undefined) {
                setOpcionFileVivero(newOptions)
            }
        }
    }

    //FILES APODERADOS LEGALES
    const handdleFileApoderadoLeg = (objectFile) => {
        setFileApoderadosLeg(prev => [...prev, objectFile])
    }

    const handdleRemovePrevApoderadoLeg = (objectFile) => {
        if (objectFile) {
            const newFiles = filesApoderadosLeg.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFileApoderadosLeg(newFiles)
            }
        }
    }

    //FILES PERSONAS AUTORIZADAS
    const handdleFilePersonasAut = (objectFile) => {
        setFilePersonasAut(prev => [...prev, objectFile])
    }

    const handdleRemovePrevPersonasAut = (objectFile) => {
        if (objectFile) {
            const newFiles = filesPersonasAut.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFilePersonasAut(newFiles)
            }
        }
    }

    //FILES MARCAS DE MEZCAL
    const handdleFileMarcas = (objectFile) => {
        setFileMarcas(prev => [...prev, objectFile])
    }

    const handdleRemovePrevMarcas = (objectFile) => {
        if (objectFile) {
            const newFiles = filesMarcas.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFileMarcas(newFiles)
            }
        }
    }

    //FILES MARCAS DE PRODUCTOS CON MEZCAL
    const handdleFileMarcasProduct = (objectFile) => {
        setFileMarcasProduct(prev => [...prev, objectFile])
    }

    const handdleRemovePrevMarcasProduct = (objectFile) => {
        if (objectFile) {
            const newFiles = filesMarcasProduct.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFileMarcasProduct(newFiles)
            }
        }
    }

    //FILES INSTALACIONES
    const handdleFileInstalaciones = (objectFile) => {
        setFileInstalaciones(prev => [...prev, objectFile])
    }

    const handdleRemovePrevInstalaciones = (objectFile) => {
        if (objectFile) {
            const newFiles = filesInstalaciones.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFileInstalaciones(newFiles)
            }
        }
    }

    const deletePrevInstalacion = (files, id) => {
        if (files) {
            let newFiles = []
            files.map((file, index) => {

                if (!(file.id).includes(id)) {
                    // deleteFile(file)
                    newFiles.push(file)
                }
            })
            setFileInstalaciones(newFiles)
        }
    }

    const handleChangeOptionFileInstalacion = (option) => {
        setOpcionFileInstalacion(prev => [...prev, option])
    }
    const handdleRemoveOptionFileInstalacion = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFileInstalacion.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFileInstalacion(newOptions)
            }
        }
    }
    const handdleDeleteOptionFileInstalacion = (idAnexo) => {
        if (idAnexo) {
            const newOptions = opcionFileInstalacion.filter(opcion => opcion.idAnexo !== idAnexo)
            if (newOptions !== undefined) {
                setOpcionFileInstalacion(newOptions)
            }
        }
    }

    React.useEffect(() => {
        if (filesFC_01?.data) {
            let newFiles = []
            for (const file of filesFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }
        //filesApoderadosLegFC_01
        if (filesApoderadosLegFC_01?.data) {
            let newFiles = []
            for (const file of filesApoderadosLegFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileApoderadosLeg(newFiles)
        }
        //filesPersonasAutFC_01
        if (filesPersonasAutFC_01?.data) {
            let newFiles = []
            for (const file of filesPersonasAutFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilePersonasAut(newFiles)
        }
        //filesMarcasFC_01
        if (filesMarcasFC_01?.data) {
            let newFiles = []
            for (const file of filesMarcasFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileMarcas(newFiles)
        }
        //filesMarcasProductFC_01
        if (filesMarcasProductFC_01?.data) {
            let newFiles = []
            for (const file of filesMarcasProductFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileMarcasProduct(newFiles)
        }
        //filesInstalacionesFC_01
        if (filesInstalacionesFC_01?.data) {
            let newFiles = []
            for (const file of filesInstalacionesFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileInstalaciones(newFiles)
        }
        //filesPrediosFC_01
        if (filesPrediosFC_01?.data) {
            let newFiles = []
            for (const file of filesPrediosFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilePredios(newFiles)
        }
        //filesViverosFC_01
        if (filesViverosFC_01?.data) {
            let newFiles = []
            for (const file of filesViverosFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileViveros(newFiles)
        }

        //opcionesFilesPrediosFC_01
        if (opcionesFilesPrediosFC_01?.data) {
            let newOpciones = []
            for (const opcion of opcionesFilesPrediosFC_01.data) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFilePredio(newOpciones)
        }

        //opcionesFilesViverosFC_01
        if (opcionesFilesViverosFC_01?.data) {
            let newOpciones = []
            for (const opcion of opcionesFilesViverosFC_01.data) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFileVivero(newOpciones)
        }

        //opcionesInstalaciones
        if (opcionesFilesInstalacionesFC_01?.data) {
            let newOpciones = []
            for (const opcion of opcionesFilesInstalacionesFC_01.data) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFileInstalacion(newOpciones)
        }
    }, [fc_01, data])

    const contadorFisicaGeneral = () => {
        let contador = 0
        if (viverista || productormaguey || productormezcal || envasador || comercializadorbebidasconmezcal || comercializadormezcal) {
            contador += 3
        }
        if (representantelegalsi === true) contador += 1
        if (certificacionsi === true) contador += 1
        if (representantesLegales.length > 0) contador += (representantesLegales.length * 2)
        if (personasAutorizadas.length > 0) contador += personasAutorizadas.length
        return contador
    }
    const contadorPredios = () => {
        let contador = 0
        if (predios.length > 0 && viverista) {
            for (const i in opcionFileVivero) {
                if (opcionFileVivero[i].opcionFile === 'copiaescritura') contador++
                else if (opcionFileVivero[i].opcionFile === 'constanciaposesion') contador++
                else if (opcionFileVivero[i].opcionFile === 'contratoarrendamiento') contador += 3
                else if (opcionFileVivero[i].opcionFile === 'contratocompraventa') contador += 3
            }
            // contador += predios.length
            if (opcionFileVivero.length !== predios.length) contador++
        }
        if (productor.length > 0 && productormaguey) {
            // contador += productor.length
            for (const i in opcionFilePredio) {
                if (opcionFilePredio[i].opcionFile === 'copiaescritura') contador++
                else if (opcionFilePredio[i].opcionFile === 'constanciaposesion') contador++
                else if (opcionFilePredio[i].opcionFile === 'contratoarrendamiento') contador += 3
                else if (opcionFilePredio[i].opcionFile === 'contratocompraventa') contador += 3
            }
            if (opcionFilePredio.length !== productor.length) contador++
        }
        return contador
    }
    const contadorMarcas = () => {
        let contador = 0
        if (comercializadormezcal) {
            if (marcas.length > 0 && !envasador && !productormaguey) contador += (marcas.length * 3)
            if (marcas.length > 0 && !envasador && productormaguey) contador += (marcas.length * 2)
            if (marcas.length > 0 && envasador && !productormaguey) contador += (marcas.length * 2)
            if (marcas.length > 0 && envasador && productormaguey) contador += marcas.length
            for (const marca of marcas) {
                if (marca.registrosi && marca.idtitularidaddemarca == 1) contador += 1
                if (marca.registrosi && marca.idtitularidaddemarca == 3) contador += 2
                if (marca.registrosi && marca.idtitularidaddemarca == 4) contador += 2
                if (marca.registrosi && marca.idtitularidaddemarca == 5) contador += 3
                if (marca.registrosi && marca.idtitularidaddemarca == 6) contador += 3
                if (marca.registrono && marca.idtitularidaddemarca == 2) contador += 2
                if (marca.registrono && marca.idtitularidaddemarca == 5) contador += 3
                if (marca.registrono && marca.idtitularidaddemarca == 6) contador += 3
            }
        }
        if (comercializadorbebidasconmezcal) {
            if (marcasProductoConMezcal.length > 0 && !envasador && !productormaguey) contador += (marcasProductoConMezcal.length * 3)
            if (marcasProductoConMezcal.length > 0 && !envasador && productormaguey) contador += (marcasProductoConMezcal.length * 2)
            if (marcasProductoConMezcal.length > 0 && envasador && !productormaguey) contador += (marcasProductoConMezcal.length * 2)
            if (marcasProductoConMezcal.length > 0 && envasador && productormaguey) contador += marcasProductoConMezcal.length
            for (const marca of marcasProductoConMezcal) {
                if (marca.registrosi && marca.idtitularidaddemarca == 1) contador += 1
                if (marca.registrosi && marca.idtitularidaddemarca == 3) contador += 2
                if (marca.registrosi && marca.idtitularidaddemarca == 4) contador += 2
                if (marca.registrosi && marca.idtitularidaddemarca == 5) contador += 3
                if (marca.registrosi && marca.idtitularidaddemarca == 6) contador += 3
                if (marca.registrono && marca.idtitularidaddemarca == 2) contador += 2
                if (marca.registrono && marca.idtitularidaddemarca == 5) contador += 3
                if (marca.registrono && marca.idtitularidaddemarca == 6) contador += 3
            }
        }
        return contador
    }
    const contadorMoralGeneral = () => {
        let contador = 0
        if (viverista || productormaguey || productormezcal || envasador || comercializadorbebidasconmezcal || comercializadormezcal) {
            contador += 5
        }
        if (certificacionsi === true) contador += 1
        if (representantesLegales.length > 0) contador += (representantesLegales.length * 2)
        if (personasAutorizadas.length > 0) contador += personasAutorizadas.length
        return contador
    }
    const contadorInstalaciones = () => {
        let contador = 0
        if (anexoInstalaciones.length > 0) {
            // contador += anexoInstalaciones.length
            for (const i in opcionFileInstalacion) {
                if (opcionFileInstalacion[i].opcionFile === 'copiatitulopropiedad') contador++
                else if (opcionFileInstalacion[i].opcionFile === 'contratoarrendamientopublico') contador++
                else if (opcionFileInstalacion[i].opcionFile === 'contratoarrendamientoprivado') contador += 3
                else if (opcionFileInstalacion[i].opcionFile === 'contratocomodatopublico') contador += 1
                else if (opcionFileInstalacion[i].opcionFile === 'contratocomodatoprivado') contador += 3
            }
            if (opcionFileInstalacion.length !== anexoInstalaciones.length) contador++
            for (const anexo of anexoInstalaciones) {
                contador += anexo.data.responsables.length
            }
        }
        return contador
    }

    const botonEnviarSolicitudFC_01 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atencion al cliente.`,
            accion: 'enviarSolicitudFC_01'
        })
    }
    const botonEnviarSolicitudFC_01Borrador = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atencion al cliente.`,
            accion: 'enviarSolicitudFC_01Borrador'
        })
    }

    const documentacionGeneralFisica = (valores) => {
        if (viverista || productormaguey || productormezcal || envasador || comercializadorbebidasconmezcal || comercializadormezcal) {
            return (
                // className={` mb-3 ${estilos.labelNaranjaDocs}`}
                <div>
                    <Collapsible trigger="Agregar documentación general" className={`${estilos.collapsible} mb-3`}>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGIOV'} tabla={"FC_01_anexos"} textLabel={`Identificación oficial vigente del solicitante: ${valores.nombrerazonsocial}`} filesMap={documentacionFC_01Map} />
                            }
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGCDF'} tabla={"FC_01_anexos"} textLabel="Comprobante de domicilio Fiscal." textoTooltip='No mayor a 3 meses de antigüedad' filesMap={documentacionFC_01Map} />
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGRFC'} tabla={"FC_01_anexos"} textLabel="Constancia de situación fiscal (RFC)." textoTooltip='No mayor a tres meses de antigüedad' filesMap={documentacionFC_01Map} />
                            {
                                representantelegalsi &&
                                <>
                                    <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGIOVREP'} tabla={"FC_01_anexos"} textLabel={`Identificación oficial vigente del apoderado legal: ${valores.representantelegal}`} filesMap={documentacionFC_01Map} />
                                </>
                            }
                            {/* {
                                representantesLegales.map((representante, index) => (
                                    <>
                                        <ArchivoComponent api={{ handdleFile: handdleFileApoderadoLeg, handdleRemovePrev: handdleRemovePrevApoderadoLeg, files: filesApoderadosLeg }} idAnexo={representante.id} id={`DGIOVAP${index}`} tabla={"FC_01_anexorepresentantelegal"} textLabel={`Identificación oficial vigente del representante legal: ${representante.representantelegal}`} />
                                        <ArchivoComponent api={{ handdleFile: handdleFileApoderadoLeg, handdleRemovePrev: handdleRemovePrevApoderadoLeg, files: filesApoderadosLeg }} idAnexo={representante.id} id={`DGPNAP${index}`} tabla={"FC_01_anexorepresentantelegal"} textLabel={`Poder notarial`} />
                                    </>
                                ))
                            } */}
                            {
                                personasAutorizadas.map((personaAut, index) => (
                                    <>
                                        <ArchivoComponent api={{ handdleFile: handdleFilePersonasAut, handdleRemovePrev: handdleRemovePrevPersonasAut, files: filesPersonasAut }} idAnexo={personaAut.id} id={`DGIOVAUT${index}`} tabla={"FC_01_anexopersonaautorizada"} textLabel={`Identificación oficial vigente de la persona autorizada: ${personaAut.personaautoriazadaparatramites}`} filesMap={documentacionPersonaAutorizadaMap} />
                                        {/* <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DGCP${index}`} tabla={"FC_01_anexopersonaautorizada"} key={index} textLabel={`Carta poder simple`} /> */}
                                    </>
                                ))
                            }
                            {
                                certificacionsi &&
                                <>
                                    <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGC'} tabla={"FC_01_anexos"} textLabel={`Documento que acredite su certificación ${valores.empresacertificadora}`} filesMap={documentacionFC_01Map} />
                                </>
                            }
                        </div>
                    </Collapsible>
                </div>

            )
        }
    }

    const documentacionGeneralMoral = (valores) => {
        if (viverista || productormaguey || productormezcal || envasador || comercializadorbebidasconmezcal || comercializadormezcal) {
            return (
                <div>
                    <Collapsible trigger="Agregar documentación general" className='mb-3'>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DGAC`} tabla={"FC_01_anexos"} textLabel="Acta constitutiva notariada" filesMap={documentacionFC_01Map} />
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DGPN`} tabla={"FC_01_anexos"} textLabel="Poder notarial del representante legal o última acta de asamblea notariada." textoTooltip='En caso de no acreditarse en su acta constitutiva' filesMap={documentacionFC_01Map} />

                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DGIOVREP`} tabla={"FC_01_anexos"} textLabel={`Identificación oficial vigente del representante legal: ${valores.representantelegal}`} filesMap={documentacionFC_01Map} />
                            {
                                representantesLegales.map((representante, index) => (
                                    <>
                                        <ArchivoComponent api={{ handdleFile: handdleFileApoderadoLeg, handdleRemovePrev: handdleRemovePrevApoderadoLeg, files: filesApoderadosLeg }} idAnexo={representante.id} id={`DGIOVAP${index}`} tabla={"FC_01_anexorepresentantelegal"} textLabel={`Identificación oficial vigente del apoderado legal: ${representante.representantelegal}`} filesMap={documentacionRepresentanteLegalMap} />
                                        <ArchivoComponent api={{ handdleFile: handdleFileApoderadoLeg, handdleRemovePrev: handdleRemovePrevApoderadoLeg, files: filesApoderadosLeg }} idAnexo={representante.id} id={`DGPNAP${index}`} tabla={"FC_01_anexorepresentantelegal"} textLabel={`Poder notarial`} filesMap={documentacionRepresentanteLegalMap} />
                                    </>
                                ))
                            }
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGCDF'} tabla={"FC_01_anexos"} textLabel="Comprobante de domicilio Fiscal." textoTooltip='No mayor a 3 meses de antigüedad' filesMap={documentacionFC_01Map} />
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGRFC'} tabla={"FC_01_anexos"} textLabel="Constancia de situación fiscal (RFC)." textoTooltip='No mayor a tres meses de antigüedad' filesMap={documentacionFC_01Map} />
                            {
                                personasAutorizadas.map((personaAut, index) => (
                                    <>
                                        <ArchivoComponent api={{ handdleFile: handdleFilePersonasAut, handdleRemovePrev: handdleRemovePrevPersonasAut, files: filesPersonasAut }} idAnexo={personaAut.id} id={`DGIOVAUT${index}`} tabla={"FC_01_anexopersonaautorizada"} textLabel={`Identificación oficial vigente de la persona autorizada: ${personaAut.personaautoriazadaparatramites}`} filesMap={documentacionPersonaAutorizadaMap} />
                                        {/* <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DGCP${index}`} tabla={"FC_01_anexopersonaautorizada"} key={index} textLabel={`Carta poder simple`} /> */}
                                    </>
                                ))
                            }
                            {
                                certificacionsi &&
                                <>
                                    <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGC'} tabla={"FC_01_anexos"} textLabel={`Certificación de la empresa: ${valores.empresacertificadora}`} filesMap={documentacionFC_01Map} />
                                </>
                            }
                        </div>
                    </Collapsible>
                </div>
            )
        }
    }

    const viveristaProductorFisicaFiles = () => {
        let nameDocumentacion = ''
        if (viverista) nameDocumentacion = 'viverista'
        if (productormaguey && viverista) nameDocumentacion += '/productor maguey'
        else if (productormaguey) nameDocumentacion = 'productor maguey'
        if (viverista || productormaguey) {
            return (
                <div>
                    {/* <div className={` mb-3 ${estilos.labelNaranjaDocs}`}>
                        <span>Documentación de viverista{productormaguey && '/productor maguey'}</span>
                    </div> */}
                    <Collapsible trigger={`Agregar documentación de ${nameDocumentacion}`} className='mb-3'>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                predios.map((vivero, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFileVivero, handdleRemovePrev: handdleRemovePrevVivero, files: filesViveros }} idAnexo={vivero.id} id={`VIV${index}`} tabla={"FC_01_anexos"} anexo={vivero} name='Vivero' tipo={'Vivero'} filesMap={documentacionViveroMap} opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileVivero, opcion: opcionFileVivero, handdleRemoveOptionFile: handdleRemoveOptionFileVivero, deletePrevFile: deletePrevVivero }} />
                                    </div>
                                ))
                            }
                            {
                                productor.map((predio, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFilePredio, handdleRemovePrev: handdleRemovePrevPredio, files: filesPredios }} id={`PRED${index}`} idAnexo={predio.id} tabla={"FC_01_anexos"} anexo={predio} name='Predio' tipo={'Predio'} filesMap={documentacionPredioMap} opcionSelect={{ handleChangeOptionFile: handleChangeOptionFilePredio, opcion: opcionFilePredio, handdleRemoveOptionFile: handdleRemoveOptionFilePredio, deletePrevFile: deletePrevPredio }} />
                                    </div>
                                ))
                            }
                            {/* {
                                predios.map((predio, index) => (
                                    <div key={index}>
                                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`PRED${index}`} tabla={"FC_01_anexos"} textLabel={`Documento que demuestre la propiedad del maguey (agave). Vivero: ${predio.nombreparaje}`} />
                                    </div>
                                ))
                            }
                            {
                                productor.map((prod, index) => (
                                    <div key={index}>
                                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`PROD${index}`} tabla={"FC_01_anexos"} textLabel={`Documento que demuestre la propiedad del maguey (agave). Predio: ${prod.nombreparaje}`} />
                                    </div>
                                ))
                            } */}
                        </div>
                    </Collapsible>

                </div>
            )
        }
    }

    const viveristaProductorMoralFiles = () => {
        let nameDocumentacion = ''
        if (viverista) nameDocumentacion = 'viverista'
        if (productormaguey && viverista) nameDocumentacion += '/productor maguey'
        else if (productormaguey) nameDocumentacion = 'productor maguey'
        if (viverista || productormaguey) {
            return (
                <div>
                    {/* <div className={` mb-3 ${estilos.labelNaranjaDocs}`}>
                        <span>Documentación de viverista{productormaguey && '/productor maguey'}</span>
                    </div> */}
                    <Collapsible trigger={`Agregar documentación de ${nameDocumentacion}`} className='mb-3'>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                predios.map((vivero, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFileVivero, handdleRemovePrev: handdleRemovePrevVivero, files: filesViveros }} idAnexo={vivero.id} id={`VIV${index}`} tabla={"FC_01_anexos"} anexo={vivero} name='Vivero' tipo={'Vivero'} filesMap={documentacionViveroMap} opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileVivero, opcion: opcionFileVivero, handdleRemoveOptionFile: handdleRemoveOptionFileVivero, deletePrevFile: deletePrevVivero }} />
                                    </div>
                                ))
                            }
                            {
                                productor.map((predio, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFilePredio, handdleRemovePrev: handdleRemovePrevPredio, files: filesPredios }} idAnexo={predio.id} id={`PRED${index}`} tabla={"FC_01_anexos"} anexo={predio} name='Predio' tipo={'Predio'} filesMap={documentacionPredioMap} opcionSelect={{ handleChangeOptionFile: handleChangeOptionFilePredio, opcion: opcionFilePredio, handdleRemoveOptionFile: handdleRemoveOptionFilePredio, deletePrevFile: deletePrevPredio }} />
                                    </div>
                                ))
                            }
                            {/* {
                                predios.map((predio, index) => (
                                    <div key={index}>
                                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`PRED${index}`} tabla={"FC_01_anexos"} textLabel={`Documento que demuestre la propiedad del maguey (agave). Vivero: ${predio.nombreparaje}`} />
                                    </div>
                                ))
                            }
                            {
                                productor.map((prod, index) => (
                                    <div key={index}>
                                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`PROD${index}`} tabla={"FC_01_anexos"} textLabel={`Documento que demuestre la propiedad del maguey (agave). Predio: ${prod.nombreparaje}`} />
                                    </div>
                                ))
                            } */}

                        </div>
                    </Collapsible>

                </div>
            )
        }
    }

    const comercializadorFisicaFiles = () => {
        if (comercializadorbebidasconmezcal || comercializadormezcal) {
            return (
                <div>
                    {/* <div className={` mb-3 ${estilos.labelNaranjaDocs}`}>
                        <span className=''>Documentación de sus Marcas</span>
                    </div> */}
                    <Collapsible trigger="Agregar documentación de sus Marcas" className='mb-3'>
                        <div className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                marcas.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexo={marca.id} id={`MARCAMEZCAL${index}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} hook={setFile} filesMap={documentacionMarcaMap} />
                                        {
                                            !envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexo={marca.id} id={`MARCAMEZCALCONTRATO${index}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaMap} />
                                        }
                                        {
                                            !productormaguey &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexo={marca.id} id={`MARCAMEZCALCONVENIO${index}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaMap} />
                                        }
                                    </div>
                                ))
                            }
                            {
                                marcasProductoConMezcal.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexo={marca.id} id={`MARCACONMEZCAL${index}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} hook={setFile} filesMap={documentacionMarcaProductoMap} />
                                        {
                                            !envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexo={marca.id} id={`MARCACONMEZCALCONTRATO${index}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaProductoMap} />
                                        }
                                        {
                                            !productormaguey &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexo={marca.id} id={`MARCACONMEZCALCONVENIO${index}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaProductoMap} />
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </Collapsible>

                </div>

            )
        }
    }

    const comercializadorMoralFiles = () => {
        if (comercializadorbebidasconmezcal || comercializadormezcal) {
            return (
                <div>
                    {/* <div className={` mb-3 ${estilos.labelNaranjaDocs}`}>
                        <span className=''>Documentación de sus Marcas</span>
                    </div> */}
                    <Collapsible trigger="Agregar documentación de sus Marcas" className='mb-3'>
                        <div className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                marcas.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexo={marca.id} id={`MARCAMEZCAL${index}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} hook={setFile} filesMap={documentacionMarcaMap} namePK={'idfc01_anexomarcas'} />
                                        {
                                            !envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexo={marca.id} id={`MARCAMEZCALCONTRATO${index}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaMap} />
                                        }
                                        {
                                            !productormaguey &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexo={marca.id} id={`MARCAMEZCALCONVENIO${index}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaMap} />
                                        }
                                    </div>
                                ))
                            }
                            {
                                marcasProductoConMezcal.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexo={marca.id} id={`MARCACONMEZCAL${index}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} hook={setFile} filesMap={documentacionMarcaProductoMap} namePK={'idfc01_anexomarcasproductoconmezcal'} />
                                        {
                                            !envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexo={marca.id} id={`MARCACONMEZCALCONTRATO${index}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaProductoMap} />
                                        }
                                        {
                                            !productormaguey &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexo={marca.id} id={`MARCACONMEZCALCONVENIO${index}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaProductoMap} />
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </Collapsible>
                </div>
            )
        }
    }

    const instalacionesFiles = () => {
        if (productormezcal || envasador || comercializadorbebidasconmezcal || comercializadormezcal) {
            return (
                <div>
                    {/* <div className={` mb-3 ${estilos.labelNaranjaDocs}`}>
                        <span className=''>Documentación de instalaciones</span>
                    </div> */}
                    {/* <Collapsible trigger="Documentación general" className='text-center'></Collapsible> */}
                    <Collapsible trigger="Agregar documentación de instalaciones" className='mb-3'>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                anexoInstalaciones.map((anexo, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <h5 className='text-center' style={{ color: 'black' }}>{anexo.data.tipoInstalacion}</h5>
                                        <ArchivosInstalaciones api={{ handdleFile: handdleFileInstalaciones, handdleRemovePrev: handdleRemovePrevInstalaciones, files: filesInstalaciones }} idAnexo={anexo.data.id} id={`INST${index}`} tabla={"FC_01_anexosInstalacion"} anexo={anexo} filesMap={documentacionInstalacionMap} opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileInstalacion, opcion: opcionFileInstalacion, handdleRemoveOptionFile: handdleRemoveOptionFileInstalacion, deletePrevFile: deletePrevInstalacion }} />
                                        {
                                            anexo.data.responsables.map((responsable, indexR) => (

                                                <>
                                                    <ArchivoComponent api={{ handdleFile: handdleFileInstalaciones, handdleRemovePrev: handdleRemovePrevInstalaciones, files: filesInstalaciones }} idAnexo={responsable.id} id={`INSTREP${index}${indexR}`} tabla={"FC_01_anexosResponsablesInstalacion"} textLabel={`Identificación oficial vigente del responsable: ${responsable.nombreresponsable}`} filesMap={documentacionResponsableMap} />
                                                </>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                            {/* {
                                anexoUnidadProduccion.map((anexo, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosInstalaciones api={{ handdleFile, handdleRemovePrev, files }} id={`UPROD${index}`} tabla={"FC_01_anexosInstalacion"} anexo={anexo} />
                                        {
                                            anexo.data.responsables.map((responsable, index) => (
                                                <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`UPRODREP${index}`} tabla={"FC_01_anexosResponsablesInstalacion"} textLabel={`Identificación oficial vigente del responsable: ${responsable.nombreresponsable}`} />
                                            ))
                                        }
                                    </div>
                                ))
                            }
                            {
                                anexoUnidadEnvasado.map((anexo, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosInstalaciones api={{ handdleFile, handdleRemovePrev, files }} id={`UENV${index}`} tabla={"FC_01_anexosInstalacion"} anexo={anexo} />
                                        {
                                            anexo.data.responsables.map((responsable, index) => (
                                                <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`UENVREP${index}`} tabla={"FC_01_anexosResponsablesInstalacion"} textLabel={`Identificación oficial vigente del responsable: ${responsable.nombreresponsable}`} />
                                            ))
                                        }
                                    </div>
                                ))
                            }
                            {
                                anexoUnidadAlmacen.map((anexo, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosInstalaciones api={{ handdleFile, handdleRemovePrev, files }} id={`UALM${index}`} tabla={"FC_01_anexosInstalacion"} anexo={anexo} />
                                        {
                                            anexo.data.responsables.map((responsable, index) => (
                                                <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`UALMREP${index}`} tabla={"FC_01_anexosResponsablesInstalacion"} textLabel={`Identificación oficial vigente del responsable: ${responsable.nombreresponsable}`} />
                                            ))
                                        }
                                    </div>
                                ))
                            } */}
                        </div>
                    </Collapsible>
                </div>
            )
        }
    }
    const ComprobanteFile = (values) => {
        return (
            <div>
                <Collapsible trigger="Agregar comprobante de pago" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGCP'} tabla={"FC_01_anexos"}
                            textLabel={`Comprobante de pago: `} filesMap={documentacionFC_01Map} comprobantepago={values.comprobantepago} comprobantepagotext={values.comprobantepagotext} />
                    </div>
                </Collapsible>
            </div>
        )


    }

    //MODAL COMPONENT
    const modalComponent = () => {
        return (
            <Fragment>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#FF0000" }}>
                            <center >{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} component="h2">
                            <p className={`${estilos.bodyModal}`}>{bodyModal}</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row col-md-12'>
                            <div className='col-md-6'>
                                <button className={`btn btn-success ${estilos.btnModal}`} type="submit" onClick={() => {
                                    switch (accion) {
                                        case 'enviarBorrador':
                                            enviarBorrador()
                                            break;
                                        case 'guardarBorrador':
                                            guardarBorrador(dataModal)
                                            break;
                                        case 'actualizarBorrador':
                                            actualizarBorrador(dataModal)
                                            break;
                                        case 'reiniciarFormato':
                                            handleResetAllPropertys()
                                            functionResetForm.function()
                                            break;
                                        case 'enviarCorrecciones':
                                            activarBotonEnviarCorreciones()
                                            functionSubmitForm.function()
                                            // handleCloseModal()
                                            // enviarCorrecciones()
                                            break;
                                        case 'cerrarModal':
                                            handleCloseModal()
                                            break;
                                        case 'modalCorrecciones':
                                            handleCloseModal()
                                            break;
                                        case 'enviarSolicitudFC_01':
                                            activarBotonEnviarRegistro()
                                            functionSubmitForm.function()
                                            break;
                                        case 'enviarSolicitudFC_01Borrador':
                                            activarBotonEnviarBorrador()
                                            functionSubmitForm.function()
                                            break;

                                        default:
                                            break;
                                    }
                                }
                                }>CONTINUAR</button>
                            </div>
                            <div className='col-md-6'>
                                <button className={`btn btn-dark ${estilos.btnModal}`} type='button' onClick={() => handleCloseModal()}>CANCELAR</button>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </Fragment>
        )
    }


    const [isValid, setIsValid] = useState(false);
    const [message, setMessage] = useState('');
    const emailRegex = /\S+@\S+\.\S+/;




    const escapeRegExpMatch = function (s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };

    const isExactMatch = (str, match) => {
        return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str)
    }

    //   const escapeRegExpMatch = function(s) {
    //   return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    //   };

    //   const isExactMatch = (str, match) => {
    //   return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str)
    //   }

    const validateEmail = (event) => {

        const email = event.target.value;
        comprobarEmail(email);

    };
    function comprobarEmail(correo) {
        const patron = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/;
        const emailsAceptados = ['@gmail', '@yahoo', '@outlook', '@hotmail'];
        const extensionesAceptadas = ['.mx', '.com', '.es'];

        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;
        if (!correo) {
            setIsValid(false);
            setMessage('Verifica la estructura de tu correo electrónico');
            return
        }
        if (correo.match(emailRegex)) {
            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;


            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                setIsValid(true);
                setMessage('Correo Válido');
            }
            else {
                setIsValid(false);
                setMessage('Verifica la estructura de tu correo electrónico');
            }
        }
        else {
            setIsValid(false);
            setMessage('Verifica la estructura de tu correo electrónico');
        }

    }

    const botonValidarMarcas = (marcas, marcasProductoConMezcal) => {
        let bandera = false
        if (comercializadormezcal === true) {
            if (marcas.length > 0) {
                for (let marca of marcas) {
                    if (marca.marca.length < 1 || marca.numeroderegistroimpi.length < 1
                        || marca.idtipomarca === 0 || marca.idtitularidaddemarca === 0) {
                        bandera = true
                        break;
                    }
                }
            } else {
                bandera = true
                // break;
            }
        }
        if (comercializadorbebidasconmezcal === true) {
            if (marcasProductoConMezcal.length > 0) {
                for (let marca of marcasProductoConMezcal) {
                    if (marca.marca.length < 1 || marca.numeroderegistroimpi.length < 1
                        || marca.idtipomarca === 0 || marca.idtitularidaddemarca === 0) {
                        bandera = true
                        break;
                    }
                }
            } else {
                bandera = true
            }

        }

        return bandera
    }

    const botonValidarDatosGenerales = (mediosDeContacto, representantesLegales, personasAutorizadas) => {
        let bandera = false
        for (let medio of mediosDeContacto) {
            if (medio.telefono.length < 10 || medio.correoelectronico.length < 1 || medio.estado === false) {
                bandera = true
                break;
            }
        }
        for (let representante of representantesLegales) {
            if (representante.representantelegal.length < 1 ||
                representante.correoelectronicorepresentante.length < 1 || representante.telefonorepresentante.length < 10
                || representante.estado.length === false) {
                bandera = true
                break;
            }
        }
        for (let persona of personasAutorizadas) {
            if (persona.personaautoriazadaparatramites.length < 1 ||
                persona.correoelectronicopersona.length < 1 || persona.telefonopersona.length < 10
                || persona.estado.length === false) {
                bandera = true
                break;
            }
        }
        return bandera
    }
    const botonValidarPredios = (predios, productor) => {
        let bandera = false
        if (viverista === true) {
            if (predios.length > 0) {
                for (let predio of predios) {
                    if ((predio.cultivado === false && predio.semicultivado === false && predio.silvestre === false) || predio.nombreparaje.length < 1 || predio.estado.length < 1 || predio.municipio.length < 1 || predio.localidad.length < 1) {
                        bandera = true
                        break;
                    }
                }
            } else {
                bandera = true

            }
        }
        if (productormaguey === true) {
            if (productor.length > 0) {
                for (let producto of productor) {
                    if ((producto.cultivado === false && producto.semicultivado === false && producto.silvestre === false) || producto.nombreparaje.length < 1 || producto.estado.length < 1 || producto.municipio.length < 1 || producto.localidad.length < 1) {
                        bandera = true
                        break;
                    }
                }
            } else {
                bandera = true

            }
        }
        return bandera
    }

    const evaluarPagina = (valores) => {
        if (paginaActiva === 1) {
            if (!valores.opcionTipoInscripcion) { return false }
            if (valores.opcionTipoInscripcion === 'inscrito') {
                if (!valores.opcionTipoInscrito) return false
            }
            /*if (valores.numerosocio) {
                if ((valores.numerosocio + '').length > 4) return false
            }*/
            if (!valores.opcionTipoEmpresa) { return false }
            if (!valores.rfc) {
                return false
            } else {
                // if (!evaluarRFC(valores.rfc)) return false
            }
            if (!valores.nombrerazonsocial) { return false }
            if (!valores.telefono) {
                return false
            } else {
                if ((valores.telefono + '').length !== 10) return false
            }
            if (!valores.correoelectronico) {
                return false
            } else {
                let valido = comprobarEmail(valores.correoelectronico)
                if (!valido) return false
            }
            if (valores.numerohombres < 0 || valores.numerohombres === '' || valores.numerohombres === null) { return false }
            if (valores.numeromujeres < 0 || valores.numeromujeres === '' || valores.numeromujeres === null) { return false }
            if (valores.numerodiscapacitados < 0 || valores.numerodiscapacitados === '' || valores.numerodiscapacitados === null) { return false }
            if (valores.numerobase < 0 || valores.numerobase === '' || valores.numerobase === null) { return false }
            if (valores.numeroeventuales < 0 || valores.numeroeventuales === '' || valores.numeroeventuales === null) { return false }
            if (certificacionsi && !valores.empresacertificadora) { return false }

            if (personamoral || (personafisica && representantelegalsi)) {
                if (!valores.representantelegal) { return false }
                if (!valores.telefonorepresentante) {
                    return false
                } else {
                    if ((valores.telefonorepresentante + '').length !== 10) return false
                }
                if (!valores.correoelectronicorepresentante) {
                    return false
                } else {
                    let valido = comprobarEmail(valores.correoelectronicorepresentante)
                    if (!valido) return false
                }
            }

            if (personafisica) {
                if (!valores.fechadenacimiento) { return false }
                if (discapacidadsi && !valores.tipodiscapacidad) { return false }
                if (lenguaindijenasi && !valores.tipolengua) { return false }
                if (!valores.ocupacion) { return false }
                if (valores.numerohijos < 0 || valores.numerohijos === '') { return false }
                if (!valores.sexo) { return false }
                if (!valores.estadocivil) { return false }
                if (!valores.escolaridad) { return false }
            }
            if (!valores.viverista && !valores.productormaguey && !valores.productormezcal
                && !valores.envasador && !valores.comercializadormezcal &&
                !valores.comercializadorbebidasconmezcal) { return false }

        }
        if (paginaActiva === 2) {
            if (personafisica) {
                if (!valores.estado || valores.estado === '') { return false }
                if (!valores.municipioalcaldia || valores.municipioalcaldia === '') { return false }
                if (!valores.codigopostal || valores.codigopostal === '') { return false }
                if (!valores.localidad || valores.localidad === '') { return false }
                if (!valores.calle || valores.calle === '') { return false }
                else if (valores.calle === 'Otro' && !valores.otracalle) { return false }
                // if (!valores.colonia) { return false }
            }
            if (personamoral) {
                if (!valores.estado || valores.estado === '') { return false }
                if (!valores.municipioalcaldia || valores.municipioalcaldia === '') { return false }
                if (!valores.codigopostal || valores.codigopostal === '') { return false }
                if (!valores.localidad || valores.localidad === '') { return false }
                if (!valores.calle || valores.calle === '') { return false }
                else if (valores.calle === 'Otro' && !valores.otracalle) { return false }
                if (!valores.numeroexterior) { return false }
                // if (!valores.colonia) { return false }
            }
        }


        return true
    }

    function comprobarEmail(correo) {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;
        if (!correo) return false
        if (correo.match(emailRegex)) {

            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;

            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                return true
            } else {
                return false
            }

        } else {
            return false
        }

    }
    function evaluarRFC(rfc) {
        let rfcAux = rfc.toUpperCase();
        if (rfcValido(rfcAux)) {
            if (rfcValido2(rfcAux)) {
                return true
            }
            else {
                return false
            }
        }
        else {
            return false
        }

    }


    const obtenerEstados = async () => {
        //Otener estados
        const result = await dispatch(obtenerEstadosApi())
        return result.payload
    }

    const obtenerCodigosPostales = async (municipio) => {
        //get Codigos Postales por municipio
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerCPsPorMunicipioApi(municipio))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerColonias = async (cp) => {
        //get colonia por CP
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerColoniasPorCpApi(cp))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerLocalidades = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: data.estado, municipio: data.municipio }))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }

    const obtenerCalles = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const clave_estado = await obtenerClaveDomicilioEstado(estadosApi, data.clave_estado)
        const clave_municipio = await obtenerClaveDomicilio(municipiosApi, data.clave_municipio, "municipio")
        const clave_localidad = await obtenerClaveDomicilio(localidadesApi, data.clave_localidad, "localidad")
        const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        await dispatch(actualizarLoadingApp_false())
        // await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({clave_estado: data.clave_estado, clave_municipio: data.clave_municipio, clave_localidad: data.clave_localidad}))
        return result.payload
    }
    const obtenerClaveDomicilioEstado = async (array, key) => {
        for (const i in array) {
            if (array[i][0] === key) return array[i][1]
        }
    }
    const obtenerClaveDomicilio = async (array, key, nombre) => {
        for (const i in array) {
            if (array[i][nombre] === key) return array[i]["clave"]
        }
    }

    const obtenerEstadosConClave = async () => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerEstadosConClaveApi())
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerMunicipiosConClave = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(data))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const [mostrarTexto, setMostrarTexto] = React.useState(false)
    const botonMostrarTexto = async () => {
        if (mostrarTexto === true) {
            setMostrarTexto(false)
        } else {
            setMostrarTexto(true)
        }
    }
    return (
        <Fragment>
            <Formik
                initialValues={fc_01}

                validate={(valores) => {
                    const { ...nuevosValores } = valores
                    let errores = {}
                    const textoError = 'Campo obligratorio'
                    if (paginaActiva === 1) {
                        if (!valores.opcionTipoInscripcion) { errores.opcionTipoInscripcion = textoError }
                        else nuevosValores.opcionTipoInscripcion = valores.opcionTipoInscripcion

                        /*if (valores.numerosocio) {
                            if ((valores.numerosocio + '').length > 4) errores.numerosocio = 'Número de asociado a 4 digitos'
                        }*/
                        if (valores.opcionTipoInscripcion === 'inscrito') {
                            if (!valores.opcionTipoInscrito) errores.opcionTipoInscrito = textoError
                        }
                        if (!valores.opcionTipoEmpresa) { errores.opcionTipoEmpresa = textoError }
                        else {
                            if (valores.opcionTipoEmpresa === 'fisica') {
                                setFisica(true)
                                setMoral(false)
                            } else if (valores.opcionTipoEmpresa === 'moral') {
                                setMoral(true)
                                setFisica(false)
                            } else {
                                setFisica(false)
                                setMoral(false)
                            }
                        }
                        //opcionTipoEmpresa
                        if (!valores.rfc) {
                            errores.rfc = textoError
                        } else {
                            // if(!comprobarRFC(valores.rfc)) errores.rfc = 'El RFC está mal construido. Revisa su estructura'
                        }
                        if (!valores.nombrerazonsocial) { errores.nombrerazonsocial = textoError }

                        if (!valores.telefono) {
                            errores.telefono = textoError
                        } else {
                            if ((valores.telefono + '').length !== 10) errores.telefono = 'Debe contener 10 digitos'
                        }
                        if (!valores.correoelectronico) {
                            errores.correoelectronico = textoError
                        } else {
                            let valido = comprobarEmail(valores.correoelectronico)
                            if (!valido) errores.correoelectronico = 'Verifica la estructura de tu correo electrónico'
                        }
                        if (valores.numerohombres < 0 || valores.numerohombres === '') { errores.numerohombres = textoError }
                        if (valores.numeromujeres < 0 || valores.numeromujeres === '') { errores.numeromujeres = textoError }
                        if (valores.numerodiscapacitados < 0 || valores.numerodiscapacitados === '') { errores.numerodiscapacitados = textoError }
                        if (valores.numerobase < 0 || valores.numerobase === '') { errores.numerobase = textoError }
                        if (valores.numeroeventuales < 0 || valores.numeroeventuales === '') { errores.numeroeventuales = textoError }
                        if (certificacionsi && !valores.empresacertificadora) { errores.empresacertificadora = textoError }

                        if (personamoral || (personafisica && representantelegalsi)) {
                            if (!valores.representantelegal) { errores.representantelegal = textoError }
                            if (!valores.telefonorepresentante) {
                                errores.telefonorepresentante = textoError
                            } else {
                                if ((valores.telefonorepresentante + '').length !== 10) errores.telefonorepresentante = 'Debe contener 10 digitos'
                            }
                            if (!valores.correoelectronicorepresentante) {
                                errores.correoelectronicorepresentante = textoError
                            } else {
                                let valido = comprobarEmail(valores.correoelectronicorepresentante)
                                if (!valido) errores.correoelectronicorepresentante = 'Verifica la estructura de tu correo electrónico'
                            }
                        }

                        if (personafisica) {
                            if (!valores.fechadenacimiento) { errores.fechadenacimiento = textoError }
                            if (discapacidadsi && !valores.tipodiscapacidad) { errores.tipodiscapacidad = textoError }
                            if (lenguaindijenasi && !valores.tipolengua) { errores.tipolengua = textoError }
                            if (!valores.ocupacion) { errores.ocupacion = textoError }
                            if (valores.numerohijos < 0 || valores.numerohijos === '') { errores.numerohijos = textoError }
                            if (!valores.sexo) { errores.sexo = textoError }
                            if (!valores.estadocivil) { errores.estadocivil = textoError }
                            if (!valores.escolaridad) { errores.escolaridad = textoError }
                        }
                        if (!valores.viverista && !valores.productormaguey && !valores.productormezcal
                            && !valores.envasador && !valores.comercializadormezcal &&
                            !valores.comercializadorbebidasconmezcal) { errores.actividadEmpresa = 'Seleccionar mínimo una actividad' }
                        if (valores.viverista) {
                            setViverista(true)
                        } else {
                            setViverista(false)
                        }

                        if (valores.productormaguey) {
                            setPoroductorMaguey(true)
                        } else {
                            setPoroductorMaguey(false)
                        }

                        if (valores.productormezcal) {
                            setProductorMezcal(true)
                        } else {
                            setProductorMezcal(false)
                        }

                        if (valores.envasador) {
                            setEnvasador(true)
                        } else {
                            setEnvasador(false)
                        }

                        if (valores.comercializadormezcal) {
                            setComercializadorMezcal(true)
                        } else {
                            setComercializadorMezcal(false)
                        }

                        if (valores.comercializadorbebidasconmezcal) {
                            setComercializadorBebidas(true)
                        } else {
                            setComercializadorBebidas(false)
                        }

                        guardarActividadesEmpresa()
                    }

                    //PAGINA DOMICILIO FISCAL
                    if (paginaActiva === 2) {
                        if (!valores.estado) {
                            errores.estado = textoError
                        }
                        if (!valores.municipioalcaldia) {
                            errores.municipioalcaldia = textoError
                        }
                        if (!valores.codigopostal) { errores.codigopostal = textoError }
                        if (!valores.localidad) { errores.localidad = textoError }
                        if (!valores.calle) { errores.calle = textoError }
                        else if (valores.calle === 'Otro' && !valores.otracalle) { errores.otracalle = textoError }
                        // if (!valores.colonia) { errores.colonia = textoError }
                        if (personamoral) {
                            if (!valores.numeroexterior) { errores.numeroexterior = textoError }
                        }

                        let domicilioF = {
                            estado: valores.estado,
                            municipioalcaldia: valores.municipioalcaldia,
                            codigopostal: valores.codigopostal,
                            colonia: valores.colonia,
                            localidad: valores.localidad,
                            calle: valores.calle,
                            numeroexterior: valores.numeroexterior,
                            numerointerior: valores.numerointerior,
                            otracalle: valores.otracalle,
                            municipiosApi,
                            codigosPostalesApi,
                            coloniasApi,
                            localidadesApi,
                            callesApi
                        }
                        // if(valores.calle === 'Otro') domicilioF.otracalle = valores.otracalle

                        if (paginaActiva === 2) guardarDomicilioFiscal(domicilioF)
                    }

                    setValores(nuevosValores)
                    return errores
                }}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_01(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorrecciones(valores)
                    }
                    // if(botonEnviarCorrecciones){
                    //     enviarCorrecciones()
                    // }
                    // if(botonActualizarBorrador){
                    //     actualizarBorrador()
                    // }
                }}
            >
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='row ms-1 '>
                            <div>
                                <div className='container'>
                                    <div className='row mt-3'>
                                        <div className='row'>
                                            {/* {
                                                modoCorreccion &&
                                                <div className='text-center'>
                                                    <h6><p style={{ color: 'red' }}><strong>Información y/o documentos a corregir</strong></p></h6>
                                                    <h6><p style={{ color: 'green' }}><strong>Información y/o documentos validados</strong></p></h6>
                                                </div>
                                            } */}
                                            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-12 marginsitoTop">


                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 ">
                                                <h1></h1>
                                            </div>
                                            <div className="input-group mb-3 text-center">
                                                {/* {
                                                    !modoEdicionBorrador &&
                                                    <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 ">
                                                        <h1></h1>
                                                    </div>
                                                }  */}

                                                {
                                                    !modoCorreccion &&
                                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 marginsitoTop">
                                                        <Fragment >
                                                            {/* // <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center " > */}
                                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                                aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                                    botonGuardarComoBorrador(values)}
                                                            >
                                                                <SaveIcon />
                                                                {
                                                                    modoEdicionBorrador ? (
                                                                        <div className="badge text-dark textoModal text-center">
                                                                            Guardar cambios en borrador
                                                                        </div>) : (
                                                                        <div className="badge text-dark textoModal text-center">
                                                                            Guardar borrador
                                                                        </div>
                                                                    )
                                                                }
                                                            </IconButton>

                                                        </Fragment>

                                                    </div>
                                                }
                                                {
                                                    modoCorreccion &&
                                                    (<div className="col-xs-12 col-sm-12 col-md-5 col-lg-2 col-xl-2 marginsitoTop"></div>)
                                                }
                                                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" />
                                                <h1 className='text-end '>Solicitud de inscripción</h1>
                                                {/* <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1" /> */}

                                                {
                                                    (!modoCorreccion && !modoEdicionBorrador) &&
                                                    <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-end marginsitoTop ms-5">
                                                        <Fragment>
                                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                                aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() => { botonReiniciarFormato(), setFunctionResetForm({ function: resetForm }) }}
                                                            >
                                                                <FormatClearIcon />
                                                                <div className="badge text-dark textoModal" >Reiniciar Formato </div>
                                                            </IconButton>
                                                        </Fragment>
                                                    </div>
                                                }
                                                {/* </div> */}
                                                {/* {
                                                    modoEdicionBorrador &&
                                                    <div className='col-md-1 text-end mt-2 ms-2'>
                                                        <button className='badge btn-danger'
                                                            onClick={salirModoEdicionBorrador}>Salir modo edición</button>
                                                    </div>
                                                } */}

                                            </div>

                                        </div>
                                        {/* <button className='mt-2 col-md-2 border-secondary text-center' onClick={botonValidarMarcas(marcas)}>boton de prueba</button> */}
                                    </div>
                                    <div className='row justify-content-start mb-2 text-center'>
                                        <ToolBarPaginas componente='fc_01' paginas={paginas} nombreParaPaginas={nombresParaPaginas} />
                                        <br />
                                    </div>
                                </div>

                                {
                                    nombresParaPaginas[paginaActiva - 1] === 'Datos generales' ?
                                        (
                                            <Fragment>
                                                {/*COMIENZA EL FORMULARIO BONITO */}

                                                <div className='container'>
                                                    {
                                                        modoCorreccion &&
                                                        <div className='text-center'>
                                                            {
                                                                observacionesApartados.countObsDatosGenerales !== 0 ?
                                                                    <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                    :
                                                                    <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                            }
                                                        </div>
                                                    }
                                                    {/* <div className={`col-md-3 ${estilos.divBorderNaranja}`}>
                                            <div>
                                                <h3><i>Quiero inscribirme cómo: </i></h3>
                                            </div>
                                        </div> */}
                                                    {mostrarTexto &&
                                                        <h6 style={{ textAlign: 'justify', fontSize: '12px' }}>
                                                            <strong>CLIENTE ASOCIADO: </strong>
                                                            Son personas físicas o morales que reciben los servicios de Certificación e Inspección por
                                                            parte del COMERCAM, con costos de servicios preferenciales, así mismo tienen voz y voto en las
                                                            asambleas anuales y en la elección de nuestros representantes.
                                                            <br /><br />
                                                            <strong>CLIENTE NO ASOCIADO: </strong>
                                                            Personas físicas o morales extranjeras con actividad en la cadena productiva del Mezcal o propietarias de una marca de Mezcal, que contraten la producción, envasado y comercialización con algún cliente de COMERCAM.
                                                            <br /><br />
                                                            <strong>YA SE ENCUNETRA INSCRITO: </strong>
                                                            Son personas físicas o morales que reciben los servicios de Certificación e Inspección por parte del COMERCAM, que cuentan ya con la certificación y numero de asociado.
                                                        </h6>
                                                    }
                                                    <div className='row mt-4'>
                                                        <div className='row justify-content-start mb-2 mt-4'>
                                                            <div className='col-md-3'>
                                                                <h5 className={`${estilos.textoPregunta}`}>¿Quiero inscribirme cómo?
                                                                    <IconButton
                                                                        sx={{ color: '#c88b3e' }}
                                                                        onClick={botonMostrarTexto}
                                                                    >
                                                                        <HelpOutlineIcon />
                                                                    </IconButton>
                                                                </h5>
                                                            </div>

                                                            <div className={`${values.opcionTipoInscripcion === 'inscrito' ? 'col-md-3' : 'col-md-9'} `}>
                                                                <div className="form-floating mb-2">
                                                                    <select className={`form-control ${fc_01Map.tipoclientecheck !== undefined ? (fc_01Map?.tipoclientecheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        // value={opcionTipoInscripcion}
                                                                        // onChange={e => setTipoInscripcion(e.target.value)}
                                                                        name="opcionTipoInscripcion"
                                                                        value={values.opcionTipoInscripcion}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    >
                                                                        <option value="">Seleccione una opción</option>
                                                                        <option value="asociado">Cliente Asociado</option>
                                                                        <option value="noasociado">Cliente NO Asociado</option>
                                                                        <option value="inscrito">Ya se encuentra inscrito</option>
                                                                    </select>
                                                                    {touched.opcionTipoInscripcion && errors.opcionTipoInscripcion && <div className="text-danger">{errors.opcionTipoInscripcion}</div>}
                                                                    {/* <span className='text-danger'>{fc_01Map?.sexo}</span> */}
                                                                    <span className={`${fc_01Map.tipoclientecheck !== undefined ? (fc_01Map?.tipoclientecheck === true ? 'text-danger' : 'text-success') : ('')}`} >
                                                                        {fc_01Map?.tipoclientecheck === true ? (fc_01Map?.tipocliente) : ''}</span>
                                                                    {/* <label>Quiero inscribirme cómo</label> */}
                                                                </div>

                                                            </div>
                                                            {
                                                                values.opcionTipoInscripcion === 'inscrito' && (<Fragment>
                                                                    <div className='col-md-3'>
                                                                        <div className="form-floating mb-2">
                                                                            <input type="number" className={`form-control ${fc_01Map.tipoclientecheck !== undefined ? (fc_01Map?.tipoclientecheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                // onChange={e => e.target.value.length < 5 ? (setNumeroSocio(e.target.value)) : ''}
                                                                                // placeholder='0'
                                                                                // value={numerosocio}
                                                                                id=""
                                                                                name="numerosocio"
                                                                                value={values.numerosocio}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                onWheel={event => event.currentTarget.blur()}
                                                                            />
                                                                            {touched.numerosocio && errors.numerosocio && <div className="text-danger">{errors.numerosocio}</div>}
                                                                            {/* <span className='text-danger'>{fc_01Map?.numerohijos}</span> */}
                                                                            <label className="floatingInput">Número de Asociado</label>
                                                                            <span className={`${fc_01Map.tipoclientecheck !== undefined ? (fc_01Map?.tipoclientecheck === true ? 'text-danger' : 'text-success') : ('')}`} >
                                                                                {fc_01Map?.tipoclientecheck === true ? (fc_01Map?.tipocliente) : ''}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className={`col-md-3`}>
                                                                        <div className="form-floating mb-2">
                                                                            <select className={`form-control ${fc_01Map.tipoclientecheck !== undefined ? (fc_01Map?.tipoclientecheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                // value={opcionTipoInscripcion}
                                                                                // onChange={e => setTipoInscripcion(e.target.value)}
                                                                                name="opcionTipoInscrito"
                                                                                value={values.opcionTipoInscrito}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            >
                                                                                <option value="">Seleccione una opción</option>
                                                                                <option value="asociado">Cliente Asociado</option>
                                                                                <option value="noasociado">Cliente NO Asociado</option>
                                                                                {/* <option value="inscrito">Ya se encuentra inscrito</option> */}
                                                                            </select>
                                                                            {touched.opcionTipoInscrito && errors.opcionTipoInscrito && <div className="text-danger">{errors.opcionTipoInscrito}</div>}
                                                                            {/* <span className='text-danger'>{fc_01Map?.sexo}</span> */}
                                                                            <span className={`${fc_01Map.tipoclientecheck !== undefined ? (fc_01Map?.tipoclientecheck === true ? 'text-danger' : 'text-success') : ('')}`} >
                                                                                {fc_01Map?.tipoclientecheck === true ? (fc_01Map?.tipocliente) : ''}</span>
                                                                            {/* <label>Quiero inscribirme cómo</label> */}
                                                                        </div>

                                                                    </div>
                                                                </Fragment>)
                                                            }
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className='container'>
                                                    <div className='row mt-3'>
                                                        <div className='row justify-content-start mb-2'>
                                                            <div className='col-md-3 mt-2'>
                                                                <h5 className={`${estilos.textoPregunta}`}>Tipo de empresa</h5>
                                                            </div>
                                                            <div className={`form-floating mb-3 ${(values.opcionTipoEmpresa === 'fisica' || values.opcionTipoEmpresa === 'moral') ? 'col-md-4' : 'col-md-9'}`}>
                                                                <select className={`form-select form-select-sm ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                    // value={opcionTipoEmpresa} onChange={e => setFisicaOMoral(e.target.value)}
                                                                    name="opcionTipoEmpresa"
                                                                    value={values.opcionTipoEmpresa}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                >
                                                                    <option value="">Seleccione una opción</option>
                                                                    <option value="fisica">Persona Física</option>
                                                                    <option value="moral">Persona Moral</option>
                                                                </select>
                                                                {touched.opcionTipoEmpresa && errors.opcionTipoEmpresa && <div className="text-danger">{errors.opcionTipoEmpresa}</div>}
                                                                {/* <span className='text-danger'>{fc_01Map?.sexo}</span> */}
                                                                {/* <label className='ms-2'>Tipo de empresa</label> */}
                                                            </div>
                                                            {
                                                                (values.opcionTipoEmpresa === 'fisica' || values.opcionTipoEmpresa === 'moral') &&
                                                                <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                                    <div className="form-floating mb-3">
                                                                        <input
                                                                            type="text"
                                                                            className={`form-control ${fc_01Map.rfccheck !== undefined ? (fc_01Map?.rfccheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                            // onChange={(e) => {
                                                                            //     setRfc(e.target.value); 
                                                                            //     validarRFC(e);
                                                                            //     handleChange;
                                                                            // }}
                                                                            // value={rfc}
                                                                            id="" placeholder='Registro Federal de Contribuyentes'
                                                                            name="rfc"
                                                                            value={values.rfc}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        <span className={`${fc_01Map.rfccheck !== undefined ? (fc_01Map?.rfccheck === true ? 'text-danger' : 'text-success') : ('')}`} >
                                                                            {fc_01Map?.rfccheck === true ? (fc_01Map?.rfc) : ''}</span>
                                                                        {touched.rfc && errors.rfc && <div className="text-danger">{errors.rfc}</div>}
                                                                        {/* <div className={`message ${isRFCValid ? estilos.success : estilos.error}`}>
                                                                            {validadorRFC}
                                                                        </div> */}

                                                                        <label className="label-black" htmlFor="floatingInput">RFC</label>

                                                                    </div>
                                                                </div>
                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    (values.opcionTipoEmpresa === 'fisica' || values.opcionTipoEmpresa === 'moral') &&
                                                    <div className='container'>
                                                        {/* <div className='row'>
                                            <h4 className='text-center labelNaranja'>Datos del solicitante</h4>
                                        </div> */}
                                                        <div className="row">
                                                            {/* <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'> */}
                                                            <div className='row justify-content-start mb-2'>
                                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                    <div className="form-floating mb-3">
                                                                        <input type="text" id="floatingInput" placeholder="name@example.com"
                                                                            className={`form-control ${fc_01Map.nombrerazonsocialcheck !== undefined ? (
                                                                                fc_01Map?.nombrerazonsocialcheck ? 'inputDenegado' : 'inputValidado') : ('')
                                                                                }`}
                                                                            // onChange={(e) => {
                                                                            //     setNombreRazon(e.target.value)
                                                                            // }}
                                                                            // value={nombrerazonsocial}
                                                                            name="nombrerazonsocial"
                                                                            value={values.nombrerazonsocial}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {touched.nombrerazonsocial && errors.nombrerazonsocial && <div className="text-danger">{errors.nombrerazonsocial}</div>}
                                                                        {/* {errors.nombrerazonsocial && <span className='text-danger'>{errors.nombrerazonsocial.message}</span>} */}
                                                                        {
                                                                            values.opcionTipoEmpresa === 'moral' ?
                                                                                <label className="label-black" htmlFor="floatingInput">Razón social</label>
                                                                                :
                                                                                <label className="label-black" htmlFor="floatingInput">Nombre completo</label>
                                                                        }

                                                                        <span className={`${fc_01Map.nombrerazonsocialcheck !== undefined ? (fc_01Map?.nombrerazonsocialcheck === true ? 'text-danger' : 'text-success') : ('')}`}>
                                                                            {fc_01Map?.nombrerazonsocialcheck === true ? (fc_01Map?.nombrerazonsocial) : ''}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                    <div className="form-floating mb-3">
                                                                        <input type="number" className={`form-control ${fc_01Map.telefonocheck !== undefined ? (
                                                                            fc_01Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')
                                                                            }`}

                                                                            // onChange={e => e.target.value.length < 11 ? (setTelefono(e.target.value)) : ''}
                                                                            // value={telefono}
                                                                            id="Telefono rep legal" placeholder='Teléfono'
                                                                            name="telefono"
                                                                            value={values.telefono}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            onWheel={event => event.currentTarget.blur()}
                                                                        // onKeyDown={"if(e=>comprobarTelefono(e.target.value)) return false"}
                                                                        />
                                                                        {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                                                        <span className={`${fc_01Map.telefonocheck !== undefined ? (fc_01Map?.telefonocheck === true ? 'text-danger' : 'text-success') : ('')}`}>
                                                                            {fc_01Map?.telefonocheck === true ? (fc_01Map?.telefono) : ''}</span>

                                                                        <label className="label-black" htmlFor="floatingInput">Teléfono</label>
                                                                    </div>
                                                                </div>
                                                                < div className='col-md-6'>
                                                                    <div className="form-floating mb-3">
                                                                        <input type="email" className={`form-control ${fc_01Map.correoelectronicocheck !== undefined ? (
                                                                            fc_01Map?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                            // onChange={(e) => {
                                                                            //     setCorreoElectronico(e.target.value);
                                                                            //     validateEmail(e);
                                                                            // }}
                                                                            // value={correoelectronico}
                                                                            id="" placeholder='ejemplo@gmail.com'
                                                                            name="correoelectronico"
                                                                            value={values.correoelectronico}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        <span className={`${fc_01Map.correoelectronicocheck !== undefined ? (fc_01Map?.correoelectronicocheck === true ? 'text-danger' : 'text-success') : ('')}`}>
                                                                            {fc_01Map?.correoelectronicocheck === true ? (fc_01Map?.correoelectronico) : ''}</span>

                                                                        <label className="label-black" htmlFor="floatingInput">Correo electrónico</label>
                                                                        {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                                                        {/* <div className={`message ${isValid ? estilos.success : estilos.error}`}>
                                                                            {message}
                                                                        </div> */}

                                                                    </div>
                                                                </div>
                                                                <TelefonoYCorreo componente='fc_01' mediosDeContacto={mediosDeContacto} hookMediosDeContacto={setMediosDeContacto} />
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <h4 className='text-center labelNaranja'>¿Cuentas con alguna certificación?
                                                                <IconButton
                                                                    sx={{ color: '#FFFFFF' }}
                                                                >
                                                                    <Tooltip position='top' title='Ejemplo: Certificacion con CERTIMEX, Kosher, etc.'>
                                                                        <HelpOutlineIcon />
                                                                    </Tooltip>
                                                                </IconButton>
                                                                <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                                <input className={`ms-2 mt-2 form-check-input ${fc_01Map.empresacertificadoracheck !== undefined ? (
                                                                    fc_01Map?.empresacertificadoracheck ? 'inputDenegado'
                                                                        : 'inputValidado') : ('')}`}
                                                                    type="checkbox" onChange={e => setCertificacionSiNo(e.target)}
                                                                    checked={certificacionsi} id="si" />
                                                                <label className="ms-5 texto-blanco">No</label>
                                                                <input className={`ms-2 mt-2 form-check-input ${fc_01Map.empresacertificadoracheck !== undefined ? (
                                                                    fc_01Map?.empresacertificadoracheck ? 'inputDenegado'
                                                                        : 'inputValidado') : ('')}`}
                                                                    type="checkbox" onChange={e => setCertificacionSiNo(e.target)}
                                                                    checked={certificacionno} id="no" />
                                                            </h4>
                                                        </div>
                                                        {
                                                            (certificacionsi) &&
                                                            <div className='col-md-12'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_01Map.empresacertificadoracheck !== undefined ? (
                                                                        fc_01Map?.empresacertificadoracheck ? 'inputDenegado'
                                                                            : 'inputValidado') : ('')}`}
                                                                        // onChange={e => setempresacertificadora(e.target.value)}
                                                                        //     value={empresacertificadora}
                                                                        id="Nombre rep legal" placeholder='Nombre'
                                                                        name="empresacertificadora"
                                                                        value={values.empresacertificadora}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {/* <span className='text-danger'>{fc_01Map?.representantelegal}</span> */}
                                                                    {touched.empresacertificadora && errors.empresacertificadora && <div className="text-danger">{errors.empresacertificadora}</div>}
                                                                    <label className="floatingInput">Nombre de la empresa certificadora</label>
                                                                    <span className={`${fc_01Map.empresacertificadoracheck !== undefined ? (fc_01Map?.empresacertificadoracheck === true ? 'text-danger' : 'text-success') : ('')}`}>
                                                                        {fc_01Map?.empresacertificadoracheck === true ? (fc_01Map?.empresacertificadora) : ''}</span>
                                                                </div>
                                                            </div>
                                                        }

                                                        <br></br>
                                                        <div className='row justify-content-start mb-2'>
                                                            {
                                                                values.opcionTipoEmpresa === 'fisica' ?
                                                                    <h4 className='text-center labelNaranja me-5'>¿Desea agregar un apoderado legal?
                                                                        <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                                        <input className={`ms-2 form-check-input ${fc_01Map.representantelegalcheck !== undefined ? (
                                                                            fc_01Map?.representantelegalcheck ? 'inputDenegado'
                                                                                : 'inputValidado') : ('')}`}
                                                                            type="checkbox" onChange={e => setAgregarRepresentanteLegalSiNo(e.target)}
                                                                            checked={representantelegalsi} id="si" />
                                                                        <label className="ms-5 texto-blanco ">No</label>
                                                                        <input className={`ms-2 form-check-input ${fc_01Map.representantelegalcheck !== undefined ? (
                                                                            fc_01Map?.representantelegalcheck ? 'inputDenegado'
                                                                                : 'inputValidado') : ('')}`}
                                                                            type="checkbox" onChange={e => setAgregarRepresentanteLegalSiNo(e.target)}
                                                                            checked={representantelegalno} id="no" />
                                                                    </h4>
                                                                    :
                                                                    <h4 className='text-center labelNaranja'>Representante legal</h4>
                                                            }
                                                            <br></br>
                                                            {/* Coleccion de representantes legales, (nuevo requerimiento) */}
                                                            {
                                                                (representantelegalsi || values.opcionTipoEmpresa === 'moral') &&
                                                                <div className='row'>
                                                                    < div className='col-md-12'>
                                                                        <div className="form-floating mb-3">
                                                                            <input type="text" className={`form-control ${fc_01Map.representantelegalcheck !== undefined ? (
                                                                                fc_01Map?.representantelegalcheck ? 'inputDenegado'
                                                                                    : 'inputValidado') : ('')}`}
                                                                                //     onChange={e => setNombreLegal(e.target.value)}
                                                                                // value={representantelegal}
                                                                                id="Nombre rep legal" placeholder='Nombre'
                                                                                name="representantelegal"
                                                                                value={values.representantelegal}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            {touched.representantelegal && errors.representantelegal && <div className="text-danger">{errors.representantelegal}</div>}
                                                                            <span className={`${fc_01Map.representantelegalcheck !== undefined ? (fc_01Map?.representantelegalcheck === true ? 'text-danger' : 'text-success') : ('')}`}>
                                                                                {fc_01Map?.representantelegalcheck === true ? (fc_01Map?.representantelegal) : ''}</span>

                                                                            <label className="label-dark" htmlFor="floatingInput">Nombre completo</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className="form-floating mb-3">
                                                                            <input type="number" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                                // onChange={e => e.target.value.length < 11 ? (setTelefonoLegal(e.target.value)) : ''}
                                                                                // value={telefonorepresentante}
                                                                                id="Telefono rep legal" placeholder='Teléfono'
                                                                                name="telefonorepresentante"
                                                                                value={values.telefonorepresentante}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                onWheel={event => event.currentTarget.blur()}
                                                                            />
                                                                            {touched.telefonorepresentante && errors.telefonorepresentante && <div className="text-danger">{errors.telefonorepresentante}</div>}
                                                                            {/* <span className='text-danger'>{fc_01Map?.telefonorepresentante}</span> */}

                                                                            <label className="label-dark" htmlFor="floatingInput">Teléfono</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className="form-floating mb-3">
                                                                            <input type="email"
                                                                                className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                                // onChange={e =>
                                                                                //     correoLegal(e.target.value)
                                                                                // }
                                                                                // value={correoelectronicorepresentante}
                                                                                id="correo rep legal" placeholder='Correo'
                                                                                name="correoelectronicorepresentante"
                                                                                value={values.correoelectronicorepresentante}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            {touched.correoelectronicorepresentante && errors.correoelectronicorepresentante && <div className="text-danger">{errors.correoelectronicorepresentante}</div>}
                                                                            {/* <span className='text-danger'>{fc_01Map?.correoelectronicorepresentante}</span> */}

                                                                            <label className="label-dark" htmlFor="floatingInput">Correo electrónico</label>
                                                                            {/* <div className={`message ${isValidEmailLegal ? estilos.success : estilos.error}`}>
                                                                                {isValidEmailLegal ? `Correo Válido` : `Verifique la estructura de su correo`}
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                    {/* <ArchivoComponent textLabel="Identificación oficial vigente" /> */}
                                                                    {
                                                                        personamoral &&
                                                                        <div>
                                                                            <hr />
                                                                            <div className='col-md-12'>
                                                                                <h4 className='text-center'>Apoderados legales</h4>
                                                                            </div>
                                                                            {
                                                                                representantesLegales.map((inputField, index) => (
                                                                                    <div key={index} className={'row'}>
                                                                                        < div className='col-md-12'>
                                                                                            <div className="form-floating mb-3">
                                                                                                <input type="text" className={`form-control ${representantesLegalesMap?.filter(map => map.idfc01_anexorepresentantelegal
                                                                                                    === inputField.idfc01_anexorepresentantelegal)[0]?.representantelegalcheck !== undefined ? (
                                                                                                    representantesLegalesMap?.filter(map => map.idfc01_anexorepresentantelegal
                                                                                                        === inputField.idfc01_anexorepresentantelegal)[0]?.representantelegalcheck ? 'inputDenegado'
                                                                                                        : 'inputValidado') : ('')}`}
                                                                                                    onChange={e => handleOnChangueRepresentanteLegal(
                                                                                                        {
                                                                                                            valor: e.target.value,
                                                                                                            id: inputField.id,
                                                                                                            campo: 'representantelegal'
                                                                                                        })}
                                                                                                    value={inputField.representantelegal}
                                                                                                    id="Nombre rep legal" placeholder='Nombre'
                                                                                                />
                                                                                                <span className={`${representantesLegalesMap?.filter(map => map.idfc01_anexorepresentantelegal
                                                                                                    === inputField.idfc01_anexorepresentantelegal)[0]?.representantelegalcheck !== undefined ? (
                                                                                                    representantesLegalesMap?.filter(map => map.idfc01_anexorepresentantelegal
                                                                                                        === inputField.idfc01_anexorepresentantelegal)[0]?.representantelegalcheck ? 'text-danger'
                                                                                                        : 'text-success') : ('')}`}>
                                                                                                    {representantesLegalesMap?.filter(map => map.idfc01_anexorepresentantelegal
                                                                                                        === inputField.idfc01_anexorepresentantelegal)[0]?.representantelegalcheck ?
                                                                                                        (representantesLegalesMap?.filter(map => map.idfc01_anexorepresentantelegal
                                                                                                            === inputField.idfc01_anexorepresentantelegal)[0]?.representantelegal) : ''
                                                                                                    }</span>

                                                                                                <label className="label-dark" htmlFor="floatingInput">Nombre completo</label>
                                                                                                {inputField.representantelegal.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                                            <div className="form-floating mb-3">
                                                                                                <input type="number" className={`form-control ${representantesLegalesMap.length > 0 ? ('inputValidado') : ('')}`}
                                                                                                    onChange={e => e.target.value.length < 11 ? (
                                                                                                        handleOnChangueRepresentanteLegal(
                                                                                                            {
                                                                                                                valor: e.target.value,
                                                                                                                id: inputField.id,
                                                                                                                campo: 'telefonorepresentante'
                                                                                                            })) : ''}
                                                                                                    value={inputField.telefonorepresentante}
                                                                                                    id="Telefono rep legal" placeholder='Teléfono'
                                                                                                    onWheel={event => event.currentTarget.blur()}
                                                                                                />
                                                                                                {/* <span className='text-danger'>{fc_01Map?.telefonorepresentante}</span> */}

                                                                                                <label className="label-dark" htmlFor="floatingInput">Teléfono</label>
                                                                                                {inputField.telefonorepresentante.length < 10 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                                                            <div className="form-floating mb-3">
                                                                                                <input type="email"
                                                                                                    className={`form-control ${representantesLegalesMap.length > 0 ? ('inputValidado') : ('')}`}
                                                                                                    onChange={e => handleOnChangueRepresentanteLegal(
                                                                                                        {
                                                                                                            valor: e.target.value,
                                                                                                            id: inputField.id,
                                                                                                            campo: 'correoelectronicorepresentante'
                                                                                                        })}
                                                                                                    value={inputField.correoelectronicorepresentante}
                                                                                                    id="correo rep legal" placeholder='Correo'
                                                                                                />
                                                                                                {/* <span className='text-danger'>{fc_01Map?.correoelectronicorepresentante}</span> */}

                                                                                                {/* <label className="label-dark" htmlFor="floatingInput">Correo</label> */}
                                                                                                <label className="floatingInput">Correo electrónico</label>
                                                                                                {inputField.correoelectronicorepresentante.length < 10 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                                <div key={index} className={`message ${inputField.estado ? estilos.success : estilos.error}`}>
                                                                                                    {inputField.estado ? `Correo Válido` : `Verifique la estructura de su correo`}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        {
                                                                                            !modoCorreccion &&
                                                                                            <div className='col-md-1 text-center'>
                                                                                                {/* <button className='botonEliminarAnexo col-md-2' onClick={e =>
                                                                                            deleteRepresentanteLegal(inputField)} id={inputField.id}>Eliminar</button> */}
                                                                                                <ModalComponent api={{ deleteAnexo: deleteRepresentanteLegal, inputField }} text="un apoderado legal" />
                                                                                            </div>
                                                                                        }
                                                                                        <hr />
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                            {
                                                                                !modoCorreccion &&
                                                                                <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                                                    <button className='botonAgregarAnexo col-md-3' onClick={e =>
                                                                                        handleAddRepresentanteLegal()}>Agregar apoderado legal</button>
                                                                                </div>
                                                                            }


                                                                        </div>
                                                                    }
                                                                </div>
                                                            }

                                                            {/* <div className="row" style={{ marginLeft: '5%' }}> */}


                                                            {/* </div> */}

                                                        </div>

                                                        {
                                                            personafisica &&
                                                            <div className='row justify-content-start mb-2'>
                                                                <div className='row'>
                                                                    <h4 className='text-center labelNaranja'>Información personal
                                                                    </h4>
                                                                </div>
                                                                <hr>
                                                                </hr>

                                                                <div className='col-md-6'>
                                                                    <div className="form-floating mb-3">
                                                                        <input type="date" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                            //     onChange={e =>
                                                                            //         setFechaNacimientoPersona(e.target.value)}
                                                                            // value={fechadenacimiento}
                                                                            max={fechaParaMayorEdad}
                                                                            id="fechanacimiento" placeholder='Fecha de nacimiento'
                                                                            name="fechadenacimiento"
                                                                            value={values.fechadenacimiento}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {touched.fechadenacimiento && errors.fechadenacimiento && <div className="text-danger">{errors.fechadenacimiento}</div>}

                                                                        <label className="floatingInput">Fecha de nacimiento</label>

                                                                    </div>
                                                                </div>


                                                                {/* <div className='col-md-6'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_01Map.sexocheck !== undefined ? (
                                                            fc_01Map?.setsexocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            onChange={e => setSexoPersona(e.target.value)}
                                                            value={sexo}
                                                            id="Sexo" placeholder='Masculino/Femenino'
                                                        />
                                                        <span className='text-danger'>{fc_01Map?.sexo}</span>

                                                        <label className="floatingInput">Género</label>
                                                    </div>
                                                </div> */}
                                                                <div className='col-md-6'>
                                                                    <div className="form-floating mb-3">
                                                                        <select className={`form-select form-select-sm ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                            // value={sexo} 
                                                                            // onChange={e => setSexoPersona(e.target.value)}
                                                                            name="sexo"
                                                                            value={values.sexo}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        >
                                                                            <option value="">Seleccione género</option>
                                                                            <option value="Masculino">Masculino</option>
                                                                            <option value="Femenino">Femenino</option>
                                                                        </select>
                                                                        {touched.sexo && errors.sexo && <div className="text-danger">{errors.sexo}</div>}
                                                                        {/* <span className='text-danger'>{fc_01Map?.sexo}</span> */}
                                                                        <label className="label-dark" htmlFor="floatingInput">Género</label>
                                                                    </div>
                                                                </div>
                                                                {/* <div className='col-md-6'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_01Map.estadocivilcheck
                                                            !== undefined ? (fc_01Map?.estadocivilcheck ? 'inputDenegado' : 'inputValidado'
                                                        ) : ('')}`} onChange={e => setEstadoCivilPersona(e.target.value)}
                                                            value={estadocivil}
                                                            id="Estado civil" placeholder='Estado civil'
                                                        />
                                                        <span className='text-danger'>{fc_01Map?.estadocivil}</span>

                                                        <label className="floatingInput">Estado civil</label>

                                                    </div>
                                                </div> */}
                                                                <div className='col-md-6'>
                                                                    <div className="form-floating mb-3">
                                                                        <select className={`form-select form-select-sm ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                            // value={estadocivil} onChange={e => setEstadoCivilPersona(e.target.value)}
                                                                            name="estadocivil"
                                                                            value={values.estadocivil}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        >
                                                                            <option value="">Seleccione estado civil</option>
                                                                            <option value="Soltero">Soltero</option>
                                                                            <option value="Casado">Casado</option>
                                                                            <option value="Divorciado">Divorciado</option>
                                                                            <option value="Viudo">Viudo</option>
                                                                            <option value="Concubinato">Concubinato</option>
                                                                        </select>
                                                                        {touched.estadocivil && errors.estadocivil && <div className="text-danger">{errors.estadocivil}</div>}
                                                                        {/* <span className='text-danger'>{fc_01Map?.estadocivil}</span> */}
                                                                        <label className="floatingInput">Estado civil</label>
                                                                    </div>
                                                                </div>
                                                                {/* <div className='col-md-6'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_01Map.escolaridadcheck
                                                            !== undefined ? (fc_01Map?.escolaridadcheck ? 'inputDenegado' : 'inputValidado'
                                                        ) : ('')}`} onChange={e => setEscolaridadPersona(e.target.value)}
                                                            value={escolaridad}
                                                            id="Escolaridad" placeholder='Escolaridad'
                                                        />
                                                        <span className='text-danger'>{fc_01Map?.escolaridad}</span>

                                                        <label className="floatingInput">Escolaridad</label>

                                                    </div>
                                                </div> */}
                                                                <div className='col-md-6'>
                                                                    <div className="form-floating mb-3">
                                                                        <select className={`form-select form-select-sm ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                            // value={escolaridad} onChange={e => setEscolaridadPersona(e.target.value)}
                                                                            name="escolaridad"
                                                                            value={values.escolaridad}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        >
                                                                            <option value="">Seleccione su escolaridad</option>
                                                                            <option value="Educación preescolar">Educación preescolar</option>
                                                                            <option value="Educación primaria">Educación primaria</option>
                                                                            <option value="Educación secundaria">Educación secundaria</option>
                                                                            <option value="Educación media superior">Educación media superior</option>
                                                                            <option value="Educación superior">Educación superior</option>
                                                                        </select>
                                                                        {touched.escolaridad && errors.escolaridad && <div className="text-danger">{errors.escolaridad}</div>}
                                                                        {/* <span className='text-danger'>{fc_01Map?.escolaridad}</span> */}
                                                                        <label className="floatingInput">Escolaridad</label>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <label className="ms-1 label-blanco">Padece alguna discapacidad</label>
                                                                    <label className="ms-3 label-blanco">Si</label>
                                                                    <input className={`ms-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                        type="checkbox" onChange={e => setDiscapacidadSiNo(e.target)}
                                                                        checked={discapacidadsi} id="si" />
                                                                    <span className='text-danger'>{fc_01Map?.tipodiscapacidad}</span>
                                                                    <label className="ms-3 label-blanco">No</label>
                                                                    <input className={`ms-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                        type="checkbox" onChange={e => setDiscapacidadSiNo(e.target)}
                                                                        checked={discapacidadno} id="no" />
                                                                    {/* <span className='text-danger'>{fc_01Map?.tipodiscapacidad}</span> */}
                                                                    {
                                                                        discapacidadsi &&
                                                                        <div className="form-floating mb-3">
                                                                            <input type="text" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                                //     onChange={e =>
                                                                                //         setTipoDiscapacidad(e.target.value)}
                                                                                // value={tipodiscapacidad}
                                                                                id="" placeholder='Tipo de discapacidad'
                                                                                name="tipodiscapacidad"
                                                                                value={values.tipodiscapacidad}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                disabled={discapacidadno} />
                                                                            {touched.tipodiscapacidad && errors.tipodiscapacidad && <div className="text-danger">{errors.tipodiscapacidad}</div>}
                                                                            {/* <span className='text-danger'>{fc_01Map?.tipodiscapacidad}</span> */}

                                                                            <label className="floatingInput">Tipo de discapacidad:</label>
                                                                        </div>
                                                                    }

                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <label className="ms-1 label-blanco">Habla alguna lengua indígena</label>
                                                                    <label className="ms-3 label-blanco">Si</label>
                                                                    <input className={`ms-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                        type="checkbox" onChange={e => setLenguaSiNo(e.target)}
                                                                        checked={lenguaindijenasi} id="si" />
                                                                    <span className='text-danger'>{fc_01Map?.tipolengua}</span>
                                                                    <label className="ms-3 label-blanco">No</label>
                                                                    <input className={`ms-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                        type="checkbox" onChange={e => setLenguaSiNo(e.target)}
                                                                        checked={lenguaindijenano} id="no" />
                                                                    {/* <span className='text-danger'>{fc_01Map?.tipolengua}</span> */}
                                                                    {
                                                                        lenguaindijenasi &&
                                                                        <div className="form-floating mb-3">
                                                                            <input type="text" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                                // onChange={e => setTipoLengua(e.target.value)}
                                                                                // value={tipolengua}
                                                                                id="" placeholder='¿Cual?'
                                                                                name="tipolengua"
                                                                                value={values.tipolengua}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                disabled={lenguaindijenano} />
                                                                            {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                                                            {/* <span className='text-danger'>{fc_01Map?.tipolengua}</span> */}

                                                                            <label className="floatingInput">Lengua indígena:</label>

                                                                        </div>}
                                                                </div>
                                                                <div className='col-md-9'>
                                                                    {(!discapacidadsi && !lenguaindijenasi) && <br />}
                                                                    <div className="form-floating mb-3">
                                                                        <input type="text" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                            // onChange={e => setOcupacionPersona(e.target.value)}
                                                                            // value={ocupacion}
                                                                            id="" placeholder='¿Cual?'
                                                                            name="ocupacion"
                                                                            value={values.ocupacion}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {touched.ocupacion && errors.ocupacion && <div className="text-danger">{errors.ocupacion}</div>}
                                                                        {/* <span className='text-danger'>{fc_01Map?.ocupacion}</span> */}
                                                                        <label className="floatingInput">Ocupación</label>
                                                                    </div>
                                                                </div>

                                                                <div className='col-md-3'>
                                                                    {(!discapacidadsi && !lenguaindijenasi) && <br />}
                                                                    <div className="form-floating mb-3 inputConFlechaVisible">
                                                                        <input type="number" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                            // onChange={e => setNumeroHijos(e.target.valueAsNumber)}
                                                                            placeholder='0'
                                                                            // value={numerohijos}
                                                                            id=""
                                                                            name="numerohijos"
                                                                            value={values.numerohijos}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            onWheel={event => event.currentTarget.blur()}
                                                                        />
                                                                        {touched.numerohijos && errors.numerohijos && <div className="text-danger">{errors.numerohijos}</div>}
                                                                        {/* <span className='text-danger'>{fc_01Map?.numerohijos}</span> */}
                                                                        <label className="floatingInput">Número de hijos</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        <div className="row">
                                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center'>

                                                                <div className='row'>
                                                                    <h4 className='text-center labelNaranja'>¿Desea agregar personas autorizadas para trámites?
                                                                        <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                                        <input className={`ms-2 form-check-input ${modoCorreccion && 'inputValidado'}`}
                                                                            type="checkbox" onChange={e => setAgregarPersonaAutorizadaSiNo(e.target)}
                                                                            checked={personaautorizadasi} id="si" />
                                                                        <label className="ms-5 texto-blanco">No</label>
                                                                        <input className={`ms-2 form-check-input ${modoCorreccion && 'inputValidado'}`}
                                                                            type="checkbox" onChange={e => setAgregarPersonaAutorizadaSiNo(e.target)}
                                                                            checked={personaautorizadano} id="no" />
                                                                    </h4>
                                                                </div><br></br>
                                                                {
                                                                    personaautorizadasi &&
                                                                    personasAutorizadas.map((inputField, index) => (
                                                                        <div key={index} className='row'>
                                                                            <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 text-center'>
                                                                                <div className="form-floating mb-3">
                                                                                    <input type="text"

                                                                                        className={`form-control ${personasAutorizadasMap?.filter(map => map?.idfc01_anexopersonaatorizadatramites
                                                                                            === inputField.idfc01_anexopersonaatorizadatramites)[0]?.personaautoriazadaparatramitescheck !== undefined ? (
                                                                                            personasAutorizadasMap?.filter(map => map.idfc01_anexopersonaatorizadatramites
                                                                                                === inputField.idfc01_anexopersonaatorizadatramites)[0]?.personaautoriazadaparatramitescheck ? 'inputDenegado'
                                                                                                : 'inputValidado') : ('')}`}

                                                                                        onChange={e =>
                                                                                            handleOnChanguePersonaAut(
                                                                                                {
                                                                                                    valor: e.target.value,
                                                                                                    id: inputField.id,
                                                                                                    campo: 'personaautoriazadaparatramites'
                                                                                                })}
                                                                                        value={inputField.personaautoriazadaparatramites}
                                                                                        id="" placeholder='Nombre'
                                                                                    />
                                                                                    <label className="label-dark" htmlFor="floatingInput">Nombre completo</label>
                                                                                    <span className={`${personasAutorizadasMap?.filter(map => map.idfc01_anexopersonaatorizadatramites
                                                                                        === inputField.idfc01_anexopersonaatorizadatramites)[0]?.personaautoriazadaparatramitescheck !== undefined ? (
                                                                                        personasAutorizadasMap?.filter(map => map.idfc01_anexopersonaatorizadatramites === inputField.idfc01_anexopersonaatorizadatramites)[0]?.personaautoriazadaparatramitescheck ? 'text-danger'
                                                                                            : 'text-success') : ('')}`}>
                                                                                        {personasAutorizadasMap?.filter(map => map.idfc01_anexopersonaatorizadatramites
                                                                                            === inputField.idfc01_anexopersonaatorizadatramites)[0]?.personaautoriazadaparatramitescheck ? (
                                                                                            personasAutorizadasMap?.filter(map => map.idfc01_anexopersonaatorizadatramites
                                                                                                === inputField.idfc01_anexopersonaatorizadatramites)[0]?.personaautoriazadaparatramites
                                                                                        ) : ''
                                                                                        }</span>
                                                                                    {inputField.personaautoriazadaparatramites.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                </div>

                                                                            </div>
                                                                            <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center'>
                                                                                <div className="form-floating mb-3">
                                                                                    <input type="number"
                                                                                        className={`form-control ${personasAutorizadasMap.length > 0 ? ('inputValidado') : ('')}`}
                                                                                        onChange={e => e.target.value.length < 11 ? (
                                                                                            handleOnChanguePersonaAut(
                                                                                                {
                                                                                                    valor: e.target.value,
                                                                                                    id: inputField.id,
                                                                                                    campo: 'telefonopersona'
                                                                                                })) : ''}
                                                                                        value={inputField.telefonopersona}
                                                                                        id="" placeholder='Telefono'
                                                                                        onWheel={event => event.currentTarget.blur()}
                                                                                    />
                                                                                    <label className="label-dark" htmlFor="floatingInput">Teléfono</label>
                                                                                    <span
                                                                                        className='text-danger'>{personasAutorizadasMap?.filter(map => map.idfc01_anexopersonaatorizadatramites
                                                                                            === inputField.idfc01_anexopersonaatorizadatramites)[0]?.telefonopersona}</span>
                                                                                    {inputField.telefonopersona.length < 10 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                </div>

                                                                            </div>
                                                                            <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center'>
                                                                                <div className="form-floating mb-3">
                                                                                    <input type="email"
                                                                                        className={`form-control ${personasAutorizadasMap.length > 0 ? ('inputValidado') : ('')}`}
                                                                                        onChange={e =>
                                                                                            handleOnChanguePersonaAut(
                                                                                                {
                                                                                                    valor: e.target.value,
                                                                                                    id: inputField.id,
                                                                                                    campo: 'correoelectronicopersona'
                                                                                                })
                                                                                        }
                                                                                        value={inputField.correoelectronicopersona}
                                                                                        id="" placeholder='Correo'
                                                                                    />
                                                                                    <label className="floatingInput">Correo electrónico</label>
                                                                                    <div key={index} className={`message ${inputField.estado ? estilos.success : estilos.error}`}>
                                                                                        {inputField.estado ? `Correo Válido` : `Verifique la estructura de su correo`}
                                                                                    </div>
                                                                                    <span className='text-danger'>{personasAutorizadasMap?.filter(map => map.idfc01_anexopersonaatorizadatramites
                                                                                        === inputField.idfc01_anexopersonaatorizadatramites)[0]?.correoelectronicopersona}</span>
                                                                                    {inputField.correoelectronicopersona.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                !modoCorreccion &&
                                                                                (
                                                                                    <div className='col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 text-center'>
                                                                                        {/* <button className='btn btn-lg btn-danger' onClick={e =>
                                                                                deletePersonaAutorizada(inputField)}>Eliminar</button> */}
                                                                                        <ModalComponent api={{ deleteAnexo: deletePersonaAutorizada, inputField }} text="una persona autorizada" />
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className='row justify-content-start'>
                                                            {
                                                                (!modoCorreccion && personaautorizadasi) &&
                                                                // <div align="center">
                                                                //     <IconButton sx={{ color: '#c88b3e' }} size="xl" edge="end"
                                                                //         aria-label="Agregar persona autorizada" onClick={handleAddPersonaAut}>
                                                                //         <AddCircleIcon />
                                                                //     </IconButton>
                                                                // </div>
                                                                <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                                    <button className='botonAgregarAnexo col-md-3' onClick={e =>
                                                                        handleAddPersonaAut()}>Agregar persona autorizada</button>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className='row'>
                                                            <h3 className='labelNaranja'><i>Actividad de la empresa dentro de la cadena productiva Maguey-Mezcal</i>
                                                            </h3>
                                                            <div className={`row text-center ${estilos.divSoloBorderNaranja}`}>
                                                                <div className='row text-center'>
                                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                                                        <input className={`form-check-input me-3 escalar ${fc_01Map.cadenaproductivacheck !== undefined ? (
                                                                            fc_01Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                            type="checkbox"
                                                                            // onChange={e => setViverista(e.target.checked)}
                                                                            checked={values.viverista} id="noAsociado"
                                                                            name="viverista"
                                                                            value={values.viverista}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {/* <FontAwesomeIcon icon={faClover} className={` ${estilos.escalarx2} ${estilos.logoNaranja} me-4`} /> */}
                                                                        <span className='text-danger'>{fc_01Map?.viverista}</span>
                                                                        <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                                            <h5>Viverista</h5>
                                                                        </label>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                                        <input className={`form-check-input me-3 escalar ${fc_01Map.cadenaproductivacheck !== undefined ? (
                                                                            fc_01Map?.cadenaproductivacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                            type="checkbox"
                                                                            // onChange={e => setPoroductorMaguey(e.target.checked)}
                                                                            checked={values.productormaguey} id="noAsociado"
                                                                            name="productormaguey"
                                                                            value={values.productormaguey}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {/* <FontAwesomeIcon icon={faHandSpock} className={` ${estilos.escalarx2} ${estilos.logoNaranja} me-4`} /> */}
                                                                        <span className='text-danger'>{fc_01Map?.productormaguey}</span>
                                                                        <label className="form-check-label border-secondary"
                                                                            htmlFor="flexCheckChecked">
                                                                            <h5>Productor de maguey</h5>
                                                                        </label>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                                        <input className={`form-check-input me-3 escalar ${fc_01Map.cadenaproductivacheck !== undefined ? (
                                                                            fc_01Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                            type="checkbox"
                                                                            // onChange={e => setProductorMezcal(e.target.checked)}
                                                                            checked={values.productormezcal} id="noAsociado"
                                                                            name="productormezcal"
                                                                            value={values.productormezcal}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {/* <FontAwesomeIcon icon={faWineBottle} className={` ${estilos.escalarx2} ${estilos.logoNaranja} me-4`} /> */}
                                                                        {/* <span className='text-danger'>{fc_01Map?.productormezcal}</span> */}


                                                                        <label className="form-check-label border-secondary"
                                                                            htmlFor="flexCheckChecked">
                                                                            <h5>Productor de mezcal</h5>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className='row' style={{ paddingTop: '3%' }}>
                                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                                                        <input className={`form-check-input me-3 escalar ${fc_01Map.cadenaproductivacheck !== undefined ? (
                                                                            fc_01Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                            type="checkbox"
                                                                            //     onChange={e => setEnvasador(e.target.checked)}
                                                                            checked={values.envasador} id="noAsociado"
                                                                            name="envasador"
                                                                            value={values.envasador}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}

                                                                        />
                                                                        {/* <FontAwesomeIcon icon={faBoxOpen} className={` ${estilos.escalarx2} ${estilos.logoNaranja} me-4`} /> */}
                                                                        <span className='text-danger'>{fc_01Map?.envasador}</span>


                                                                        <label className="form-check-label me-4 text-center"
                                                                            htmlFor="flexCheckChecked">
                                                                            <h5 className='text-center'>Envasador</h5>
                                                                        </label>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                                                        <input className={`form-check-input me-3 escalar ${fc_01Map.cadenaproductivacheck !== undefined ? (
                                                                            fc_01Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                            type="checkbox"
                                                                            // onChange={e => setComercializadorMezcal(e.target.checked)}
                                                                            checked={values.comercializadormezcal} id="noAsociado"
                                                                            name="comercializadormezcal"
                                                                            value={values.comercializadormezcal}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        <label className="form-check-label me-4" htmlFor="flexCheckChecked">
                                                                            <h5>Comercializador de</h5>
                                                                        </label>
                                                                        <label className="form-check-label me-4" htmlFor="flexCheckChecked">
                                                                            <h5>mezcal</h5>
                                                                        </label>
                                                                        <span className='text-danger'>{fc_01Map?.comercializadormezcal}</span>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                                                        <input className={`form-check-input me-3 escalar ${fc_01Map.cadenaproductivacheck !== undefined ? (
                                                                            fc_01Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                            type="checkbox"
                                                                            //     onChange={e => setComercializadorBebidas(e.target.checked)}
                                                                            checked={values.comercializadorbebidasconmezcal} id="noAsociado"
                                                                            name="comercializadorbebidasconmezcal"
                                                                            value={values.comercializadorbebidasconmezcal}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {/* <FontAwesomeIcon icon={faDumpsterFire} className={` ${estilos.escalarx2} ${estilos.logoNaranja} me-4`} /> */}
                                                                        <label className="form-check-label me-2 " htmlFor="flexCheckChecked">
                                                                            <h5>Comercializador de</h5>
                                                                        </label>
                                                                        <label className="form-check-label me-1 " htmlFor="flexCheckChecked">
                                                                            <h5>productos con mezcal</h5>
                                                                        </label>
                                                                        <span
                                                                            className='text-danger'>{fc_01Map?.comercializadorbebidasconmezcal}</span>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <span className={`${fc_01Map.cadenaproductivacheck !== undefined ? (fc_01Map?.cadenaproductivacheck === true ? 'text-danger text-center' : 'text-success text-center') : ('')}`}>
                                                                {fc_01Map?.cadenaproductivacheck === true ? (fc_01Map?.cadenaproductiva) : ''}</span>
                                                            {(touched.viverista || touched.productormaguey || touched.productormezcal || touched.envasador
                                                                || touched.comercializadormezcal || touched.comercializadorbebidasconmezcal)
                                                                && errors.actividadEmpresa && <div className="text-danger text-center">{errors.actividadEmpresa}</div>}
                                                        </div>
                                                        <br />
                                                        {/* <div className='row'> */}
                                                        <h3 className='text-center labelNaranja'>Estadística social</h3>


                                                        {/* <div className={`row text-center ${estilos.divSoloBorderNaranja}`}> */}
                                                        <div className='row justify-content-start mb-2'>
                                                            {/* <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                                    <br/>
                                                
                                                </div> */}
                                                            <h5 className="label-withe" >Número de trabajadores</h5>
                                                            <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                                <br />
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" id="floatingInput"
                                                                        className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                        placeholder='0'
                                                                        // onChange={e => setNumeroHombres(e.target.valueAsNumber)}
                                                                        // value={numerohombres}
                                                                        name="numerohombres"
                                                                        value={values.numerohombres}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        onWheel={event => event.currentTarget.blur()}
                                                                    />
                                                                    {touched.numerohombres && errors.numerohombres && <div className="text-danger">{errors.numerohombres}</div>}
                                                                    <span className='text-danger'>{fc_01Map?.numerohombres}</span>
                                                                    <label className="label-dark" htmlFor="floatingInput"><small>Núm. de hombres</small></label>
                                                                </div>
                                                            </div>
                                                            <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                                <br />
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" id="floatingInput"
                                                                        className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                        placeholder='0'
                                                                        // onChange={e => setNumeroMujeres(e.target.valueAsNumber)}
                                                                        // value={numeromujeres}
                                                                        name="numeromujeres"
                                                                        value={values.numeromujeres}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        onWheel={event => event.currentTarget.blur()}
                                                                    />
                                                                    {touched.numeromujeres && errors.numeromujeres && <div className="text-danger">{errors.numeromujeres}</div>}
                                                                    <span className='text-danger'>{fc_01Map?.numeromujeres}</span>

                                                                    <label className="label-dark" htmlFor="floatingInput"><small>Núm. de mujeres</small></label>
                                                                </div>
                                                            </div>
                                                            <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                                                <br />
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" id="floatingInput"
                                                                        className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                        placeholder='0'
                                                                        // onChange={e => setNumeroDiscapacitados(e.target.valueAsNumber)}
                                                                        // value={numerodiscapacitados}
                                                                        name="numerodiscapacitados"
                                                                        value={values.numerodiscapacitados}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        onWheel={event => event.currentTarget.blur()}
                                                                    />
                                                                    {touched.numerodiscapacitados && errors.numerodiscapacitados && <div className="text-danger">{errors.numerodiscapacitados}</div>}
                                                                    <span className='text-danger'>{fc_01Map?.numerodiscapacitados}</span>

                                                                    <label className="label-dark" htmlFor="floatingInput"><small>Núm. de discapacitados</small></label>
                                                                </div>
                                                            </div>
                                                            {/* <div className='col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1'>
                                                    
                                                    </div> */}

                                                            <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                                <label className="label-blanco">Base</label>
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" id="floatingInput"
                                                                        className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                        placeholder='0'
                                                                        // onChange={e => setNumeroBase(e.target.valueAsNumber)}
                                                                        // value={numerobase}
                                                                        name="numerobase"
                                                                        value={values.numerobase}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        onWheel={event => event.currentTarget.blur()}
                                                                    />
                                                                    {touched.numerobase && errors.numerobase && <div className="text-danger">{errors.numerobase}</div>}
                                                                    <span className='text-danger'>{fc_01Map?.numerobase}</span>

                                                                    <label className="label-dark" htmlFor="floatingInput"><small>Núm. de personas</small></label>
                                                                </div>
                                                            </div>
                                                            {/* <div className='col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1'>
                                                    
                                                    </div> */}

                                                            <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                                                <label className="label-blanco">Eventuales</label>
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" id="floatingInput"
                                                                        className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_01Map) ? ('inputValidado') : ('')}`}
                                                                        placeholder='0'
                                                                        // onChange={e => setNumeroEventuales(e.target.valueAsNumber)}
                                                                        // value={numeroeventuales}
                                                                        name="numeroeventuales"
                                                                        value={values.numeroeventuales}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        onWheel={event => event.currentTarget.blur()}
                                                                    />
                                                                    {touched.numeroeventuales && errors.numeroeventuales && <div className="text-danger">{errors.numeroeventuales}</div>}
                                                                    <span className='text-danger'>{fc_01Map?.numeroeventuales}</span>

                                                                    <label className="label-dark" htmlFor="floatingInput"><small>Núm. de personas</small></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* </div> */}
                                                        {/* </div> */}
                                                    </div>

                                                }
                                            </Fragment>
                                        ) : nombresParaPaginas[paginaActiva - 1] === 'Domicilio fiscal' ?
                                            (
                                                <Fragment>
                                                    <br></br>
                                                    {
                                                        modoCorreccion &&
                                                        <div className='text-center'>
                                                            {
                                                                observacionesApartados.countObsDomicilioFiscal !== 0 ?
                                                                    <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                    :
                                                                    <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                            }
                                                        </div>
                                                    }

                                                    <div className='container'>
                                                        <div className='row justify-content-start mb-2'>
                                                            <div className='row'>
                                                                <div className='row'>
                                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className="form-floating mb-3">
                                                                            {/* <input type="text" id="floatingInput" className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                // onChange={e => setEstado(e.target.value)}
                                                                                // value={estado}
                                                                                placeholder='Estado'
                                                                                name="estado"
                                                                                value={values.estado}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            {touched.estado && errors.estado && <div className="text-danger">{errors.estado}</div>}
                                                                            <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck
                                                                                    ? (fc_01Map?.domiciliofiscal) : ''}</span> */}
                                                                            <select className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                value={values.estado}
                                                                                onChange={e => {
                                                                                    const { ...newValues } = values
                                                                                    newValues.estado = e.target.value
                                                                                    newValues.municipioalcaldia = ''
                                                                                    newValues.codigopostal = ''
                                                                                    newValues.colonia = ''
                                                                                    newValues.localidad = ''
                                                                                    newValues.calle = ''
                                                                                    if (e.target.value !== '') obtenerMunicipiosConClave(e.target.value)
                                                                                    setValues(newValues)

                                                                                }}
                                                                                name="estado"
                                                                                onBlur={handleBlur}
                                                                            >
                                                                                <option value="">Seleccione su estado</option>
                                                                                {
                                                                                    estadosApi?.[0] !== undefined && estadosApi?.map((estado, index) => (
                                                                                        <option key={index} value={`${estado[0]}`}>{`${estado[0]}`}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            {touched.estado && errors.estado && <div className="text-danger">{errors.estado}</div>}
                                                                            <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck
                                                                                    ? (fc_01Map?.domiciliofiscal) : ''}</span>
                                                                            <label className='floatingInput'>Estado</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className="form-floating mb-3">
                                                                            {/* <input type="text" id="floatingInput" className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                // onChange={e => setMunicipioAlcaldia(e.target.value)}
                                                                                //     value={municipioalcaldia}
                                                                                name="municipioalcaldia"
                                                                                value={values.municipioalcaldia}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                placeholder='Municipio/Alcaldia' /> */}
                                                                            <select className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                value={values.municipioalcaldia}
                                                                                onChange={e => {
                                                                                    const { ...newValues } = values
                                                                                    newValues.municipioalcaldia = e.target.value
                                                                                    newValues.codigopostal = ''
                                                                                    newValues.colonia = ''
                                                                                    newValues.localidad = ''
                                                                                    newValues.calle = ''
                                                                                    if (e.target.value !== '') obtenerCodigosPostales(e.target.value)
                                                                                    setValues(newValues)
                                                                                }}
                                                                                name="municipioalcaldia"
                                                                                onBlur={handleBlur}
                                                                                disabled={values.estado === '' ? true : false}
                                                                            >
                                                                                <option value="">Seleccione su municipio</option>
                                                                                {
                                                                                    municipiosApi?.[0] !== undefined && municipiosApi?.map((municipio, index) => (
                                                                                        <option key={index} value={`${municipio.municipio}`}>{`${municipio.municipio}`}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            {touched.municipioalcaldia && errors.municipioalcaldia && <div className="text-danger">{errors.municipioalcaldia}</div>}
                                                                            <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck ? (fc_01Map?.domiciliofiscal) : ''}</span>

                                                                            <label className="label-dark" htmlFor="floatingInput">Municipio/Alcaldía</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className="form-floating mb-3">
                                                                            {/* <input type="number" id="floatingInput"
                                                                                className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                    ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                //     onChange={e => setCp(e.target.value)}
                                                                                // value={codigopostal}
                                                                                name="codigopostal"
                                                                                value={values.codigopostal}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                placeholder='Código postal'
                                                                            /> */}
                                                                            <select className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                value={values.codigopostal}
                                                                                onChange={e => {
                                                                                    const { ...newValues } = values
                                                                                    newValues.codigopostal = e.target.value
                                                                                    newValues.colonia = ''
                                                                                    newValues.localidad = ''
                                                                                    newValues.calle = ''
                                                                                    if (e.target.value !== '') obtenerColonias(e.target.value)
                                                                                    if (e.target.value !== '') obtenerLocalidades({ estado: values.estado, municipio: values.municipioalcaldia })
                                                                                    setValues(newValues)
                                                                                }}
                                                                                name="codigopostal"
                                                                                onBlur={handleBlur}
                                                                                disabled={values.municipioalcaldia === '' ? true : false}
                                                                            >
                                                                                <option value="">Seleccione su código postal</option>
                                                                                {
                                                                                    codigosPostalesApi?.[0] !== undefined && codigosPostalesApi?.map((cp, index) => (
                                                                                        <option key={index} value={`${cp}`}>{`${cp}`}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            {touched.codigopostal && errors.codigopostal && <div className="text-danger">{errors.codigopostal}</div>}
                                                                            <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck ? (fc_01Map?.domiciliofiscal) : ''}</span>

                                                                            <label className="label-dark" htmlFor="floatingInput">Código Postal</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className="form-floating mb-3">
                                                                            {/* <input type="text" id="floatingInput" className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                // onChange={e => setColonia(e.target.value)}
                                                                                // value={colonia}
                                                                                name="colonia"
                                                                                value={values.colonia}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                placeholder='Colonia' /> */}
                                                                            <select className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                value={values.colonia}
                                                                                onChange={e => {
                                                                                    const { ...newValues } = values
                                                                                    newValues.colonia = e.target.value
                                                                                    setValues(newValues)
                                                                                }}
                                                                                name="colonia"
                                                                                onBlur={handleBlur}
                                                                                disabled={values.codigopostal === '' ? true : false}
                                                                            >
                                                                                <option value="">Seleccione su colonia</option>
                                                                                {
                                                                                    coloniasApi?.[0] !== undefined && coloniasApi?.map((colonia, index) => (
                                                                                        <option key={index} value={`${colonia}`}>{`${colonia}`}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            {touched.colonia && errors.colonia && <div className="text-danger">{errors.colonia}</div>}
                                                                            <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck ? (fc_01Map?.domiciliofiscal) : ''}</span>

                                                                            <label className="label-dark" htmlFor="floatingInput">Colonia</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='row'>
                                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className="form-floating mb-3">
                                                                            {/* <input type="text" className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                //     onChange={e => setLocalidad(e.target.value)}
                                                                                // value={localidad}
                                                                                id=""
                                                                                placeholder='Localidad'
                                                                                name="localidad"
                                                                                value={values.localidad}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            /> */}
                                                                            <select className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                value={values.localidad}
                                                                                onChange={e => {
                                                                                    const { ...newValues } = values
                                                                                    newValues.localidad = e.target.value
                                                                                    newValues.calle = ''
                                                                                    if (e.target.value !== '') obtenerCalles({ clave_estado: values.estado, clave_municipio: values.municipioalcaldia, clave_localidad: values.localidad })

                                                                                    setValues(newValues)
                                                                                }}
                                                                                name="localidad"
                                                                                onBlur={handleBlur}
                                                                                disabled={values.codigopostal === '' ? true : false}
                                                                            >
                                                                                <option value="">Seleccione su localidad</option>
                                                                                {
                                                                                    localidadesApi?.[0] !== undefined && localidadesApi?.map((localidad, index) => (
                                                                                        <option key={index} value={`${localidad.localidad}`}>{`${localidad.localidad}`}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            {touched.localidad && errors.localidad && <div className="text-danger">{errors.localidad}</div>}
                                                                            <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck ? (fc_01Map?.domiciliofiscal) : ''}</span>

                                                                            <label className="label-dark" htmlFor="floatingInput">Localidad</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className={`col-xs-12 col-sm-12 ${values.calle === 'Otro' ? 'col-md-1 col-lg-1 col-xl-1' : 'col-md-6 col-lg-6 col-xl-6'}`}>
                                                                        <div className="form-floating mb-3">
                                                                            {/* <input type="text" id="floatingInput"
                                                                                // onChange={e => setCallle(e.target.value)}
                                                                                //     value={calle}
                                                                                className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                    ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                placeholder='Calle'
                                                                                name="calle"
                                                                                value={values.calle}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            /> */}
                                                                            <select className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                value={values.calle}
                                                                                onChange={e => {
                                                                                    const { ...newValues } = values
                                                                                    newValues.calle = e.target.value
                                                                                    setValues(newValues)
                                                                                }}
                                                                                name="calle"
                                                                                onBlur={handleBlur}
                                                                                disabled={values.localidad === '' ? true : false}
                                                                            >
                                                                                <option value="">Seleccione su calle</option>
                                                                                {
                                                                                    callesApi?.[0] !== undefined && callesApi?.map((calle, index) => (
                                                                                        <option key={index} value={`${calle.nombre_vialidad}`}>{`${calle.nombre_vialidad}`}</option>
                                                                                    ))
                                                                                }
                                                                                <option value="Otro">Otro</option>
                                                                            </select>
                                                                            {touched.calle && errors.calle && <div className="text-danger">{errors.calle}</div>}
                                                                            <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck ? (fc_01Map?.domiciliofiscal) : ''}</span>

                                                                            <label className="label-dark" htmlFor="floatingInput">Calle</label>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        values.calle === 'Otro' &&
                                                                        <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                                            <div className="form-floating mb-3">
                                                                                <input type="text" id="floatingInput"
                                                                                    // onChange={e => setNumExterior(e.target.value)}
                                                                                    //     value={numeroexterior}
                                                                                    className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                        ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                    placeholder='Calle'
                                                                                    name="otracalle"
                                                                                    value={values.otracalle}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                />
                                                                                {touched.otracalle && errors.otracalle && <div className="text-danger">{errors.otracalle}</div>}
                                                                                <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                    ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck ? (fc_01Map?.domiciliofiscal) : ''}</span>

                                                                                <label className="label-dark" htmlFor="floatingInput">Especifique</label>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='row'>

                                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className="form-floating mb-3">
                                                                            <input type="text" id="floatingInput"
                                                                                // onChange={e => setNumExterior(e.target.value)}
                                                                                //     value={numeroexterior}
                                                                                className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                    ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                placeholder='Número exterior'
                                                                                name="numeroexterior"
                                                                                value={values.numeroexterior}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            {touched.numeroexterior && errors.numeroexterior && <div className="text-danger">{errors.numeroexterior}</div>}
                                                                            <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck ? (fc_01Map?.domiciliofiscal) : ''}</span>

                                                                            <label className="label-dark" htmlFor="floatingInput">Número exterior</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className="form-floating mb-3">
                                                                            <input type="text" className={`form-control ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                // onChange={e => setNumInterior(e.target.value)}
                                                                                // value={numerointerior}
                                                                                id="" placeholder='Número interior'
                                                                                name="numerointerior"
                                                                                value={values.numerointerior}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            {touched.numerointerior && errors.numerointerior && <div className="text-danger">{errors.numerointerior}</div>}
                                                                            <span className={` ${fc_01Map.domiciliofiscalcheck !== undefined ? (fc_01Map?.domiciliofiscalcheck
                                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_01Map?.domiciliofiscalcheck ? (fc_01Map?.domiciliofiscal) : ''}</span>

                                                                            <label className="label-dark" htmlFor="floatingInput">Número interior</label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <input type="date" id="floatingInput"
                                                            className={`form-control ${fc_01Map.fechasolicitudcheck !== undefined ? (
                                                                fc_01Map?.fechasolicitudcheck ? 'inputDenegado' : 'inputValidado') : ('')}`
                                                            } onChange={e => setFechaSolicitud(e.target.value)}
                                                            value={fechasolicitud}
                                                            placeholder='Fecha de solicitud' disabled />

                                                        <label className="label-dark" htmlFor="floatingInput">Fecha de solicitud</label>
                                                        <span className='text-danger'>{fc_01Map?.fechasolicitud}</span>
                                                    </div>
                                                </div> */}
                                                            </div>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </Fragment>

                                            ) : (nombresParaPaginas[paginaActiva - 1] === 'Viverista' ||
                                                nombresParaPaginas[paginaActiva - 1] === 'Productor de maguey' ||
                                                nombresParaPaginas[paginaActiva - 1] === 'Viverista/Productor de maguey') ?
                                                (
                                                    <Fragment>
                                                        <div className='container'>
                                                            {
                                                                modoCorreccion &&
                                                                <div className='text-center'>
                                                                    {
                                                                        observacionesApartados.countObsPrediosViveros !== 0 ?
                                                                            <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                            :
                                                                            <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                                    }
                                                                </div>
                                                            }
                                                            {viverista && <Fragment>
                                                                <h4 className='text-center labelNaranja'>Datos de vivero</h4>
                                                                <PredioComponent componente='fc_01' predios={predios} map={prediosMap} handdleDeleteOptionFile={handdleDeleteOptionFileVivero} />
                                                            </Fragment>
                                                            }
                                                            {/* <hr /> */}
                                                            {productormaguey && <Fragment>
                                                                <h4 className='text-center labelNaranja'>Datos de predio</h4>
                                                                <ProductorComponent componente='fc_01' productor={productor} map={productorMap} handdleDeleteOptionFile={handdleDeleteOptionFilePredio} />
                                                            </Fragment>
                                                            }
                                                        </div>
                                                    </Fragment>
                                                ) : nombresParaPaginas[paginaActiva - 1] === 'Instalaciones' ?
                                                    (
                                                        <div className='container'>
                                                            {
                                                                modoCorreccion &&
                                                                <div className='text-center'>
                                                                    {
                                                                        observacionesApartados.countObsInstalaciones !== 0 ?
                                                                            <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                            :
                                                                            <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                                    }
                                                                </div>
                                                            }
                                                            <div className="row ms-3 mb-5">

                                                                <div className='row justify-content-md-center mb-2 text-center'>
                                                                    {/* <h4 className={`${estilos.textoNormal}`}><i>¿Desea agregar un Anexo a la solcitud?</i></h4> */}
                                                                    {/* <h3 className='text-center labelNaranja'>¿Desea agregar unidades a la solicitud?</h3> */}
                                                                </div>

                                                                {
                                                                    productormezcal && (!modoCorreccion) &&
                                                                    <div className="mt-3 col-md-4">
                                                                        <div className='text-center'>
                                                                            <button type="button" onClick={() => { props.history.push('/fc_01AnexoProduccion') }}
                                                                                className={`btn ${estilos.botonNaranja}`}>Agregar unidad de producción</button>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {
                                                                    envasador && (!modoCorreccion) &&
                                                                    <div className="mt-3 col-md-4">
                                                                        <div className='text-center'>
                                                                            <button type="button" onClick={() => { props.history.push('/fc_01AnexoEnvasado') }}
                                                                                className={`btn ${estilos.botonNaranja}`}>Agregar unidad de envasado</button>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {
                                                                    !modoCorreccion &&
                                                                    (
                                                                        <div className="mt-3 col-md-4">
                                                                            <div className='text-center'>
                                                                                <button type="button" onClick={e => botonAlmacen()}
                                                                                    className={`btn ${estilos.botonNaranja}`}>Agregar unidad de almacén</button>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }

                                                            </div>
                                                            <div className='mt-2'>
                                                                {
                                                                    anexoInstalaciones.length > 0 &&
                                                                    <TablaAnexos rows={anexoInstalaciones} handdleDeleteOptionFile={handdleDeleteOptionFileInstalacion} />
                                                                }
                                                            </div>
                                                        </div>
                                                    ) : nombresParaPaginas[paginaActiva - 1] === 'Marcas' ?
                                                        (
                                                            <div className='container' >
                                                                {
                                                                    modoCorreccion &&
                                                                    <div className='text-center'>
                                                                        {
                                                                            observacionesApartados.countObsMarcas !== 0 ?
                                                                                <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                                :
                                                                                <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                                        }
                                                                    </div>
                                                                }
                                                                {
                                                                    comercializadormezcal &&
                                                                    <div className='container' >
                                                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center'>
                                                                            <div className='row'>
                                                                                <h4 className='text-center labelNaranja'>Datos de sus marcas a comercializar de mezcal<br></br></h4>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            marcas.map((inputField, index) => (
                                                                                <div key={index} className='row text-center' >
                                                                                    <div className='col-md-12'>
                                                                                        <div className="form-floating mb-4">
                                                                                            <div className="input-group mb-3 text-center" >
                                                                                                <label className="label-blanco" htmlFor="floatingInput">¿Su marca esta registrada ante el IMPI?</label>
                                                                                                <input className={`ms-2 form-check-input ${marcasDeMezcalMap.length > 0 ? 'inputValidado' : ''}`}
                                                                                                    type="checkbox" id="si" onChange={e => handleOnChangueMarcas(
                                                                                                        {
                                                                                                            valor: e.target.checked,
                                                                                                            id: inputField.id,
                                                                                                            campo: 'registrosi'
                                                                                                        })}
                                                                                                    checked={inputField.registrosi} />
                                                                                                <label className="label-blanco ms-1" htmlFor="floatingInput">Si  </label>

                                                                                                <label style={{ margin: 10 }}></label>
                                                                                                <input className={`ms-2 form-check-input ${marcasDeMezcalMap.length > 0 ? 'inputValidado' : ''}`}
                                                                                                    type="checkbox" id="no" onChange={e => handleOnChangueMarcas(
                                                                                                        {
                                                                                                            valor: e.target.checked,
                                                                                                            id: inputField.id,
                                                                                                            campo: 'registrono'
                                                                                                        })}
                                                                                                    checked={inputField.registrono} />
                                                                                                <label className="label-blanco ms-1" htmlFor="floatingInput"> No</label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    {
                                                                                        inputField.registrosi === false && inputField.registrono === false ? (<div className='col-md-1'></div>) :
                                                                                            (
                                                                                                <Fragment>
                                                                                                    <div className='col-md-4'>
                                                                                                        <div className="form-floating mb-3">
                                                                                                            <input type="text" onChange={e => handleOnChangueMarcas(
                                                                                                                {
                                                                                                                    valor: e.target.value,
                                                                                                                    id: inputField.id,
                                                                                                                    campo: 'marca'
                                                                                                                })}
                                                                                                                value={inputField.marca}
                                                                                                                className={`form-control ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.marcacheck !== undefined ? (marcasDeMezcalMap?.filter
                                                                                                                        (map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.marcacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                id="" placeholder='Marca'
                                                                                                            />
                                                                                                            <label className="label-dark" htmlFor="floatingInput">Nombre de marca</label>
                                                                                                            {inputField.marca.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}

                                                                                                            <span className={`${marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                === inputField.idfc01_anexomarcas)[0]?.marcacheck !== undefined ? (
                                                                                                                marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.marcacheck ? 'text-danger'
                                                                                                                    : 'text-success') : ('')}`}>
                                                                                                                {marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.marcacheck ?
                                                                                                                    (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.marca) : ''}
                                                                                                            </span>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className='col-md-4'>
                                                                                                        <div className="form-floating mb-3">
                                                                                                            <input type="number"
                                                                                                                className={`form-control ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.numeroderegistroimpicheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                        === inputField.idfc01_anexomarcas)[0]?.numeroderegistroimpicheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                onChange={e =>
                                                                                                                    handleOnChangueMarcas(
                                                                                                                        {
                                                                                                                            valor: e.target.value,
                                                                                                                            id: inputField.id,
                                                                                                                            campo: 'numeroderegistroimpi'
                                                                                                                        })}
                                                                                                                value={inputField.numeroderegistroimpi}
                                                                                                                id="" placeholder='No. registro impi'
                                                                                                                onWheel={event => event.currentTarget.blur()}
                                                                                                            />
                                                                                                            {
                                                                                                                inputField.registrosi === true ?
                                                                                                                    (<label className="label-dark" htmlFor="floatingInput">Número de registro de marca</label>) : (<label className="label-dark" htmlFor="floatingInput"><small>Número de expediente de marca</small></label>)
                                                                                                            }
                                                                                                            {inputField.numeroderegistroimpi.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                                            <span className={` ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                === inputField.idfc01_anexomarcas)[0]?.numeroderegistroimpicheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.numeroderegistroimpicheck ? 'text-danger' : 'text-success') : ('')}`}>
                                                                                                                {marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.numeroderegistroimpicheck ?
                                                                                                                    (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.numeroderegistroimpi) : ''}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className='col-md-4'>
                                                                                                        <div className="form-floating mb-3">
                                                                                                            <select onChange={e => handleOnChangueMarcas(
                                                                                                                {
                                                                                                                    valor: Number(e.target.value),
                                                                                                                    id: inputField.id,
                                                                                                                    campo: 'idtipomarca'
                                                                                                                })}
                                                                                                                value={inputField.idtipomarca}
                                                                                                                className={`form-select form-select-sm ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.idtipomarcacheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                        === inputField.idfc01_anexomarcas)[0]?.idtipomarcacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                            >
                                                                                                                <option value="0" disabled>Tipo de marca</option>
                                                                                                                <option value="1">Mixta</option>
                                                                                                                <option value="2">Nominativa</option>
                                                                                                                <option value="3">Tridimencional</option>
                                                                                                            </select>
                                                                                                            {/* <label className="label-dark" htmlFor="floatingInput">Tipo de marca</label> */}
                                                                                                            {inputField.idtipomarca === undefined || inputField.idtipomarca === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                                            <span className={` ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                === inputField.idfc01_anexomarcas)[0]?.idtipomarcacheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.idtipomarcacheck ? 'text-danger' : 'text-success') : ('')}`}>
                                                                                                                {marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.idtipomarcacheck ?
                                                                                                                    (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.idtipomarca) : ''}</span>
                                                                                                        </div>

                                                                                                    </div>
                                                                                                    {
                                                                                                        inputField.registrosi === true ?
                                                                                                            (
                                                                                                                <div className='col-md-4 text-center' >
                                                                                                                    <br />
                                                                                                                    <div className="form-floating mb-3">
                                                                                                                        <select onChange={e => handleOnChangueMarcas(
                                                                                                                            {
                                                                                                                                valor: Number(e.target.value),
                                                                                                                                id: inputField.id,
                                                                                                                                campo: 'idtitularidaddemarca'
                                                                                                                            })}
                                                                                                                            value={inputField.idtitularidaddemarca}
                                                                                                                            className={`form-select form-select-sm ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                                === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                        >
                                                                                                                            <option value="0" disabled>Titularidad de la marca</option>
                                                                                                                            <option value="1">Propia (Título)</option>
                                                                                                                            <option value="3">Licencia de uso autorizado</option>
                                                                                                                            <option value="4">Cesión de derechos de marca autorizada</option>
                                                                                                                            <option value="5">Licencia de uso en trámite</option>
                                                                                                                            <option value="6">Cesión de derechos de marca en trámite</option>
                                                                                                                        </select>
                                                                                                                        {/* <label htmlFor="floatingInput">Titularidad de la marca</label> */}
                                                                                                                        {inputField.idtitularidaddemarca === undefined || inputField.idtitularidaddemarca === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                                                        <span className={` ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                            === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                                === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck ? 'text-danger' : 'text-success') : ('')}`}>
                                                                                                                            {marcasDeMezcalMap.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck ?
                                                                                                                                (marcasDeMezcalMap.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarca) : ''}</span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            ) : inputField.registrono === true ?
                                                                                                                (
                                                                                                                    <div className='col-md-4 text-center' >
                                                                                                                        <br />
                                                                                                                        <div className="form-floating mb-3">
                                                                                                                            <select onChange={e => handleOnChangueMarcas(
                                                                                                                                {
                                                                                                                                    valor: Number(e.target.value),
                                                                                                                                    id: inputField.id,
                                                                                                                                    campo: 'idtitularidaddemarca'
                                                                                                                                })}
                                                                                                                                value={inputField.idtitularidaddemarca}
                                                                                                                                className={`form-select form-select-sm ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                                        === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                            >
                                                                                                                                <option value="0" disabled>Titularidad de la marca</option>
                                                                                                                                <option value="2">Propia en trámite</option>
                                                                                                                                <option value="5">Licencia de uso en trámite</option>
                                                                                                                                <option value="6">Cesión de derechos de marca en trámite</option>
                                                                                                                            </select>
                                                                                                                            {/* <label htmlFor="floatingInput">Titularidad de la marca</label> */}
                                                                                                                            {inputField.idtitularidaddemarca === undefined || inputField.idtitularidaddemarca == 0 ? (<span className='text-danger'>Campo obligratorio</span>) : ''}
                                                                                                                            <span className={` ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                                === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck ? 'text-danger' : 'text-success') : ('')}`}>
                                                                                                                                {marcasDeMezcalMap.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarcacheck ?
                                                                                                                                    (marcasDeMezcalMap.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.idtitularidaddemarca) : ''}</span>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                ) : ''
                                                                                                    }
                                                                                                    {
                                                                                                        (comercializadormezcal || comercializadorbebidasconmezcal) && !(productormezcal) &&
                                                                                                        <div className='col-md-4'>
                                                                                                            <label className="label-blanco" htmlFor="floatingInput">Indicar productor autorizado</label>
                                                                                                            <div className="form-floating mb-3">
                                                                                                                <input type="text" onChange={e => handleOnChangueMarcas(
                                                                                                                    {
                                                                                                                        valor: e.target.value,
                                                                                                                        id: inputField.id,
                                                                                                                        campo: 'productor'
                                                                                                                    })}
                                                                                                                    value={inputField.productor}
                                                                                                                    className={`form-control ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                        === inputField.idfc01_anexomarcas)[0]?.productorcheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                            === inputField.idfc01_anexomarcas)[0]?.productorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                    id="" placeholder='Nombre o Razon social'
                                                                                                                />
                                                                                                                <label className="label-dark" htmlFor="floatingInput">Nombre o Razón Social</label>
                                                                                                                <span className={` ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.productorcheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                        === inputField.idfc01_anexomarcas)[0]?.productorcheck ? 'text-danger' : 'text-success') : ('')}`}>
                                                                                                                    {marcasDeMezcalMap.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.productorcheck ?
                                                                                                                        (marcasDeMezcalMap.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.productor) : ''}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    }

                                                                                                    {
                                                                                                        !envasador &&
                                                                                                        <div className='col-md-4'>
                                                                                                            <label className="label-blanco" htmlFor="floatingInput">Indicar maquilador autorizado</label>
                                                                                                            <div className="form-floating mb-3">
                                                                                                                <input type="text" onChange={e => handleOnChangueMarcas(
                                                                                                                    {
                                                                                                                        valor: e.target.value,
                                                                                                                        id: inputField.id,
                                                                                                                        campo: 'maquilador'
                                                                                                                    })}
                                                                                                                    value={inputField.maquilador}
                                                                                                                    className={`form-control ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                        === inputField.idfc01_anexomarcas)[0]?.maquiladorcheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                            === inputField.idfc01_anexomarcas)[0]?.maquiladorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                    id="" placeholder='Nombre o Razon social'
                                                                                                                />
                                                                                                                <label className="label-dark" htmlFor="floatingInput">Nombre o Razón Social</label>
                                                                                                                <span className={` ${marcasDeMezcalMap?.filter(map => map?.idfc01_anexomarcas
                                                                                                                    === inputField.idfc01_anexomarcas)[0]?.maquiladorcheck !== undefined ? (marcasDeMezcalMap?.filter(map => map.idfc01_anexomarcas
                                                                                                                        === inputField.idfc01_anexomarcas)[0]?.maquiladorcheck ? 'text-danger' : 'text-success') : ('')}`}>
                                                                                                                    {marcasDeMezcalMap.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.maquiladorcheck ?
                                                                                                                        (marcasDeMezcalMap.filter(map => map.idfc01_anexomarcas === inputField.idfc01_anexomarcas)[0]?.maquilador) : ''}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    }
                                                                                                </Fragment>
                                                                                            )
                                                                                    }

                                                                                    {
                                                                                        !modoCorreccion && <Fragment>
                                                                                            {/* {productormaguey || productormezcal && <div className='mt-2 col-md-5'></div> } */}
                                                                                            <div className='mt-2 col-md-5'></div>
                                                                                            <div className='mt-2 col-md-2 border-secondary text-center'>
                                                                                                {/* <div className='mt-2 col-md-5' align='center'></div> */}
                                                                                                {/* <div className='row justify-content-md-center mb-2 text-center border-secondary' align='center'> */}
                                                                                                {/* <button className='btn btn-danger' onClick={e =>
                                                                                        deleteMarca(inputField)} align='center'>Eliminar</button> */}
                                                                                                {/* <div className=' col-md-2' > */}
                                                                                                <ModalComponent api={{ deleteAnexo: deleteMarca, inputField }} text="una marca" />
                                                                                                {/* </div> */}
                                                                                            </div>

                                                                                            {/* </div> */}
                                                                                        </Fragment>
                                                                                    }
                                                                                    <hr />
                                                                                </div>
                                                                            ))
                                                                        }
                                                                        {

                                                                            // </div>
                                                                            !modoCorreccion &&
                                                                            <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                                                {/* <div className='col-md-3' align='center'> */}
                                                                                <button className='botonAgregarAnexo col-md-2' onClick={e =>
                                                                                    handleAddMarcas()}>Agregar marca</button>
                                                                                {marcas.length === 0 ? (<span className='text-danger text-center'>Campo obligatorio</span>) : ''}
                                                                                {/* </div> */}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                }
                                                                {
                                                                    comercializadorbebidasconmezcal &&
                                                                    <div className='container' >
                                                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center'>
                                                                            <div className='row'>
                                                                                <h4 className='text-center labelNaranja'>Datos de sus marcas a comercializar de productos con mezcal<br></br></h4>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            marcasProductoConMezcal.map((inputField, index) => (
                                                                                <div key={index} className='row text-center' >
                                                                                    <div className='col-md-12'>
                                                                                        <div className="form-floating mb-4">
                                                                                            <div className="input-group mb-3 text-center" >
                                                                                                <label className="label-blanco" htmlFor="floatingInput">¿Su marca esta registrada ante el IMPI?</label>
                                                                                                <input className={`ms-2 form-check-input ${marcasConProductosMap.length > 0 ? 'inputValidado' : ''}`}
                                                                                                    type="checkbox" id="si" onChange={e => handleOnChangueMarcasProductosConMezcal(
                                                                                                        {
                                                                                                            valor: e.target.checked,
                                                                                                            id: inputField.id,
                                                                                                            campo: 'registrosi'
                                                                                                        })}
                                                                                                    checked={inputField.registrosi} />
                                                                                                <label className="label-blanco ms-1" htmlFor="floatingInput">Si  </label>

                                                                                                <label style={{ margin: 10 }}></label>
                                                                                                <input className={`ms-2 form-check-input ${marcasDeMezcalMap.length > 0 ? 'inputValidado' : ''}`}
                                                                                                    type="checkbox" id="no" onChange={e => handleOnChangueMarcasProductosConMezcal(
                                                                                                        {
                                                                                                            valor: e.target.checked,
                                                                                                            id: inputField.id,
                                                                                                            campo: 'registrono'
                                                                                                        })}
                                                                                                    checked={inputField.registrono} />
                                                                                                <label className="label-blanco ms-1" htmlFor="floatingInput"> No</label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    {
                                                                                        inputField.registrosi === false && inputField.registrono === false ? (<div className='col-md-1'></div>) :
                                                                                            (
                                                                                                <Fragment>
                                                                                                    <div className='col-md-4'>
                                                                                                        <div className="form-floating mb-3">
                                                                                                            <input type="text" onChange={e => handleOnChangueMarcasProductosConMezcal(
                                                                                                                {
                                                                                                                    valor: e.target.value,
                                                                                                                    id: inputField.id,
                                                                                                                    campo: 'marca'
                                                                                                                })}
                                                                                                                value={inputField.marca}
                                                                                                                className={`form-control ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.marcacheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.marcacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                id="" placeholder='Marca'
                                                                                                            />
                                                                                                            <label className="label-dark" htmlFor="floatingInput">Nombre de marca</label>
                                                                                                            {inputField.marca.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                                            <span className={` ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.marcacheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.marcacheck ? 'text-danger' : 'text-success') : ('')}`}>
                                                                                                                {marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.marcacheck ?
                                                                                                                    (marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.marca) : ''}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className='col-md-4'>
                                                                                                        <div className="form-floating mb-3">
                                                                                                            <input type="text"
                                                                                                                className={`form-control ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.numeroderegistroimpicheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.numeroderegistroimpicheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                onChange={e =>
                                                                                                                    handleOnChangueMarcasProductosConMezcal(
                                                                                                                        {
                                                                                                                            valor: e.target.value,
                                                                                                                            id: inputField.id,
                                                                                                                            campo: 'numeroderegistroimpi'
                                                                                                                        })}
                                                                                                                value={inputField.numeroderegistroimpi}
                                                                                                                id="" placeholder='No. registro impi'
                                                                                                            />
                                                                                                            {
                                                                                                                inputField.registrosi === true ?
                                                                                                                    (<label className="label-dark" htmlFor="floatingInput">Número de registro de marca</label>) : (<label className="label-dark" htmlFor="floatingInput"><small>Número de expediente de marca</small></label>)
                                                                                                            }
                                                                                                            {inputField.numeroderegistroimpi.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}

                                                                                                            <span className={` ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.numeroderegistroimpicheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.numeroderegistroimpicheck ? 'text-danger' : 'text-success') : ('')}`}>
                                                                                                                {marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.numeroderegistroimpicheck ?
                                                                                                                    (marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.numeroderegistroimpi) : ''}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className='col-md-4'>
                                                                                                        <div className="form-floating mb-3">
                                                                                                            <select onChange={e => handleOnChangueMarcasProductosConMezcal(
                                                                                                                {
                                                                                                                    valor: Number(e.target.value),
                                                                                                                    id: inputField.id,
                                                                                                                    campo: 'idtipomarca'
                                                                                                                })}
                                                                                                                value={inputField.idtipomarca}
                                                                                                                className={`form-select form-select-sm ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtipomarcacheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtipomarcacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                            >
                                                                                                                <option value="0" disabled>Tipo de marca</option>
                                                                                                                <option value="1">Mixta</option>
                                                                                                                <option value="2">Nominativa</option>
                                                                                                                <option value="3">Tridimencional</option>
                                                                                                            </select>
                                                                                                            {/* <label className="label-dark" htmlFor="floatingInput">Tipo de marca</label> */}
                                                                                                            {inputField.idtipomarca === undefined || inputField.idtipomarca === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                                            <span className={` ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtipomarcacheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtipomarcacheck ? 'text-danger' : 'text-success') : ('')}`}>{marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtipomarcacheck ?
                                                                                                                        (marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                            === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtipomarca) : ''}</span>
                                                                                                        </div>

                                                                                                    </div>
                                                                                                    {
                                                                                                        inputField.registrosi === true ?
                                                                                                            (
                                                                                                                <div className='col-md-4 text-center' >
                                                                                                                    <br />
                                                                                                                    <div className="form-floating mb-3">
                                                                                                                        <select onChange={e => handleOnChangueMarcasProductosConMezcal(
                                                                                                                            {
                                                                                                                                valor: Number(e.target.value),
                                                                                                                                id: inputField.id,
                                                                                                                                campo: 'idtitularidaddemarca'
                                                                                                                            })}
                                                                                                                            value={inputField.idtitularidaddemarca}
                                                                                                                            className={`form-select form-select-sm ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                                === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                        >
                                                                                                                            <option value="0" disabled>Titularidad de la marca</option>
                                                                                                                            <option value="1">Propia (Título)</option>
                                                                                                                            <option value="3">Licencia de uso autorizado</option>
                                                                                                                            <option value="4">Cesión de derechos de marca autorizada</option>
                                                                                                                            <option value="5">Licencia de uso en trámite</option>
                                                                                                                            <option value="6">Cesión de derechos de marca en trámite</option>
                                                                                                                        </select>
                                                                                                                        {/* <label htmlFor="floatingInput">Titularidad de la marca</label> */}
                                                                                                                        {inputField.idtitularidaddemarca === undefined || inputField.idtitularidaddemarca === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                                                        <span className={` ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                            === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck ? 'text-danger' : 'text-success') : ('')}`}>{marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck ?
                                                                                                                                    (marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarca) : ''}</span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            ) : inputField.registrono === true ?
                                                                                                                (
                                                                                                                    <div className='col-md-4 text-center' >
                                                                                                                        <br />
                                                                                                                        <div className="form-floating mb-3">
                                                                                                                            <select onChange={e => handleOnChangueMarcasProductosConMezcal(
                                                                                                                                {
                                                                                                                                    valor: Number(e.target.value),
                                                                                                                                    id: inputField.id,
                                                                                                                                    campo: 'idtitularidaddemarca'
                                                                                                                                })}
                                                                                                                                value={inputField.idtitularidaddemarca}
                                                                                                                                className={`form-select form-select-sm ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                            >
                                                                                                                                <option value="0" disabled>Titularidad de la marca</option>
                                                                                                                                <option value="2">Propia en trámite</option>
                                                                                                                                <option value="5">Licencia de uso en trámite</option>
                                                                                                                                <option value="6">Cesión de derechos de marca en trámite</option>
                                                                                                                            </select>
                                                                                                                            {/* <label htmlFor="floatingInput">Titularidad de la marca</label> */}
                                                                                                                            {inputField.idtitularidaddemarca === undefined || inputField.idtitularidaddemarca === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                                                                                            <span className={` ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                                === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck ? 'text-danger' : 'text-success') : ('')}`}>{marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarcacheck ?
                                                                                                                                        (marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                            === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.idtitularidaddemarca) : ''}</span>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                ) : ''
                                                                                                    }
                                                                                                    {
                                                                                                        (comercializadormezcal || comercializadorbebidasconmezcal) && !(productormezcal) &&
                                                                                                        <div className='col-md-4'>
                                                                                                            <label className="label-blanco" htmlFor="floatingInput">Indicar productor autorizado</label>
                                                                                                            <div className="form-floating mb-3">
                                                                                                                <input type="text" onChange={e => handleOnChangueMarcasProductosConMezcal(
                                                                                                                    {
                                                                                                                        valor: e.target.value,
                                                                                                                        id: inputField.id,
                                                                                                                        campo: 'productor'
                                                                                                                    })}
                                                                                                                    value={inputField.productor}
                                                                                                                    className={`form-control ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.productorcheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                            === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.productorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                    id="" placeholder='Nombre o Razon social'
                                                                                                                />
                                                                                                                <label className="label-dark" htmlFor="floatingInput">Nombre o Razón Social</label>
                                                                                                                <span className={` ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.productorcheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.productorcheck ? 'text-danger' : 'text-success') : ('')}`}>{marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                            === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.productorcheck ? (marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.productor) : ''}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    }

                                                                                                    {
                                                                                                        !envasador &&
                                                                                                        <div className='col-md-4'>
                                                                                                            <label className="label-blanco" htmlFor="floatingInput">Indicar maquilador autorizado</label>
                                                                                                            <div className="form-floating mb-3">
                                                                                                                <input type="text" onChange={e => handleOnChangueMarcasProductosConMezcal(
                                                                                                                    {
                                                                                                                        valor: e.target.value,
                                                                                                                        id: inputField.id,
                                                                                                                        campo: 'maquilador'
                                                                                                                    })}
                                                                                                                    value={inputField.maquilador}
                                                                                                                    className={`form-control ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.maquiladorcheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                            === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.maquiladorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                                                                    id="" placeholder='Nombre o Razon social'
                                                                                                                />
                                                                                                                <label className="label-dark" htmlFor="floatingInput">Nombre o Razón Social</label>
                                                                                                                <span className={` ${marcasConProductosMap?.filter(map => map?.idfc01_anexomarcasproductoconmezcal
                                                                                                                    === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.maquiladorcheck !== undefined ? (marcasConProductosMap?.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                        === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.maquiladorcheck ? 'text-danger' : 'text-success') : ('')}`}>{marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                            === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.maquiladorcheck ? (marcasConProductosMap.filter(map => map.idfc01_anexomarcasproductoconmezcal
                                                                                                                                === inputField.idfc01_anexomarcasproductoconmezcal)[0]?.maquilador) : ''}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    }
                                                                                                </Fragment>
                                                                                            )
                                                                                    }

                                                                                    {
                                                                                        !modoCorreccion && <Fragment>
                                                                                            <div className='mt-2 col-md-5'></div>
                                                                                            <div className='mt-2 col-md-2 border-secondary text-center'>
                                                                                                {/* <button className='btn btn-danger' onClick={e =>
                                                                                        deleteMarcaProductoConMezcal(inputField)} align='center'>Eliminar</button> */}
                                                                                                <ModalComponent api={{ deleteAnexo: deleteMarcaProductoConMezcal, inputField }} text="una marca" />
                                                                                            </div>
                                                                                        </Fragment>
                                                                                    }
                                                                                    <hr />
                                                                                </div>
                                                                            ))
                                                                        }
                                                                        {

                                                                            // </div>
                                                                            !modoCorreccion &&
                                                                            <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                                                {/* <div className='col-md-3' align='center'> */}
                                                                                <button className='botonAgregarAnexo col-md-2' onClick={e =>
                                                                                    handleAddMarcasProductoConMezcal()}>Agregar marca</button>
                                                                                {marcasProductoConMezcal.length === 0 ? (<span className='text-danger text-center'>Campo obligatorio</span>) : ''}
                                                                                {/* </div> */}
                                                                            </div>
                                                                        }


                                                                    </div>
                                                                }


                                                            </div>
                                                        ) :
                                                        (
                                                            <div className='container'>
                                                                <div className='row'>
                                                                    {
                                                                        modoCorreccion &&
                                                                        <div className='text-center'>
                                                                            {
                                                                                (observacionesApartados.countObservacionesDocumentacion !== 0 || (values.comprobantepago !== undefined && values.comprobantepago)) ?
                                                                                    <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                                    :
                                                                                    <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {/* <div className='row justify-content-md-center mb-2 text-center'>
                                                                <br />
                                                                <h3 className='text-center labelNaranjaCorto'>Documentación general</h3>
                                                            </div> */}
                                                                    {
                                                                        modoCorreccion &&
                                                                        <div className={`${estilos.componenteDocFC_01} col-md-12`}>
                                                                            <DocumentacionFC_01Component></DocumentacionFC_01Component>
                                                                        </div>
                                                                    }
                                                                    {/* {
                                                                        (values.opcionTipoEmpresa === 'fisica' && modoCorreccion) ? (
                                                                            <Fragment>
                                                                                {documentacionGeneralFisica(values)}
                                                                                {viveristaProductorFisicaFiles()}
                                                                                {comercializadorFisicaFiles()}
                                                                                {instalacionesFiles()}
                                                                                {ComprobanteFile(values)}

                                                                            </Fragment>
                                                                        ) : modoCorreccion &&
                                                                        ( 
                                                                            <Fragment>
                                                                                {documentacionGeneralMoral(values)}
                                                                                {viveristaProductorMoralFiles()}
                                                                                {comercializadorMoralFiles()}
                                                                                {instalacionesFiles()}
                                                                                {ComprobanteFile(values)}
                                                                            </Fragment>
                                                                        )

                                                                    } */}

                                                                </div>
                                                                <br />
                                                                {comercializadormezcal &&
                                                                    <Fragment>
                                                                        <div className={`col-md-11 mb-3 labelNaranja ms-5`}>¿Desea solicitar una contraseña oficial NOM?
                                                                            <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                                            <input className={`ms-2 form-check-input ${modoCorreccion && 'inputValidado'}`}
                                                                                type="checkbox" onChange={e => setGenerarpasswordnomsiNo(e.target)}
                                                                                checked={passwordnomsi} id="si" disabled/>
                                                                            <label className="ms-5 texto-blanco ">No</label>
                                                                            <input className={`ms-2 form-check-input ${modoCorreccion && 'inputValidado'}`}
                                                                                type="checkbox" onChange={e => setGenerarpasswordnomsiNo(e.target)}
                                                                                checked={passwordnomno} id="no" disabled/>
                                                                        </div>
                                                                    </Fragment>
                                                                }
                                                                <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_01'} />
                                                                {
                                                                    <div className="row mt-5 text-center">
                                                                        {
                                                                            modoEdicionBorrador ? (
                                                                                <div className="text-center">
                                                                                    <button type="submit" onClick={() => { botonEnviarSolicitudFC_01Borrador(submitForm), setFunctionSubmitForm({ function: submitForm }) }}
                                                                                        className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                                        disabled={!terminosYCondiciones}>Finalizar Borrador</button>
                                                                                </div>
                                                                            ) : modoCorreccion ?

                                                                                (
                                                                                    <div className="text-center">
                                                                                        <button type="button" onClick={() => { botonEnviarCorreccionesFC_01(submitForm), setFunctionSubmitForm({ function: submitForm }) }}
                                                                                            className={`btn ${estilos.botonNaranjaRedondoCorrecciones}`}
                                                                                            disabled={!terminosYCondiciones}>Enviar correcciones</button>
                                                                                    </div>
                                                                                ) :
                                                                                (
                                                                                    <div className="text-center">
                                                                                        <button type="submit" onChange={handleChange} onClick={() => { botonEnviarSolicitudFC_01(submitForm), setFunctionSubmitForm({ function: submitForm }) }}
                                                                                            className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                                            disabled={!terminosYCondiciones}>Finalizar Formulario</button>
                                                                                    </div>
                                                                                )
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                        )
                                }
                                <br></br>

                                <br />
                                {modalComponent()}
                            </div>
                        </div>
                        {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folioSolicitud}></ModalEnviadoCorrectamente>}
                        {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                        <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                    </form>
                )}
            </Formik>
        </Fragment >
    )

}

export default withRouter(FormularioFC01BeneficiarioComponent)
